import React from 'react';
// import { Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
// import { RetryLink } from "apollo-link-retry";
// import {Redirect} from 'react-router-dom';
// import gpl from 'graphql-tag';
import _ from 'lodash';
// import JsBarcode from 'jsbarcode';

import ImprRC from '../components/funcionales/imprrc'
import ImprFact from '../components/funcionales/imprfact'
import ImprPS from '../components/funcionales/imprps'
import ImprContr from '../components/funcionales/imprcontr'

import mainNC from './home/functions/notas/mainnc';

import imprFactEC from '../components/funcionales/imprfactec'

// import jsPDF from 'jspdf';
// import 'jspdf-autotable';

// import './respond';

//utils
import queries from '../../src/utils/queries'

import codBarras from '../../src/functions/codbarras'

//components
import HomeCli1 from './home/homecli1';
import HomeCli2 from './home/homecli2';
import AddCli1 from './home/addcli1';
import AddCli2 from './home/addcli2';
import VerCli1 from './home/vercli1';
import VerCli2 from './home/vercli2';

import HomeTicl1 from './home/hometicl1';
import HomeTicl2 from './home/hometicl2';
import AddTicl1 from './home/addticl1';
import AddTicl2 from './home/addticl2';
import VerTicl1 from './home/verticl1';
import VerTicl2 from './home/verticl2';

import HomeGraf1 from './home/homegraf1';
import HomeGraf2 from './home/homegraf2';
import AddGraf1 from './home/addgraf1';
import AddGraf2 from './home/addgraf2';
import VerGraf1 from './home/vergraf1';
import VerGraf2 from './home/vergraf2';

import HomeTido1 from './home/hometido1';
import HomeTido2 from './home/hometido2';
import AddTido1 from './home/addtido1';
import AddTido2 from './home/addtido2';
import VerTido1 from './home/vertido1';
import VerTido2 from './home/vertido2';

import HomeCifa1 from './home/homecifa1';
import HomeCifa2 from './home/homecifa2';
import AddCifa1 from './home/addcifa1';
import AddCifa2 from './home/addcifa2';
import VerCifa1 from './home/vercifa1';
import VerCifa2 from './home/vercifa2';

import HomeOtpa1 from './home/homeotpa1';
import HomeOtpa2 from './home/homeotpa2';
import AddOtpa1 from './home/addotpa1';
import AddOtpa2 from './home/addotpa2';
import VerOtpa1 from './home/verotpa1';
import VerOtpa2 from './home/verotpa2';

import HomeOfic1 from './home/homeofic1';
import HomeOfic2 from './home/homeofic2';
import AddOfic1 from './home/addofic1';
import AddOfic2 from './home/addofic2';
import VerOfic1 from './home/verofic1';
import VerOfic2 from './home/verofic2';

import HomeSeg1 from './home/homeseg1';
import HomeSeg2 from './home/homeseg2';
import AddSeg1 from './home/addseg1';
import AddSeg2 from './home/addseg2';
import VerSeg1 from './home/verseg1';
import VerSeg2 from './home/verseg2';

import HomePaq1 from './home/homepaq1';
import HomePaq2 from './home/homepaq2';
import AddPaq1 from './home/addpaq1';
import AddPaq2 from './home/addpaq2';
import VerPaq1 from './home/verpaq1';
import VerPaq2 from './home/verpaq2';

import HomeTiaj1 from './home/hometiaj1';
import HomeTiaj2 from './home/hometiaj2';
import AddTiaj1 from './home/addtiaj1';
import AddTiaj2 from './home/addtiaj2';
import VerTiaj1 from './home/vertiaj1';
import VerTiaj2 from './home/vertiaj2';

// import HomeUsu1 from './home/homeusu1';
// import HomeUsu2 from './home/homeusu2';
// import AddUsu1 from './home/addusu1';
// import AddUsu2 from './home/addusu2';
// import VerUsu1 from './home/verusu1';
// import VerUsu2 from './home/verusu2';

import HomeFact from './home/fact/homefact';
import HomeProc from './home/proc/homeproc';
import HomeRtes from './home/rtes/homertes';
import HomeUser from './home/user/homeuser';
import HomeDir from './home/homedir';
import HomeOdeS from './home/odes/homeodes';
import HomeConf from './home/homeconf';
import HomeMigrar from './home/homemigrar';

import RecPagoAdel1 from './home/recpago/recpagoad1';
import RecPagoAdel2 from './home/recpago/recpagoad2';

import RecPago1 from './home/recpago/recpago1';
import RecPago2 from './home/recpago/recpago2';

import RecPagoOtr1 from './home/recpago/recpagootr1';
import RecPagoOtr2 from './home/recpago/recpagootr2';

// import RecPagoTer1 from './home/recpago/recpagoter1';
// import RecPagoTer2 from './home/recpago/recpagoter2';

// import Estilos from '../css/main.css';
import '../css/marquee.css';

//maneja los reintentos por errores de red => proporciona un retroceso exponencial
//y el jitter demora entre los intentos por defecto
//como se maneja ?
// const link = new RetryLink({
//   delay: {
//     initial: 300,
//     max: Infinity,
//     jitter: true
//   },
//   attempts: {
//     max: 5,
//     retryIf: (error, _operation) => !!error
//   }
// });

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

const styles ={
  modal:{
    width: '40%',
    top: '40%',
    left: '30%',
    position: 'fixed',
    color: 'blue'
  },
  bordes:{
    margin: '1em 0em 0.1em 0em',
    padding: '0em 0em 0em 0em',
  },
  menuPpal:{
    width: '25%',
    padding: '0.4em 0.2em 0em 2em',
  },
  boxIzq:{
    width: '25%',
    padding: '0.1em 0.2em 0em 1.2em',
  },
  boxDer:{
    width: '75%',
    padding: '0.1em 1.2em 0em 0.2em',
  },
  boxUnaCol:{
    width: '100%',
    padding: '1em 1em 2em 1em',
  },
  botones:{
    // background: 'linear-gradient(#093028, #237A57)',
    background: '#0B486B',
    margin: '0px 0px 0px 10px',
  },
  menu:{
    background: 'linear-gradient(#0F2027, #2C5364)',
    // background: 'linear-gradient(#FF0000, #dd1818)',
    // background: 'linear-gradient(#355C7D, #6C5B7B)',
  },
  divider:{
    margin: '10px 10px 10px 10px',
  },
  rowMarquee:{
    background: 'linear-gradient(#141E30, #243B55)',
    // background: '#0B486B',
    border: 'px solid blue',
    margin: '0px',
    padding: '2px 0 0 0',
    color: "white",
  },
  titBuscar:{
    // background: 'linear-gradient(#000000, #283c86)',
    background: 'linear-gradient(#272323, #283c86)',
    // background: 'linear-gradient(#355C7D, #6C5B7B)',
    height: '3em',
    color: 'white',
  },
  titBuscarTot:{
    fontSize: 16
  },
  etiqClientes:{
    padding: '12px 40px 12px 12px',
    color: "white",
  },
  dropdown:{
    // background: 'linear-gradient(#0F2027, #2C5364)',
    background: 'linear-gradient(#1C333D, #3C677A)',
    // background: 'linear-gradient(#141E30, #243B55)',
    // background: 'linear-gradient(#11998e, #38ef7d)',
    color: 'white',
    textAlign: 'left',
    width: '100%',
    fontWeight: 'normal',
    // font: '18pt sans-serif',
    // font: '46px Calibri',
    // fontWeight: 'Bold',
    // fontStyle: 'Italic'
  },
  listaDer:{
    background: 'linear-gradient(#1CB5E0, #000046)',
    margin: '0px',
    padding: '0px',
    height: '3em',
  },
  detCliente:{
    // background: 'linear-gradient(#1CB5E0, #000046)',
    background: 'linear-gradient(#1CB5E0, #000046)',
    margin: '0px',
    padding: '0px',
    height: '9em',
  },
  detalle:{
    margin: '0px',
    padding: '0px',
  },
  titClientes:{
    background: 'linear-gradient(#355C7D, #6C5B7B)',
    height: 'em',
  },
  box:{
    background: 'linear-gradient(#2a5298, #141E30)', border: '1px solid #2a5298',
    // bueno => background: '#243B55', border: '1px solid #141E30',
    // background: '#948E99', border: '1px solid #2E1437',
    // background: '#606c88',
    // background: 'white', border: '1px solid #e6e6e6',
    marginBottom: '1em',
    padding: '1em'
  },
  boxGrid:{
    width: '50%'
  },
  elemLis_1:{
    color: 'white',
    fontWeight: 'bold',
  },
  elemLis_2:{
    color: '#000000',
    // color: '#2C7744',
    fontWeight: 'bold',
  },
  elemLis_3:{
    color: '#93291E',
    fontWeight: 'bold',
  },
  subElemLis_1:{
    color: '#DCE35B',
    fontWeight: 'bold',
  },
  botIcon:{
    height: '1em',
    width: '1em',
  },
  chekBox:{
    padding: '0em 2em 0em 0em',
    // width: '1em',
  },
  label:{
    color: '#FFE000',
  },
  input:{
    background: 'linear-gradient(white, #999966 )',
    border: '0px',
    color: '#89253e',
  },
  confirmar:{
    background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
    border: '0px',
    color: '#135058',
    fontWeight: 'bold',
  },
  styBtn:{
    margin: '0.4em',
    padding: '0.6em',
    background: 'linear-gradient(#1CB5E0, #000046)',
    color: 'yellow',
  },
  styTableSup:{
    margin: '0.2em',
    background: 'linear-gradient(#000046, #1CB5E0)',
    color: 'black',
  },
  styTableInf:{
    margin: '0.1em',
    background: 'linear-gradient(#1CB5E0, #000046)',
    color: 'yellow',
  },
  styTableSel:{
    background: 'linear-gradient(#093189, #1CB5E0, #093189)',
  },
  backGr_1:{
    // background: 'linear-gradient(#6dd5ed, #2193b0)',
    background: 'linear-gradient(#E9E4F0, #D3CCE3)',

  },
  backGr_2:{
    background: 'linear-gradient(#2193b0, #6dd5ed)',

  },
  styPaddMarg:{
    padding: '0.2em 0.1em 0.2em 0.1em',
    fontSize: '0.9em'
  },
  styInput:{
    width: '8em',
  },
  paraH1:{
    padding: '0em',
    margin: '0em',
    color: '#302b63',
  },
  paraH2_01:{
    padding: '0em',
    margin: '0em',
    color: '#2C7744',
  },
  paraH2_02:{
      padding: '0em',
      margin: '0em',
      color: 'red',
  },
}

//NUMERO A LETRAS
// function unidadesNum(num){
//   switch(num){
//     case 1: return "UN";
//     case 2: return "DOS";
//     case 3: return "TRES";
//     case 4: return "CUATRO";
//     case 5: return "CINCO";
//     case 6: return "SEIS";
//     case 7: return "SIETE";
//     case 8: return "OCHO";
//     case 9: return "NUEVE";
//     default: return "";
//   }
//   //ojo se comento por sugerencia de react
//   // return "";
// }//unidadesNum()

// function decenasNum(num){
//   let decena = Math.floor(num/10);
//   let unidad = num - (decena * 10);

//   switch(decena){
//       case 1:
//           switch(unidad){
//               case 0: return "DIEZ";
//               case 1: return "ONCE";
//               case 2: return "DOCE";
//               case 3: return "TRECE";
//               case 4: return "CATORCE";
//               case 5: return "QUINCE";
//               default: return "DIECI" + unidadesNum(unidad);
//           }
//       case 2:
//           switch(unidad)
//           {
//               case 0: return "VEINTE";
//               default: return "VEINTI" + unidadesNum(unidad);
//           }
//       case 3: return decenasYNum("TREINTA", unidad);
//       case 4: return decenasYNum("CUARENTA", unidad);
//       case 5: return decenasYNum("CINCUENTA", unidad);
//       case 6: return decenasYNum("SESENTA", unidad);
//       case 7: return decenasYNum("SETENTA", unidad);
//       case 8: return decenasYNum("OCHENTA", unidad);
//       case 9: return decenasYNum("NOVENTA", unidad);
//       case 0: return unidadesNum(unidad);
//       default: return "";
//   }
// }//unidadesNum()

// function decenasYNum(strSin, numUnidades) {
//   if (numUnidades > 0)
//   return strSin + " Y " + unidadesNum(numUnidades)

//   return strSin;
// }//decenasYNum()

// function centenasNum(num) {
//   let centenas = Math.floor(num / 100);
//   let decenas = num - (centenas * 100);

//   switch(centenas)
//   {
//       case 1:
//           if (decenas > 0)
//               return "CIENTO " + decenasNum(decenas);
//           return "CIEN";
//       case 2: return "DOSCIENTOS " + decenasNum(decenas);
//       case 3: return "TRESCIENTOS " + decenasNum(decenas);
//       case 4: return "CUATROCIENTOS " + decenasNum(decenas);
//       case 5: return "QUINIENTOS " + decenasNum(decenas);
//       case 6: return "SEISCIENTOS " + decenasNum(decenas);
//       case 7: return "SETECIENTOS " + decenasNum(decenas);
//       case 8: return "OCHOCIENTOS " + decenasNum(decenas);
//       case 9: return "NOVECIENTOS " + decenasNum(decenas);
//       default: return "";
//   }
// //ojo se comento por sugerencia de react
//   // return decenasNum(decenas);
// }//centenasNum()

// function seccionNum(num, divisor, strSingular, strPlural) {
//   let cientos = Math.floor(num / divisor)
//   let resto = num - (cientos * divisor)

//   let letras = "";

//   if (cientos > 0)
//       if (cientos > 1)
//           letras = centenasNum(cientos) + " " + strPlural;
//       else
//           letras = strSingular;

//   if (resto > 0)
//       letras += "";

//   return letras;
// }//seccionNum()

// function milesNum(num) {
//   let divisor = 1000;
//   let cientos = Math.floor(num / divisor)
//   let resto = num - (cientos * divisor)

//   let strMiles = seccionNum(num, divisor, "UN MIL", "MIL");
//   let strCentenas = centenasNum(resto);

//   if(strMiles === "")
//       return strCentenas;

//   return strMiles + " " + strCentenas;
// }//milesNum()

// function millonesNum(num) {
//   let divisor = 1000000;
//   let cientos = Math.floor(num / divisor)
//   let resto = num - (cientos * divisor)

//   let strMillones = seccionNum(num, divisor, "UN MILLON DE", "MILLONES DE");
//   let strMiles = milesNum(resto);

//   if(strMillones === "")
//       return strMiles;

//   return strMillones + " " + strMiles;
// }//millonesNum()

// function numeroALetras(num) {
//   var data = {
//       numero: num,
//       enteros: Math.floor(num),
//       centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
//       letrasCentavos: "",
//       letrasMonedaPlural: 'PESOS',//"PESOS", 'Dólares', 'Bolívares', 'etcs'
//       letrasMonedaSingular: 'PESO', //"PESO", 'Dólar', 'Bolivar', 'etc'

//       letrasMonedaCentavoPlural: "CENTAVOS",
//       letrasMonedaCentavoSingular: "CENTAVO"
//   };

//   if (data.centavos > 0) {
//       data.letrasCentavos = "CON " + (function (){
//           if (data.centavos === 1)
//               return millonesNum(data.centavos) + " " + data.letrasMonedaCentavoSingular;
//           else
//               return millonesNum(data.centavos) + " " + data.letrasMonedaCentavoPlural;
//           })();
//   };

//   if(data.enteros === 0)
//       return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
//   if (data.enteros == 1)
//       return millonesNum(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
//   else
//       return millonesNum(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
// }
//numeroALetras()
//FIN NUMERO A LETRAS

// const argsBuscar = {numDocum: 50}
// const argsBuscarMC = {contrato: "contrato"}

// const argsBuscar = {nombreCliente: 'WILSON', numDocum: 25}
// const argsBuscar = {}
// const argsBuscar = {"servicios.subclaseserv.claseserv.codigoClaseServ": "2"}

let argsBuscarClient = {numDocum: 50}
if(sessionStorage.getItem('Ciudad')!=="Todas..."){
  argsBuscarClient.nombreCiudad = sessionStorage.getItem('Ciudad')
}
if(sessionStorage.getItem('Dpto')!=="Todos..."){
  argsBuscarClient.descrDpto = sessionStorage.getItem('Dpto')
}

class Home extends React.Component{
  state={
    showClient: true, addCliente: false, verCliente: false,

    showUser: false,

    showTipocli: false, addTipocli: false, verTipocli: false,
    showGrupoaf: false, addGrupoaf: false, verGrupoaf: false,
    showTipodoc: false, addTipodoc: false, verTipodoc: false,
    showCicloFact: false, addCicloFact: false, verCicloFact: false,
    showOtrosPagCl: false, addOtrosPagCl: false, verOtrosPagCl: false,
    showOficina: false, addOficina: false, verOficina: false,
    showSegmento: false, addSegmento: false, verSegmento: false,
    showPaquete: false, addPaquete: false, verPaquete: false,

    showTipoAju: false, addTipoAju: false, verTipoAju: false,

    showDirecc: false, showFact: false, showProc: false, showRtes: false, showConfig: false,
    showMigrar: false, showOdeS: false, opcionOdeS: "ModOdeS", showRecPago: false,
    stImprRC: false, stImprFact: false,
    numeroRC: 0, numeroFra: 0,
    listaR: [], listFact: [], listServTar: [],
    nombreUA: "",
    saldoCl: 0,
    totRecibido: 0,
    showRecPagoOtr: false,
    showRecPagoAdel: false,

    // showRecPagoTer: false,

    permiteHistFinanc: false,
    permiteHistPago: false,
    permiteProgNvoServ: false,
    permiteHistFact: false,
    permiteHistCE: false,
    permiteHistNot: false,
    permiteHistAj: false,
    permiteNCPF: false,
    permiteNDF: false,
    permiteNCF: false,
    permiteNCA: false,
    permiteAjP: false,
    permiteAjN: false,
    permiteMNF: false,
    permiteUpdate: false,
    permiteUpdateDir: false,
    permiteDelete: false,

    argsAdd: {},
    errorAdd: [],
    argsBuscCliente: {},
    argsBuscCliOS: {},
    
    idLista: {},
    anuloPago: false
  }

  logout = () => {
    // console.log(sessionStorage.getItem('userLogin'))
    // console.log(sessionStorage.getItem('token'))
    // console.log(sessionStorage.getItem('token1'))

    sessionStorage.removeItem('token');
    sessionStorage.removeItem('token1');
    sessionStorage.removeItem('token2');
    sessionStorage.removeItem('Ciudad');
    sessionStorage.removeItem('Dpto');
    sessionStorage.removeItem('userLogin');

    console.log("se salioooooo")
    this.props.history.push("/")
    // return <Redirect to="/" />
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg,
    campo7, campo7Val, campo7Sel, campo7Msg,
    campo8, campo8Val, campo8Sel, campo8Msg,
    campo9, campo9Val, campo9Sel, campo9Msg,
    campo10, campo10Val, campo10Sel, campo10Msg,
    campo11, campo11Val, campo11Sel, campo11Msg,
    )=>{
// console.log(campo1, campo1Val, campo1Sel, campo1Msg,
//   campo2, campo2Val, campo2Sel, campo2Msg,
//   campo3, campo3Val, campo3Sel, campo3Msg,
//   campo4, campo4Val, campo4Sel, campo4Msg,
//   campo5, campo5Val, campo5Sel, campo5Msg,
//   campo6, campo6Val, campo6Sel, campo6Msg,
//   campo7, campo7Val, campo7Sel, campo7Msg,
//   campo8, campo8Val, campo8Sel, campo8Msg,
//   campo9, campo9Val, campo9Sel, campo9Msg,
//   campo10, campo10Val, campo10Sel, campo10Msg,
//   campo11, campo11Val, campo11Sel, campo11Msg)
    const argsAdd = this.state.argsAdd
    const errors = [];
    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    if(campo7!=='XXX' && (!campo7 || campo7===campo7Sel)){
      argsAdd[campo7Val] = campo7Sel;
      errors.push({path: campo7Val, message: campo7Msg});
    }
    if(campo8!=='XXX' && (!campo8 || campo8===campo8Sel)){
      argsAdd[campo8Val] = campo8Sel;
      errors.push({path: campo8Val, message: campo8Msg});
    }
    if(campo9!=='XXX' && (!campo9 || campo9===campo9Sel)){
      argsAdd[campo9Val] = campo9Sel;
      errors.push({path: campo9Val, message: campo9Msg});
    }
    if(campo10!=='XXX' && (!campo10 || campo10===campo10Sel)){
      argsAdd[campo10Val] = campo10Sel;
      errors.push({path: campo10Val, message: campo10Msg});
    }
    if(campo11!=='XXX' && (!campo11 || campo11===campo11Sel)){
      argsAdd[campo11Val] = campo11Sel;
      errors.push({path: campo11Val, message: campo11Msg});
    }

    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  nextValFra = async (name) => {
    const argsUpd = {
      _id: name,
    }
    const response = await this.props.editSeqFrafindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqFrafindOneAndUpdate.proxFact
  }
  
//ACTUALIZAR BD
crudBD = async (operacionCRUD, args, i)=>{
  // console.log("CRUD")
      if(args.ctrlCampo === 'CRUD'){
// console.log(i)
// console.log(args)
        const {data} = await operacionCRUD({
          variables: args
        });
  
  //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          // console.log("MANY")
          // console.log(args)
          await operacionCRUD({
            variables: args
          });
        }
      }
    }

    // crudBD = async (operacionCRUD, args, i)=>{
// console.log("CRUD")
//       if(args.ctrlCampo === 'CRUD'){
// console.log(i)
//         const {data} = await operacionCRUD({
//           variables: args
//         });
  
// //Se utiliza para traer el _id del documento creado
//         if(args.ctrl_id === 'SI_ID'){
//           if(Object.values(data)[0]._id){
//             return Object.values(data)[0]._id
//           }else{
//             return 0
//           }
//         }
//       }
//     }

updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await this.crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }

//     updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
//   //ENVIO PARA ACTUALIZAR BD
//       let codigo = 0
//       if(argsCrud[0].ctrl_id === 'SI_ID'){
//         codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
//       }else{
//         await this.crudBD(crudColecc[0], argsCrud[0], 0)
//       }
//       if(codigo!==0){
//         for(let i=1; i<totDocCRUD; i++){
//           argsCrud[i]._id = codigo
//         }
//       }
//       console.log("inicio")
//       for(let i=1; i<totDocCRUD; i++){
//         await this.crudBD(crudColecc[i], argsCrud[i], i)
//       }
// console.log("final")
//     }

  showClient = (ev) => {
    ev.preventDefault()
    this.props.allClientes.refetch()
    this.estadosFalse()
    this.setState({showClient: true})
    // console.log(this.state)
    // console.log("showclient")
  }

  showDirecc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showDirecc: true})
  }

  showOdeS = async (ev, opcion) => {
    // ev.preventDefault()

    let argsBuscarMC={}
    argsBuscarMC.orden='-_id'
    if(this.state.argsBuscCliOS.contrato){
      argsBuscarMC.contrato=this.state.argsBuscCliOS.contrato
    }else{
      argsBuscarMC.contrato=null
    }

    await this.props.allMovClientes.refetch(argsBuscarMC)
    await this.props.allMovClientesCC.refetch(argsBuscarMC)

    this.estadosFalse()
    this.setState({showOdeS: true, opcionOdeS: opcion})
  }

  // showRecPagoTer = async (ev) => {
  //   ev.preventDefault()
  //   this.estadosFalse()
  //   this.setState({showRecPagoTer: true})
  // }

  showRecPago = async (ev) => {
    ev.preventDefault()

    let argsBuscarMC={}
    argsBuscarMC.orden='+_id'
    if(this.state.argsBuscCliOS.contrato){
      argsBuscarMC.contrato=this.state.argsBuscCliOS.contrato
    }else{
      argsBuscarMC.contrato=null
    }

    let aleatorio1 = parseInt(Math.random() * (9999999 - 1000000) + 1000000, 10)
    sessionStorage.setItem("aleatorio1", aleatorio1);

    await this.props.allMovClientes.refetch(argsBuscarMC)
    await this.props.allMovClientesCC.refetch(argsBuscarMC)

    this.estadosFalse()
    this.setState({showRecPago: true})
  }

  showRecPagoOtr = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showRecPagoOtr: true})
  }
  
  showRecPagoAdel = async (ev) => {
    ev.preventDefault()

    this.estadosFalse()
    this.setState({showRecPagoAdel: true})
  }

  showTipocli = (ev) => {
    ev.preventDefault()
    this.props.allTiposCliente.refetch()
    this.estadosFalse()
    this.setState({showTipocli: true})
  }

  showGrupoaf = (ev) => {
    ev.preventDefault()
    this.props.allGruposAfin.refetch()
    this.estadosFalse()
    this.setState({showGrupoaf: true})
  }

  showTipodoc = (ev) => {
    ev.preventDefault()
    this.props.allTiposDoc.refetch()
    this.estadosFalse()
    this.setState({showTipodoc: true})
  }

  showCicloFact = (ev) => {
    ev.preventDefault()
    this.props.allCicloFact.refetch()
    this.estadosFalse()
    this.setState({showCicloFact: true})
  }

  showOtrosPagCl = (ev) => {
    ev.preventDefault()
    this.props.allOtrosPagCl.refetch()
    this.estadosFalse()
    this.setState({showOtrosPagCl: true})
  }

  showOficina = (ev) => {
    ev.preventDefault()
    this.props.allOficina.refetch()
    this.estadosFalse()
    this.setState({showOficina: true})
  }

  showSegmento = (ev) => {
    ev.preventDefault()
    this.props.allSegmento.refetch()
    this.estadosFalse()
    this.setState({showSegmento: true})
  }

  showPaquete = (ev) => {
    ev.preventDefault()
    this.props.allPaquete.refetch()
    this.estadosFalse()
    this.setState({showPaquete: true})
  }

  showTipoAju = (ev) => {
    ev.preventDefault()
    this.props.allTipoAju.refetch()
    this.estadosFalse()
    this.setState({showTipoAju: true})
  }

  showUser = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showUser: true})
  }

  showFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showFact: true})
  }

  showProc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showProc: true})
  }

  showRtes = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showRtes: true})
  }

  showConfig = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showConfig: true})
  }

  showMigrar = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showMigrar: true})
  }

  addCliente = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCliente: true})
  }

  addTipocli = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipocli: true})
  }

  addGrupoaf = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addGrupoaf: true})
  }

  addTipodoc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipodoc: true})
  }

  addCicloFact = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCicloFact: true})
  }

  addOtrosPagCl = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addOtrosPagCl: true})
  }

  addOficina = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addOficina: true})
  }

  addSegmento = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addSegmento: true})
  }

  addPaquete = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPaquete: true})
  }

  addTipoAju = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipoAju: true})
  }

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd
    // console.log(argsAdd)
    // console.log(ev.target.value)
    // console.log(ev.target.name)
    let datoTipo = ""
    if(input!==undefined&&ev.target.name===undefined){
      datoTipo = input.type
    }
    if(!argsAdd.codigoSegmento&&this.props.allSegmento.allSegmento.length===1){
      argsAdd['codigoSegmento'] =  this.props.allSegmento.allSegmento[0].codigoSegmento
      argsAdd['descrSegmento'] = this.props.allSegmento.allSegmento[0].descrSegmento
    }

    if(datoTipo==='checkbox'){
      if (this.state.addCliente) {
        argsAdd[input.name] = input.label
      }else{
        argsAdd[input.name] = input.checked
      }
    }else{
      if(ev.target.type==='checkbox'){
        argsAdd[ev.target.name] = ev.target.checked
      }else{
        if (this.state.addCliente && !argsAdd['sexoCliente']) {
          argsAdd['sexoCliente'] = 'Masculino'
        }
        argsAdd[ev.target.name] = ev.target.value
      }
    }
    this.setState({argsAdd});
    // console.log(argsAdd)
  }
  
  handleChangeBuscClient = (ev)=>{
    const argsBuscCliente = this.state.argsBuscCliente
    if(ev.target.name === "numDocum"){
      var numDocum = document.getElementById("numDocum");
      if(ev.target.value<=0){
        numDocum.value = ""
        argsBuscCliente[ev.target.name] = ""
      }else{
        argsBuscCliente[ev.target.name] = ev.target.value
      }
    }else{
      if(ev.target.name === "nombreCiudad"){
        if(sessionStorage.getItem('Ciudad')==="Todas..."){
          argsBuscCliente[ev.target.name] = ev.target.value
        }else{
          argsBuscCliente[ev.target.name] = sessionStorage.getItem('Ciudad')
        }
      }else{
        if(ev.target.name === "descrDpto"){
          if(sessionStorage.getItem('Dpto')==="Todos..."){
            argsBuscCliente[ev.target.name] = ev.target.value
          }else{
            argsBuscCliente[ev.target.name] = sessionStorage.getItem('Dpto')
          }
        }else{
          argsBuscCliente[ev.target.name] = ev.target.value
        }
      }
    }
    this.setState({argsBuscCliente});
  }

  handleBuscCliente = async (ev, args) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showClient: true})
// console.log(args)
    let argsBuscar={}


    // argsBuscar.descrTipoVia1="C"
    // argsBuscar.numeroTipoVia1="3A"
    // argsBuscar.descrTipoVia2="N"
    // argsBuscar.numeroTipoVia2="15A"
    // argsBuscar.numeroTipoVia2F="15"
    // argsBuscar.mac="376"

    if(args.numDocum){
      argsBuscar.numDocum=parseInt(args.numDocum, 10)
    }else{
      argsBuscar.numDocum=50
    }
    if(args.contrato){
      argsBuscar.contrato=args.contrato
    }else{
      argsBuscar.contrato=null
    }
    if(args.nombreCliente){
      argsBuscar.nombreCliente=args.nombreCliente
    }else{
      argsBuscar.nombreCliente=null
    }
    if(args.apellidoCliente){
      argsBuscar.apellidoCliente=args.apellidoCliente
    }else{
      argsBuscar.apellidoCliente=null
    }
    if(args.descrClaseServ){
      argsBuscar.descrClaseServ=args.descrClaseServ
    }else{
      argsBuscar.descrClaseServ=null
    }
    if(args.descrSubclaseServ){
      argsBuscar.descrSubclaseServ=args.descrSubclaseServ
    }else{
      argsBuscar.descrSubclaseServ=null
    }

    if(args.descrDpto){
      argsBuscar.descrDpto=args.descrDpto
    }else{
      argsBuscar.descrDpto=null
    }
    if(args.nombreCiudad){
      argsBuscar.nombreCiudad=args.nombreCiudad
    }else{
      argsBuscar.nombreCiudad=null
    }
    if(args.nombreZona){
      argsBuscar.nombreZona=args.nombreZona
    }else{
      argsBuscar.nombreZona=null
    }
    if(args.nombreBarrio){
      argsBuscar.nombreBarrio=args.nombreBarrio
    }else{
      argsBuscar.nombreBarrio=null
    }

    if(args.descrTipoVia1){
      argsBuscar.descrTipoVia1=args.descrTipoVia1
    }else{
      argsBuscar.descrTipoVia1=null
    }
    if(args.numeroTipoVia1){
      argsBuscar.numeroTipoVia1=args.numeroTipoVia1
    }else{
      argsBuscar.numeroTipoVia1=null
    }
    if(args.descrTipoVia2){
      argsBuscar.descrTipoVia2=args.descrTipoVia2
    }else{
      argsBuscar.descrTipoVia2=null
    }
    if(args.numeroTipoVia2){
      argsBuscar.numeroTipoVia2=args.numeroTipoVia2
    }else{
      argsBuscar.numeroTipoVia2=null
    }
    if(args.numeroTipoVia2F){
      argsBuscar.numeroTipoVia2F=args.numeroTipoVia2F
    }else{
      argsBuscar.numeroTipoVia2F=null
    }

    if(args.mac){
      argsBuscar.mac=args.mac
    }else{
      argsBuscar.mac=null
    }
    if(args.codigoMarquilla){
      argsBuscar.codigoMarquilla=args.codigoMarquilla
    }else{
      argsBuscar.codigoMarquilla=null
    }

    if(args.estadoCliente){
      argsBuscar.estadoCliente=args.estadoCliente
    }else{
      argsBuscar.estadoCliente=null
    }
    if(args.descrEstrato){
      argsBuscar.descrEstrato=args.descrEstrato
    }else{
      argsBuscar.descrEstrato=null
    }
    if(args.telefono){
      argsBuscar.telefono=args.telefono
    }else{
      argsBuscar.telefono=null
    }
    if(args.numeroDoc){
      argsBuscar.numeroDoc=args.numeroDoc
    }else{
      argsBuscar.numeroDoc=null
    }
    if(args.descrTipoCliente){
      argsBuscar.descrTipoCliente=args.descrTipoCliente
    }else{
      argsBuscar.descrTipoCliente=null
    }
    if(args.descrGrupoAfin){
      argsBuscar.descrGrupoAfin=args.descrGrupoAfin
    }else{
      argsBuscar.descrGrupoAfin=null
    }
    if(args.descrRecursoR){
      argsBuscar.descrRecursoR=args.descrRecursoR
    }else{
      argsBuscar.descrRecursoR=null
    }
    if(args.diasMora){
      argsBuscar.diasMoraIni=args.diasMora
    }else{
      argsBuscar.diasMoraIni=null
    }
    if(args.diasMora){
      argsBuscar.diasMoraFin=args.diasMora
    }else{
      argsBuscar.diasMoraFin=null
    }
    // console.log(argsBuscar)
    await this.props.allClientes.refetch(argsBuscar)

//VALIDAR SI MODIFICARON EL sessionStorage userLogin o Ciudad
    const argsEncr = {
      valor: sessionStorage.getItem('userLogin'),
      comparar: sessionStorage.getItem('token1')
    }
    const response = await this.props.encriptar({
      variables: argsEncr
    });
    const {success} = response.data.encriptar;
    let enapp = success
    if(enapp){
      const argsEncr = {
        valor: sessionStorage.getItem('Ciudad'),
        comparar: sessionStorage.getItem('token2')
      }
      const response = await this.props.encriptar({
        variables: argsEncr
      });
      const {success} = response.data.encriptar;
      enapp = success  
    }
    if (!enapp){
//MODIFICARON EL sessionStorage userLogin o Ciudad
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('token1');
      sessionStorage.removeItem('token2');
      sessionStorage.removeItem('Ciudad');
      sessionStorage.removeItem('Dpto');
      sessionStorage.removeItem('userLogin');
console.log("ojo")
      this.props.history.push("/")
    }
  }

  handleCliente = async (ev, args, comoAsigCicloFact, argsSelDpto, listServTar, listTOS, fechaV, argsDocum, modeloFactura, empresaArchFE, listaCateg)=>{
    // console.log(modeloFactura, empresaArchFE)
    // console.log(args)
    // console.log(argsDocum)
    // console.log(listServTar)
    // console.log(listaCateg)

    // // Ej para API (POST) para enviar contrato, procesarlo y recibir información
    // let servidor = 'http://192.168.1.3:3000/'
    // let usuario = {"contrato": "22108"}
    // console.log(usuario)
    // try {
    //   const response = await fetch(servidor + 'cliente', {
    //     method: 'POST',
    //     body: JSON.stringify(usuario),
    //     headers: {
    //       'content-type': "application/json",
    //       'contrato': "22108",
    //     },
    //   });
    //   const result = await response.json();
    //   console.log("Success:", result);
    // } catch (error) {
    //   // console.error(`Download error: ${error.message}`);
    //   console.error("Error:", error);
    // }
    // // FIN API (POST)

    // fetch(servidor + 'cliente', {
    //   method: 'POST',
    //   body: JSON.stringify(usuario),
    //   headers: {
    //     'content-type': "application/json",
    //     'contrato': "22108",
    //     'nombre': "Wilson martinez Gomez",
    //   },
    // })
    // .then(() => console.log("Información enviada"))
    // .catch(() => console.log("Información NO enviada"))

    let puedeCrearCli = true
    //PARA EVITAR QUE SE CREEN CLIENTES DUPLICADOS
    if(this.state.addCliente){
      let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
      let horaEntrada = new Date().getTime();
      let difHoraEntrada = 3000
      if(horaEntradaAnt){
        difHoraEntrada = horaEntrada - horaEntradaAnt
      }else{
        difHoraEntrada = 8000
      }
      if(difHoraEntrada>7000){
        sessionStorage.setItem("horaEntrada", horaEntrada);
      }else{
        puedeCrearCli = false
      }
    }
    //FIN PARA EVITAR QUE SE CREEN CLIENTES DUPLICADOS
// console.log(puedeCrearCli)
    const argsAdd = {}
    const errors = [];
    let hayError = false
    let sinCampo='XXX'
    let contratoSequence = this.props.getParametro.getParametro.contratoSequence
    let contratoCl =""
    if(!puedeCrearCli){
      contratoCl = "ABCXYZ123"
    }
    if(this.state.addCliente&&puedeCrearCli&&
        ((contratoSequence!=="SI"&&args.contrato)||(contratoSequence==="SI"))){
      for(let iii=0; iii<999999; iii++){
        let argsBuscarCL = ""
        if(contratoSequence==="SI"){
          if(!args.nombreCliente||!args.apellidoCliente||!args.numeroDoc||
              !args.descrEstrato||args.descrEstrato==="Seleccionar..."||
              !args.descrSegmento||args.descrSegmento==="Seleccionar..."||
              ((!args.cicloFact||args.cicloFact==="Seleccionar...")&&
              comoAsigCicloFact==="Asignarlo al crear o modificar clientes")||
              !args.descrTipoDoc||args.descrTipoDoc==="Seleccionar..."||
              !args.descrTipoCliente||args.descrTipoCliente==="Seleccionar..."||
              !args.descrGrupoAfin||args.descrGrupoAfin==="Seleccionar..."||
              !args.eMail||!args.telefono1
              ||((!args.infAdic1||args.infAdic1==="Seleccionar...")&&empresaArchFE==="conectic")
            ){
              contratoCl = "ABCXYZ123"
          }
          if(contratoCl!=="ABCXYZ123"){
            if((args.descrTipoOS&&args.descrTipoOS!=="Seleccionar...")){
              //Validar DIRECCION
              if((!args.observacAB&&!this.state.permiteUpdateDir)||!args.descrTipoVia1||args.descrTipoVia1==="Seleccionar..."||!args.numeroTipoVia1||
                !args.descrTipoVia2||args.descrTipoVia2==="Seleccionar..."||!args.numeroTipoVia2||
                !argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar..."||!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Seleccionar..."||
                !argsSelDpto.nombreZona||argsSelDpto.nombreZona==="Seleccionar..."||!argsSelDpto.nombreBarrio||argsSelDpto.nombreBarrio==="Seleccionar..."){
                  contratoCl = "ABCXYZ123"
              }
              if(contratoCl!=="ABCXYZ123"){
                //Validar TARIFA
                let comoAsigCicloFact = this.props.getParametro.getParametro.comoAsigCicloFact
                if(listServTar.length===0){
                  contratoCl = "ABCXYZ123"
                }else{
                  if(!fechaV){
                    contratoCl = "ABCXYZ123"
                  }else{
                    if(listServTar.length>0){
                      if(comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"&&
                      !listServTar[0].cicloFact){
                        contratoCl = "ABCXYZ123"
                      }
                    }
                    listServTar.forEach((elemento, _id) => {
                      if(elemento.estadoSelecc===false){
                        contratoCl = "ABCXYZ123"
                      }
                      if(elemento.numeroServicios===null||elemento.numeroServicios===''||elemento.numeroServicios<=0){
                        contratoCl = "ABCXYZ123"
                      }
                      if(elemento.valorServicios===null||elemento.valorServicios===''||elemento.valorServicios<0){
                        contratoCl = "ABCXYZ123"
                      }
                    })
                  }
                }
              }    
            }
          }
          if(contratoCl!=="ABCXYZ123"){
            if((this.state.addCliente&&(!args.descrTipoOS||args.descrTipoOS==="Seleccionar..."))){
              if(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar..."){
                contratoCl = "ABCXYZ123"
              }
              if(!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Seleccionar..."){
                contratoCl = "ABCXYZ123"
              }
            }
            if(args.observaciones){
              if(args.observaciones.length>100){
                contratoCl = "ABCXYZ123"
              }
            }      
          }
          if(contratoCl!=="ABCXYZ123"){
            let contratoCS = await this.nextVal('contrato')
            contratoCl = contratoCS.toString()
            // console.log("OJOOOOOOOO contrato", contratoCl)
          }
        }else{
          contratoCl = args.contrato
        }
        argsBuscarCL = {contrato: contratoCl}
        let clienteAdd = []
        if(this.props.allClientes1.allClientes){
          let {data} = await this.props.allClientes1.refetch(argsBuscarCL)
          clienteAdd = await data.allClientes
          if(clienteAdd.length>0){
            if(contratoSequence!=="SI"){
              errors.push({path: 'contrato', message: `El contrato ${args.contrato} ya existe`});
              iii = 9999999
            }
          }else{
            iii = 9999999
          }
        }else{
          errors.push({path: 'cargando', message: `Cargando la informacón para validación, por favor intente de nuevo`});
          iii = 9999999
        }

        if(listaCateg.length>0&&(!args.descrCategOST||args.descrCategOST==="Seleccionar...")){
          errors.push({path: 'Categoría', message: `Por favor seleccione la Categoría`});
        }
      }
    }

    if(!this.state.addCliente||contratoSequence!=="SI"){
      contratoCl = args.contrato
    }
    if((!contratoCl||!args.nombreCliente||!args.apellidoCliente||!args.numeroDoc||
        !args.descrEstrato||args.descrEstrato==="Seleccionar..."||
        !args.descrSegmento||args.descrSegmento==="Seleccionar..."||
        ((!args.cicloFact||args.cicloFact==="Seleccionar...")&&
        comoAsigCicloFact==="Asignarlo al crear o modificar clientes")||
        !args.descrTipoDoc||args.descrTipoDoc==="Seleccionar..."||
        !args.descrTipoCliente||args.descrTipoCliente==="Seleccionar..."||
        !args.descrGrupoAfin||args.descrGrupoAfin==="Seleccionar..."||
        ((!args.infAdic1||args.infAdic1==="Seleccionar...")&&empresaArchFE==="conectic"))&&
        !this.state.permiteDelete&&!this.state.permiteUpdateDir&&errors.length===0){
      if(comoAsigCicloFact==="Asignarlo al crear o modificar clientes"){
        if((!args.infAdic1||args.infAdic1==="Seleccionar...")&&empresaArchFE==="conectic"){
          this.validarHandle(contratoCl, 'contrato', '', 'Debe escribir el contrato',
            args.nombreCliente, 'nombreCliente', '', 'Debe escribir el nombre del cliente',
            args.apellidoCliente, 'apellidoCliente', '', 'Debe escribir el apellido del cliente',
            args.descrEstrato, 'descrEstrato', 'Seleccionar...', 'Debe seleccionar el estrato',
            args.descrSegmento, 'descrSegmento', 'Seleccionar...', 'Debe seleccionar el segmento',
            args.cicloFact, 'cicloFact', 'Seleccionar...', 'Debe seleccionar el ciclo de facturación',
            args.descrTipoDoc, 'descrTipoDoc', 'Seleccionar...', 'Debe seleccionar el tipo de documento',
            args.numeroDoc, 'numeroDoc', '', 'Debe escribir el número del documento',
            args.descrTipoCliente, 'descrTipoCliente', 'Seleccionar...', 'Debe seleccionar el tipo de cliente',
            args.descrGrupoAfin, 'descrGrupoAfin', 'Seleccionar...', 'Debe seleccionar el grupo de afinidad',
            args.infAdic1, 'infAdic1', 'Seleccionar...', 'Debe seleccionar la información adicional',
          )
        }else{
          this.validarHandle(contratoCl, 'contrato', '', 'Debe escribir el contrato',
            args.nombreCliente, 'nombreCliente', '', 'Debe escribir el nombre del cliente',
            args.apellidoCliente, 'apellidoCliente', '', 'Debe escribir el apellido del cliente',
            args.descrEstrato, 'descrEstrato', 'Seleccionar...', 'Debe seleccionar el estrato',
            args.descrSegmento, 'descrSegmento', 'Seleccionar...', 'Debe seleccionar el segmento',
            args.cicloFact, 'cicloFact', 'Seleccionar...', 'Debe seleccionar el ciclo de facturación',
            args.descrTipoDoc, 'descrTipoDoc', 'Seleccionar...', 'Debe seleccionar el tipo de documento',
            args.numeroDoc, 'numeroDoc', '', 'Debe escribir el número del documento',
            args.descrTipoCliente, 'descrTipoCliente', 'Seleccionar...', 'Debe seleccionar el tipo de cliente',
            args.descrGrupoAfin, 'descrGrupoAfin', 'Seleccionar...', 'Debe seleccionar el grupo de afinidad',
            sinCampo, '', '', '',
          )
        }
      }else{
        if((!args.infAdic1||args.infAdic1==="Seleccionar...")&&empresaArchFE==="conectic"){
          this.validarHandle(contratoCl, 'contrato', '', 'Debe escribir el contrato',
            args.nombreCliente, 'nombreCliente', '', 'Debe escribir el nombre del cliente',
            args.apellidoCliente, 'apellidoCliente', '', 'Debe escribir el apellido del cliente',
            args.descrEstrato, 'descrEstrato', 'Seleccionar...', 'Debe seleccionar el estrato',
            args.descrSegmento, 'descrSegmento', 'Seleccionar...', 'Debe seleccionar el segmento',
            args.descrTipoDoc, 'descrTipoDoc', 'Seleccionar...', 'Debe seleccionar el tipo de documento',
            args.numeroDoc, 'numeroDoc', '', 'Debe escribir el número del documento',
            args.descrTipoCliente, 'descrTipoCliente', 'Seleccionar...', 'Debe seleccionar el tipo de cliente',
            args.descrGrupoAfin, 'descrGrupoAfin', 'Seleccionar...', 'Debe seleccionar el grupo de afinidad',
            args.infAdic1, 'infAdic1', 'Seleccionar...', 'Debe seleccionar la información adicional',
            sinCampo, '', '', '',
          )
        }else{
          this.validarHandle(contratoCl, 'contrato', '', 'Debe escribir el contrato',
            args.nombreCliente, 'nombreCliente', '', 'Debe escribir el nombre del cliente',
            args.apellidoCliente, 'apellidoCliente', '', 'Debe escribir el apellido del cliente',
            args.descrEstrato, 'descrEstrato', 'Seleccionar...', 'Debe seleccionar el estrato',
            args.descrSegmento, 'descrSegmento', 'Seleccionar...', 'Debe seleccionar el segmento',
            args.descrTipoDoc, 'descrTipoDoc', 'Seleccionar...', 'Debe seleccionar el tipo de documento',
            args.numeroDoc, 'numeroDoc', '', 'Debe escribir el número del documento',
            args.descrTipoCliente, 'descrTipoCliente', 'Seleccionar...', 'Debe seleccionar el tipo de cliente',
            args.descrGrupoAfin, 'descrGrupoAfin', 'Seleccionar...', 'Debe seleccionar el grupo de afinidad',
            sinCampo, '', '', '',
            sinCampo, '', '', '',
          )
        }
      }
    }else{
      if(this.state.addCliente&&!args.eMail){
        errors.push({path: 'eMail', message: `Debe escribir el Correo electrónico`});
      }
      if(this.state.addCliente&&!args.telefono1){
        errors.push({path: 'telefono1', message: `Debe escribir el Teléfono 1`});
      }
      if(this.state.permiteUpdateDir||(this.state.addCliente&&args.descrTipoOS&&args.descrTipoOS!=="Seleccionar...")){
//Validar DIRECCION
        if((!args.observacAB&&!this.state.permiteUpdateDir)||!args.descrTipoVia1||args.descrTipoVia1==="Seleccionar..."||!args.numeroTipoVia1||
          !args.descrTipoVia2||args.descrTipoVia2==="Seleccionar..."||!args.numeroTipoVia2||
          !argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar..."||!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Seleccionar..."||
          !argsSelDpto.nombreZona||argsSelDpto.nombreZona==="Seleccionar..."||!argsSelDpto.nombreBarrio||argsSelDpto.nombreBarrio==="Seleccionar..."){
          this.validarHandle(!this.state.permiteUpdateDir?args.observacAB:sinCampo, 'observacAB', '', 'Debe escribir las observaciones',
                            args.descrTipoVia1, 'descrTipoVia1', 'Seleccionar...', 'Debe seleccionar la vía principal',
                            args.numeroTipoVia1, 'numeroTipoVia1', '', 'Debe escribir el número de la vía principal',
                            args.descrTipoVia2, 'descrTipoVia2', 'Seleccionar...', 'Debe escribir el número de la vía secundaria',
                            args.numeroTipoVia2, 'numeroTipoVia2', '', 'Debe escribir el número de la vía secundaria',
                            argsSelDpto.descrDpto, 'descrDpto', 'Seleccionar...', 'Debe seleccionar el departamento',
                            argsSelDpto.nombreCiudad, 'nombreCiudad', 'Seleccionar...', 'Debe seleccionar la ciudad',
                            argsSelDpto.nombreZona, 'nombreZona', 'Seleccionar...', 'Debe seleccionar la zona',
                            argsSelDpto.nombreBarrio, 'nombreBarrio', 'Seleccionar...', 'Debe seleccionar el barrio',
                            sinCampo, '', '', '',
                            sinCampo, '', '', '')
          hayError = true
        }

        if(!this.state.permiteUpdateDir){
          //Validar TARIFA
          let comoAsigCicloFact = this.props.getParametro.getParametro.comoAsigCicloFact
          if(listServTar.length===0){
            errors.push({path: 'tarifa', message: `No hay servicios asignados en la tarifa`});
          }else{
            if(!fechaV){
              errors.push({path: 'tarifa', message: `Debe seleccionar la fecha de vencimiento de la tarifa`});
            }else{
              if(listServTar.length>0){
                if(comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"&&
                !listServTar[0].cicloFact){
                  errors.push({path: 'tarifa', message: `La tarifa debe tener asignado el ciclo de facturación`});
                }
              }
              listServTar.forEach((elemento, _id) => {
                if(elemento.estadoSelecc===false){
                  errors.push({path: 'tarifa', message: `El servicio ${elemento.nombreResumido} esta marcado para quitar, si desea quitarlo de la tarifa haga click en Refrescar`});
                }
                if(elemento.numeroServicios===null||elemento.numeroServicios===''||elemento.numeroServicios<=0){
                  errors.push({path: 'tarifa', message: `El servicio ${elemento.nombreResumido} tiene un número de servicios inválido`});
                }
                if(elemento.valorServicios===null||elemento.valorServicios===''||elemento.valorServicios<0){
                  errors.push({path: 'tarifa', message: `El servicio ${elemento.nombreResumido} tiene un valor inválido, verifique si el número de servicios tiene valor en la tarifa`});
                }
              })
            }
          }
        }
      }

      if(this.state.permiteUpdateDir||(this.state.addCliente&&(!args.descrTipoOS||args.descrTipoOS==="Seleccionar..."))){
        if(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar..."){
          argsAdd['descrDpto'] = "";
          errors.push({path: 'descrDpto', message: `Debe seleccionar el departamento`});
        }
        if(!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Seleccionar..."){
          argsAdd['nombreCiudad'] = "";
          errors.push({path: 'nombreCiudad', message: `Debe seleccionar la ciudad`});
        }
      }
      if(args.observaciones){
        if(args.observaciones.length>100){
          argsAdd['observaciones'] = "";
          errors.push({path: 'observaciones', message: `Las observaciones tienen ${args.observaciones.length} caracteres (máximo 100)`});
        }
      }
      if(errors.length>0){
        this.setState({errorAdd: errors})
      }

      if(errors.length===0&&!hayError){
// //PARA EVITAR QUE SE CREEN CLIENTES DUPLICADOS
//         let puedeCrearCli = true
//         if(this.state.addCliente){
//           let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
//           let horaEntrada = new Date().getTime();
//           let difHoraEntrada = 3000
//           if(horaEntradaAnt){
//             difHoraEntrada = horaEntrada - horaEntradaAnt
//           }else{
//             difHoraEntrada = 8000
//           }
//           if(difHoraEntrada>7000){
//             sessionStorage.setItem("horaEntrada", horaEntrada);
//           }else{
//             puedeCrearCli = false
//           }
//         }
// //FIN PARA EVITAR QUE SE CREEN CLIENTES DUPLICADOS
        if(this.state.addCliente&&puedeCrearCli){
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaFechaHoy, fechaHoraHoy} = response.data.fecha
          let fechaHoy = fechaHoraHoy.substr(0, 10)
          let horaOS = fechaHoraHoy.substr(11, 5)
          // .trim()
          // console.log(args.nombreCliente, args.apellidoCliente, args.infAdic1)
          if(args.infAdic1){
            args.infAdic1 = args.infAdic1.trim()
          }
          args.nombreCliente = args.nombreCliente.trim()
          args.apellidoCliente = args.apellidoCliente.trim()
          // let fechaHoy = new Date()
          // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          args.fechaCreacionSistema = fechaHoy
          args.fechaCreate = fechaHoraHoy
          // console.log(fechaHoraHoy)
          let argsAddCrear = args
          if(contratoSequence==="SI"){
            argsAddCrear['contrato'] = contratoCl
          }
          if(!args.fechaCumple){
            argsAddCrear['fechaCumple'] = null
          }
          response = await this.props.createCliente({
            variables: argsAddCrear
          });
          // console.log(response)
          //response del resolvers devuelve el contrato en ok y el _id en _id
          const {errors, success, ok, _id} = response.data.createCliente;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            if(this.state.addCliente&&args.descrTipoOS&&args.descrTipoOS!=="Seleccionar..."){
              //CREAR LA OS
              const argsAdd = argsSelDpto
              argsAdd['_idTipoOS'] = args._idTipoOS
              argsAdd['codigoTipoOS'] = args.codigoTipoOS
              argsAdd['descrTipoOS'] = args.descrTipoOS
              argsAdd['observacAB'] = args.observacAB
              argsAdd['numeroOS'] = await this.nextVal('odess')
              argsAdd['codigoTipoDocV'] = argsDocum.codigoTipoDocV
              argsAdd['numeroDocumV'] = argsDocum.numeroDocumV
              argsAdd['descrRecursoV'] = argsDocum.descrRecursoV!=="Seleccionar..."?argsDocum.descrRecursoV:null
              argsAdd['contrato'] = ok
              argsAdd['fechaEjec'] = fechaFechaHoy
              argsAdd['fechaFra'] = fechaFechaHoy
              argsAdd['fechaCreate'] = fechaFechaHoy
              argsAdd['horaSolic'] = horaOS
              if(!args.descrCategOST||args.descrCategOST==="Seleccionar..."){
                argsAdd['descrCategOST'] = ""
              }else{
                argsAdd['descrCategOST'] = args.descrCategOST
              }
              // console.log(argsAdd)
              response = await this.props.createOdeS({
                variables: argsAdd
              });

//Actualizar fechas clientes
              let actFechas = []
              let argsUpdClFe = {}
              argsUpdClFe.tipoAct = "EditarFechCli"
              argsUpdClFe._id = _id
              argsUpdClFe.fechaUltOSAb = fechaFechaHoy
              actFechas.push(argsUpdClFe)

              let argsUpd = {}

//Asignar recursos a la OS
              let updRec = []
              if(argsSelDpto.codigoTipoDocT){
                const elemento3 = this.props.allRecurso.allRecurso.filter(elemento =>
                  elemento.codigoTipoDoc===argsSelDpto.codigoTipoDocT&&
                  elemento.numeroDocum===argsSelDpto.numeroDocumT)
                if(elemento3.length===1){
                  let elemento = elemento3[0]
                  argsUpd = {
                    "tipoAct": "EditarRecursos",
                    "numeroOS": argsAdd.numeroOS,
                    "_idRecurso" : elemento._id,
                    "codigoTipoDoc" : elemento.codigoTipoDoc,
                    "numeroDocum" : elemento.numeroDocum,
                    "descrRecurso" : elemento.descrRecurso,
                    "_idTipoRec" : elemento.tiporec._id,
                    "descrTipoRec" : elemento.tiporec.descrTipoRec,
                    "areaAprovech" : elemento.tiporec.areaAprovech
                  };
                  updRec.push(argsUpd)
                  // console.log(argsUpd)
                }
              }

//Agregar direccion a la OS
              let updDir = []
              argsUpd = {}
              argsUpd = {
                "tipoAct": "EditarDirmayor",
                "numeroOS": argsAdd.numeroOS,
                "codigoDpto": argsAdd.codigoDpto,
                "descrDpto": argsAdd.descrDpto,
                "codigoDptoDANE": argsAdd.codigoDptoDANE,
                "codigoCiudad": argsAdd.codigoCiudad,
                "nombreCiudad": argsAdd.nombreCiudad,
                "codigoMunicipioDANE": argsAdd.codigoMunicipioDANE,
                "codigoPostalDANE": argsAdd.codigoPostalDANE,
                "codigoCiudadInterno": argsAdd.codigoCiudadInterno,
                "codBarrasRdo": argsAdd.codBarrasRdo,
                "codigoZona": argsAdd.codigoZona,
                "nombreZona": argsAdd.nombreZona,
                "codigoBarrio": argsAdd.codigoBarrio,
                "nombreBarrio": argsAdd.nombreBarrio,
                "codigoTipoDocT": argsAdd.codigoTipoDocT,
                "numeroDocumT": argsAdd.numeroDocumT,
                "descrRecursoT": argsAdd.descrRecursoT,
                "codigoTipoDocR": argsAdd.codigoTipoDocR,
                "numeroDocumR": argsAdd.numeroDocumR,
                "descrRecursoR": argsAdd.descrRecursoR,

                "descrTipoVia1": args.descrTipoVia1,
                "numeroTipoVia1": args.numeroTipoVia1,
                "descrTipoVia2": args.descrTipoVia2,
                "numeroTipoVia2": args.numeroTipoVia2,
                "numeroTipoVia2F": args.numeroTipoVia2F,
                "descrTipoUnd1": args.descrTipoUnd1,
                "numeroTipoUnd1": args.numeroTipoUnd1,
                "descrTipoUnd2": args.descrTipoUnd2,
                "numeroTipoUnd2": args.numeroTipoUnd2,
                "descrTiUndMat": args.descrTiUndMat,
                "descrUndMat": args.descrUndMat
              };
              if(!args.descrTipoUnd1){delete argsUpd.descrTipoUnd1}
              if(!args.numeroTipoUnd1){delete argsUpd.numeroTipoUnd1}
              if(!args.descrTipoUnd2){delete argsUpd.descrTipoUnd2}
              if(!args.numeroTipoUnd2){delete argsUpd.numeroTipoUnd2}
              if(!args.descrTiUndMat){delete argsUpd.descrTiUndMat}
              if(!args.descrUndMat){delete argsUpd.descrUndMat}
              updDir.push(argsUpd)
              // console.log(argsUpd)

//Agregar tarifa a la OS
              let servTarCli = []
              let servTarCliI = []

              listServTar.forEach((elemento, i) => {
                argsUpd = {}
                argsUpd = {
                  "tipoAct": i===0?"EditarTarifa":"EditarServTar",
                  "numeroOS": argsAdd.numeroOS,
                  "codigoTarifa": elemento.codigoTarifa,
                  "descrTarifa": elemento.descrTarifa,
                  "cicloFact": elemento.cicloFact?elemento.cicloFact:null,
                  "fechaVence": fechaV,
                  "codigoServicioT": elemento.codigoServicio,
                  "nombreResumidoT": elemento.nombreResumido,
                  "descripcionServicioT": elemento.descripcionServicio,
                  "_idSubclaseServT": elemento._idSubclaseServ,
                  "codigoSubclaseServT": elemento.codigoSubclaseServ,
                  "descrSubclaseServT": elemento.descrSubclaseServ,
                  "_idClaseServT": elemento._idClaseServ,
                  "codigoClaseServT": elemento.codigoClaseServ,
                  "descrClaseServT": elemento.descrClaseServ,
                  "velEfecDownstream": elemento.velEfecDownstream,
                  "velEfecUpstream": elemento.velEfecUpstream,
                  "codigoTipoTec": elemento.codigoTipoTec,
                  "descrTipoTec": elemento.descrTipoTec,
                  "colorServicio": elemento.colorServicio,
                  "estadoServicio": "A",
                  "rango1NumServValorIni": elemento.rango1NumServValorIni,
                  "rango1NumServValorFin": elemento.rango1NumServValorFin,
                  "rango1Valor": elemento.rango1Valor,
                  "rango2NumServValorIni": elemento.rango2NumServValorIni,
                  "rango2NumServValorFin": elemento.rango2NumServValorFin,
                  "rango2Valor": elemento.rango2Valor,
                  "rango3NumServValorIni": elemento.rango3NumServValorIni,
                  "rango3NumServValorFin": elemento.rango3NumServValorFin,
                  "rango3Valor": elemento.rango3Valor,
                  "numeroServicios": elemento.numeroServicios,
                  "valorServicios": elemento.valorServicios,
                  "valorAntesImptos": elemento.valorAntesImptos
                };
                servTarCli.push(argsUpd)
// console.log(argsUpd)
                elemento.imptos.forEach((elemento1, ii) => {
                  if(elemento1.codigoImpto!==null){
                    argsUpd = {}
                    argsUpd = {
                      "tipoAct": ii===0?"CrearImpto1":"CrearImpto2",
                      "numeroOS": argsAdd.numeroOS,
                      "codigoTarifa": elemento.codigoTarifa,
                      "codigoServicioT": elemento.codigoServicio,
                      "codigoImpto": elemento1.codigoImpto,
                      "descrImpto": elemento1.descrImpto,
                      "porcImpto": elemento1.porcImpto,
                      "valorImpto": elemento1.valorImpto,
                    }
                    servTarCliI.push(argsUpd)
                  }
                })
              })
// console.log(servTarCli)
// console.log(servTarCliI)
//Actualizar bd
              let numDocCRUD = 0
              let totDocCRUD = 3 + servTarCli.length + servTarCliI.length
              let argsCrud = []
              let crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editOdeSUpdDoc)
              }
          
              argsCrud[numDocCRUD] = actFechas[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editCliente

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updRec[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDir[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

              numDocCRUD += 1
              servTarCli.forEach((elemento, i) => {
                argsCrud[numDocCRUD] = elemento
                argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
                argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              
                numDocCRUD += 1
                let imptosTC = servTarCliI.filter(imptos => imptos.codigoTarifa===elemento.codigoTarifa 
                                              && imptos.codigoServicioT===elemento.codigoServicioT)
                imptosTC.forEach((elemento1, ii) => {
                  argsCrud[numDocCRUD] = elemento1
                  argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
                  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              
                  numDocCRUD += 1
                })
              })
// console.log(argsCrud, totDocCRUD)
              await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            }
//FIN crear OS

//Agregar ciudad
            // if(this.state.addCliente&&(!args.descrTipoOS||args.descrTipoOS==="Seleccionar...")){
            if(this.state.addCliente){
              let updDir = []
              let argsUpd = {}
              argsUpd = {
                "tipoAct": "EditarDirmayor",
                "_id": _id,
                "codigoDpto": argsSelDpto.codigoDpto,
                "descrDpto": argsSelDpto.descrDpto,
                "codigoDptoDANE": argsSelDpto.codigoDptoDANE,
                "codigoCiudad": argsSelDpto.codigoCiudad,
                "nombreCiudad": argsSelDpto.nombreCiudad,
                "codigoMunicipioDANE": argsSelDpto.codigoMunicipioDANE,
                "codigoPostalDANE": argsSelDpto.codigoPostalDANE,
                "codigoCiudadInterno": argsSelDpto.codigoCiudadInterno,
                "codBarrasRdo": argsSelDpto.codBarrasRdo,
              };
              updDir.push(argsUpd)
              // console.log(argsUpd)

              //Actualizar bd
              let numDocCRUD = 0
              let totDocCRUD = 1
              let argsCrud = []
              let crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editClienteUpdDoc)
              }

              argsCrud[numDocCRUD] = updDir[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editClienteUpdDoc

              // console.log(argsCrud, totDocCRUD)
              await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            }
//FIN Agregar ciudad

            if(contratoSequence==="SI"){
              alert(`contrato ${contratoCl} creado con éxito`)
            }

            let estrato = document.getElementById("miListaEstr");
            estrato.options.selectedIndex = 0

            if(this.props.allSegmento.allSegmento.length>1){
              let segmento = document.getElementById("miListaSeg");
              segmento.options.selectedIndex = 0
            }
            
            if(comoAsigCicloFact==="Asignarlo al crear o modificar clientes"){
              let ciclofact = document.getElementById("miListaCF");
              ciclofact.options.selectedIndex = 0
            }
            let tipodoc = document.getElementById("miListaTD");
            tipodoc.options.selectedIndex = 0
            let tipocl = document.getElementById("miListaTC");
            tipocl.options.selectedIndex = 0
            let grupoaf = document.getElementById("miListaGA");
            grupoaf.options.selectedIndex = 0
            let descrDpto = document.getElementById("miLista");
            descrDpto.options.selectedIndex = 0
            let nombreCiudad = document.getElementById("miLista1");
            nombreCiudad.options.selectedIndex = 0

            let contrato = document.getElementById("contrato");
            let infAdic1 = ""
            if(empresaArchFE==="conectic"){
              infAdic1 = document.getElementById("miListaInfAdic");
              infAdic1.options.selectedIndex = 0
            }
            if((modeloFactura!=="1"&&empresaArchFE!=="conectic")){
              infAdic1 = ""
            }
            let nombreCliente = document.getElementById("nombreCliente");
            let apellidoCliente = document.getElementById("apellidoCliente");
            let numeroDoc = document.getElementById("numeroDoc");
            let telefono1 = document.getElementById("telefono1");
            let telefono2 = document.getElementById("telefono2");
            let telefono3 = document.getElementById("telefono3");
            let referencia1 = document.getElementById("referencia1");
            let telefonoRef1 = document.getElementById("telefonoRef1");
            let referencia2 = document.getElementById("referencia2");
            let telefonoRef2 = document.getElementById("telefonoRef2");
            let eMail = document.getElementById("eMail");
            let fechaCumple = document.getElementById("fechaCumple");
            let observaciones = document.getElementById("observaciones");
            if(contratoSequence!=="SI"){
              contrato.value = ""
            }
            // if(modeloFactura!=="1"){
            //   infAdic1.value = ""
            // }
            nombreCliente.value = ""
            apellidoCliente.value = ""
            telefono1.value = ""
            telefono2.value = ""
            telefono3.value = ""
            referencia1.value = ""
            telefonoRef1.value = ""
            referencia2.value = ""
            telefonoRef2.value = ""
            eMail.value = ""
            fechaCumple = ""
            observaciones.value = ""
            numeroDoc.value = ""

            if(args.descrTipoOS&&args.descrTipoOS!=="Seleccionar..."){
              let tipoos = document.getElementById("miListaOS");
              tipoos.options.selectedIndex = 0
              let direcc = document.getElementById("descrTipoVia1");
              direcc.options.selectedIndex = 0
              direcc = document.getElementById("descrTipoVia2");
              direcc.options.selectedIndex = 0
              direcc = document.getElementById("descrTipoUnd1");
              direcc.options.selectedIndex = 0
              direcc = document.getElementById("descrTipoUnd2");
              direcc.options.selectedIndex = 0
              direcc = document.getElementById("descrTiUndMat");
              direcc.options.selectedIndex = 0
              direcc = document.getElementById("descrUndMat");
              direcc.options.selectedIndex = 0
              direcc = document.getElementById("miLista3");
              direcc.options.selectedIndex = 0
            }            
            let argsAdd = {}
            argsAdd.descrTipoOS = "Seleccionar..."
            this.setState({errorAdd: []})
            this.setState({argsAdd})
            this.props.allClientes.refetch()
          }
        }else{
          if(this.state.permiteUpdate){
            // console.log(args.nombreCliente, args.apellidoCliente, args.numeroDoc,
            //   this.state.idLista.nombreCliente, this.state.idLista.apellidoCliente, this.state.idLista.numeroDoc)
            let infAdic1 = ""
            if(args.infAdic1){
              infAdic1 = args.infAdic1.trim()
            }
            let nombreCliente = args.nombreCliente.trim()
            let apellidoCliente = args.apellidoCliente.trim()

            const argsUpd = {
              _id: args._id,
              tipoAct: "EditarCliente",
              infAdic1: infAdic1,
              nombreCliente: nombreCliente,
              apellidoCliente: apellidoCliente,
              sexoCliente: args.sexoCliente,
              eMail: args.eMail,
              fechaCumple: args.fechaCumple,
              descrEstrato: args.descrEstrato,
              codigoSegmento: args.codigoSegmento?args.codigoSegmento:"",
              descrSegmento: args.descrSegmento?args.descrSegmento:"",
              cicloFact: args.cicloFact,
              telefono1: args.telefono1,
              telefono2: args.telefono2,
              telefono3: args.telefono3,
              referencia1: args.referencia1,
              telefonoRef1: args.telefonoRef1,
              referencia2: args.referencia2,
              telefonoRef2: args.telefonoRef2,
              numeroDoc: args.numeroDoc,
              observaciones: args.observaciones,
              codigoTipoCliente: args.codigoTipoCliente,
              descrTipoCliente: args.descrTipoCliente,
              idTipoDoc: args.idTipoDoc,
              codigoTipoDoc: args.codigoTipoDoc,
              descrTipoDoc: args.descrTipoDoc,
              idGrupoAf: args.idGrupoAf,
              codigoGrupoAfin: args.codigoGrupoAfin,
              descrGrupoAfin: args.descrGrupoAfin
            }
            // console.log(argsUpd)
            if(this.state.idLista.estadoCliente==="NUEVO"){
              delete argsUpd.cicloFact
            }
            let actCliente = []
            actCliente.push(argsUpd)

            // PARA CREAR REGISTROS EN HISTCLIENTES
            let creaHC = []
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha
            let fechaHoy = fechaHoraHoy.substr(0, 10)
            let horaHoy = fechaHoraHoy.substr(11, 5)
  
            if(args.nombreCliente!==this.state.idLista.nombreCliente){
              let argsAddHC = {
                "fechaHistCliente": fechaHoy + ' ' + horaHoy,
                "contrato": args.contrato,
                "movimiento": "Cambiar Nombre",
                "descripcion": `Ant: ${this.state.idLista.nombreCliente}`,
                "detalle": `Nuevo: ${args.nombreCliente}`,
                "usuarioCreate": sessionStorage.getItem('userLogin'),
              }
              creaHC.push(argsAddHC)
            }
            if(args.apellidoCliente!==this.state.idLista.apellidoCliente){
              let argsAddHC = {
                "fechaHistCliente": fechaHoy + ' ' + horaHoy,
                "contrato": args.contrato,
                "movimiento": "Cambiar Apellido",
                "descripcion": `Ant: ${this.state.idLista.apellidoCliente}`,
                "detalle": `Nuevo: ${args.apellidoCliente}`,
                "usuarioCreate": sessionStorage.getItem('userLogin'),
              }
              creaHC.push(argsAddHC)
            }
            if(args.numeroDoc!==this.state.idLista.numeroDoc){
              let argsAddHC = {
                "fechaHistCliente": fechaHoy + ' ' + horaHoy,
                "contrato": args.contrato,
                "movimiento": "Cambiar Documento",
                "descripcion": `Ant: ${this.state.idLista.numeroDoc}`,
                "detalle": `Nuevo: ${args.numeroDoc}`,
                "usuarioCreate": sessionStorage.getItem('userLogin'),
              }
              creaHC.push(argsAddHC)
            }
            // FIN PARA CREAR REGISTROS EN HISTCLIENTES

            let creaHCMany = [], creaHCMany1 = []
            creaHC.forEach((elementoHC, ii) => {
              creaHCMany.push(elementoHC)
            })
            creaHCMany1.push({histcliente: creaHCMany})

            let numDocCRUD = 0
            let totDocCRUD = 2
            let argsCrud = []
            let crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editCliente)
            }
          
            argsCrud[numDocCRUD] = actCliente[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editCliente

            numDocCRUD += 1

            argsCrud[numDocCRUD] = creaHCMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.createHistClienteMany
            
            this.updColecc(crudColecc, argsCrud, totDocCRUD)

            // const response = await this.props.editCliente({
            //   variables: argsUpd
            // });
            // const {errors, success} = response.data.editCliente;
            // if (!success){
            //   this.setState({errorAdd: errors})
            // }else{
              this.props.allClientes.refetch()
              this.estadosFalse()
              this.setState({showClient: true})
            // }
          }
          if(this.state.permiteDelete){
            // console.log(args.contrato)

            // if(this.props.allClientes.allClientes){
            //   console.log(this.props.allClientes.allClientes)
            //   for(let iii=0; iii<this.props.allClientes.allClientes.length; iii++){
            //     console.log(iii, this.props.allClientes.allClientes[iii].contrato)
            //     const argsDel = {
            //       _id: this.props.allClientes.allClientes[iii]._id,
            //       contrato: this.props.allClientes.allClientes[iii].contrato,
            //     }
            //     await this.props.deleteCliente({
            //       variables: argsDel
            //     });
            //   }
            // }

            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha
    
            let argsCreate = args
            argsCreate.fechaCreate = fechaHoraHoy
            
            const argsDel = {
              _id: args._id,
              contrato: contratoCl,
              // paraLog: `contrato: ${contratoCl}    Eliminado por: ${sessionStorage.getItem('userLogin')} => ${fechaHoraHoy}\r\n`
              paraLog: `${contratoCl}|${sessionStorage.getItem('userLogin')}|${fechaHoraHoy}\r\n`
            }
            await this.props.deleteCliente({
              variables: argsDel
            });

            this.props.allClientes.refetch()

            this.estadosFalse()
            this.setState({showClient: true})
          }
          if(this.state.permiteUpdateDir){
            let argsBuscarCL = {contrato: argsDocum.contrato}
            let clienteUpd = []
            if(this.props.allClientes1.allClientes){
              let {data} = await this.props.allClientes1.refetch(argsBuscarCL)
              clienteUpd = await data.allClientes
              if(clienteUpd.length===0){
                errors.push({path: 'contrato', message: `El contrato ${contratoCl} NO existe`});
              }
            }else{
              errors.push({path: 'cargando', message: `Cargando la informacón para validación, por favor intente de nuevo`});
            }
            
            if(errors.length===0){
              let cliente = clienteUpd[0]

              let response = await this.props.fecha({
                variables: {}
              });
              const {fechaHoraHoy} = response.data.fecha
              let fechaHoy = fechaHoraHoy.substr(0, 10)
              let horaHoy = fechaHoraHoy.substr(11, 8)
        
              //CREA REGISTRO EN HISTCLIENTES
              let creaHC = []

              let linea1DNN = `${args.descrTipoVia1?args.descrTipoVia1:""}${args.numeroTipoVia1?" " + args.numeroTipoVia1:""}`
              linea1DNN += `${args.descrTipoVia2?" " + args.descrTipoVia2:""}${args.numeroTipoVia2?" " + args.numeroTipoVia2:""}`
              linea1DNN += `${args.numeroTipoVia2F?" " + args.numeroTipoVia2F:""}${args.descrTipoUnd1?" " + args.descrTipoUnd1:""}`
              linea1DNN += `${args.numeroTipoUnd1?" " + args.numeroTipoUnd1:""}${args.descrTipoUnd2?" " + args.descrTipoUnd2:""}`
              linea1DNN += `${args.numeroTipoUnd2?" " + args.numeroTipoUnd2:""}${args.descrTiUndMat?" " + args.descrTiUndMat:""}`
              linea1DNN += `${args.descrUndMat?" " + args.descrUndMat:""}`
        
              let linea3DNN = `${argsSelDpto.nombreCiudad?argsSelDpto.nombreCiudad:""}`    
              let linea4DNN = `${argsSelDpto.nombreZona?", " + argsSelDpto.nombreZona:""}`
              linea4DNN += `${argsSelDpto.nombreBarrio?", " + argsSelDpto.nombreBarrio:""}`
        
              let linea1DAnt = ""
              let linea3DAnt = ""
              let linea4DAnt = ""
              linea1DAnt = `${cliente.direccion.descrTipoVia1?cliente.direccion.descrTipoVia1:""}${cliente.direccion.numeroTipoVia1?" " + cliente.direccion.numeroTipoVia1:""}`
              linea1DAnt += `${cliente.direccion.descrTipoVia2?" " + cliente.direccion.descrTipoVia2:""}${cliente.direccion.numeroTipoVia2?" " + cliente.direccion.numeroTipoVia2:""}`
              linea1DAnt += `${cliente.direccion.numeroTipoVia2F?" " + cliente.direccion.numeroTipoVia2F:""}${cliente.direccion.descrTipoUnd1?" " + cliente.direccion.descrTipoUnd1:""}`
              linea1DAnt += `${cliente.direccion.numeroTipoUnd1?" " + cliente.direccion.numeroTipoUnd1:""}${cliente.direccion.descrTipoUnd2?" " + cliente.direccion.descrTipoUnd2:""}`
              linea1DAnt += `${cliente.direccion.numeroTipoUnd2?" " + cliente.direccion.numeroTipoUnd2:""}${cliente.direccion.descrTiUndMat?" " + cliente.direccion.descrTiUndMat:""}`
              linea1DAnt += `${cliente.direccion.descrUndMat?" " + cliente.direccion.descrUndMat:""}`
      
              linea3DAnt = `${cliente.dirmayor.ciudades.nombreCiudad?cliente.dirmayor.ciudades.nombreCiudad:""}`    
              linea4DAnt = `${cliente.dirmayor.ciudades.zonas.nombreZona?", " + cliente.dirmayor.ciudades.zonas.nombreZona:""}`
              linea4DAnt += `${cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio?", " + cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`
    
              let argsAddHC = {
                "fechaHistCliente": fechaHoy + ' ' + horaHoy,
                "contrato": cliente.contrato,
                "movimiento": "Cambiar dirección",
                "descripcion": `Dir Ant: ${linea1DAnt} - ${linea3DAnt} ${linea4DAnt}`,
                "detalle": `Dir nueva: ${linea1DNN} - ${linea3DNN} ${linea4DNN}`,
                "usuarioCreate": sessionStorage.getItem('userLogin'),
              }
              creaHC.push(argsAddHC)
              //FIN CREA REGISTRO EN HISTCLIENTES

              //ACTUALIZAR DIRECCION A LOS CLIENTES
              let movColecc = []
              let argsAdd = {}

              argsAdd['tipoAct'] = "EditarDirmayor"
              argsAdd['_id'] = cliente._id

              argsAdd['dirmayor'] = {codigoDpto: argsSelDpto.codigoDpto,
                descrDpto: argsSelDpto.descrDpto,
                codigoDptoDANE: argsSelDpto.codigoDptoDANE,
                ciudades: {codigoCiudad: argsSelDpto.codigoCiudad,
                  nombreCiudad: argsSelDpto.nombreCiudad,
                  codigoMunicipioDANE: argsSelDpto.codigoMunicipioDANE,
                  codigoPostalDANE: argsSelDpto.codigoPostalDANE,
                  codigoCiudadInterno: argsSelDpto.codigoCiudadInterno,
                  codBarrasRdo: argsSelDpto.codBarrasRdo,
                  zonas: {codigoZona: argsSelDpto.codigoZona,
                    nombreZona: argsSelDpto.nombreZona,
                    barrios: {codigoBarrio: argsSelDpto.codigoBarrio,
                      nombreBarrio: argsSelDpto.nombreBarrio,
                      descrRecursoT: argsSelDpto.descrRecursoT,
                      numeroDocumT: argsSelDpto.numeroDocumT,
                      codigoTipoDocT: argsSelDpto.codigoTipoDocT,
                      descrRecursoR: argsSelDpto.descrRecursoR,
                      numeroDocumR: argsSelDpto.numeroDocumR,
                      codigoTipoDocR: argsSelDpto.codigoTipoDocR
                  }}}}

              argsAdd['direccion'] = {descrTipoVia1: args.descrTipoVia1,
                numeroTipoVia1: args.numeroTipoVia1,
                descrTipoVia2: args.descrTipoVia2,
                numeroTipoVia2: args.numeroTipoVia2,
                numeroTipoVia2F: args.numeroTipoVia2F,
                descrTipoUnd1: args.descrTipoUnd1,
                numeroTipoUnd1: args.numeroTipoUnd1,
                descrTipoUnd2: args.descrTipoUnd2,
                numeroTipoUnd2: args.numeroTipoUnd2,
                descrTiUndMat: args.descrTiUndMat,
                descrUndMat: args.descrUndMat
              }
              movColecc.push(argsAdd)
              //FIN ACTUALIZAR DIRECCION A LOS CLIENTES
            
              //Actualiza la dir de los clientes y crea hist cliente
              let actCliMany1 = []
              actCliMany1.push({cliente: movColecc})

              let creaHCMany = [], creaHCMany1 = []
              creaHC.forEach((elementoHC, ii) => {
                creaHCMany.push(elementoHC)
              })
              creaHCMany1.push({histcliente: creaHCMany})

              let numDocCRUD = 0
              let totDocCRUD = 2
              let argsCrud = []
              let crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editClienteUpdDocMany)
              }
            
              argsCrud[numDocCRUD] = actCliMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

              numDocCRUD += 1

              argsCrud[numDocCRUD] = creaHCMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.createHistClienteMany
              
              this.updColecc(crudColecc, argsCrud, totDocCRUD)
              this.props.allClientes.refetch()

              this.estadosFalse()
              this.setState({showClient: true})
            }
          }
        }
      }
    }
  }

  handleTipocli = async (ev, args)=>{
    if(!args.codigoTipoCliente||!args.descrTipoCliente){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTipoCliente){
        argsAdd['codigoTipoCliente'] = "";
        errors.push({path: 'codigoTipoCliente', message: "Debe escribir el código"});
      }
      if(!args.descrTipoCliente){
        argsAdd['descrTipoCliente'] = "";
        errors.push({path: 'descrTipoCliente', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTipocli){
        const response = await this.props.createTipoCliente({
          variables: args
        });
        const {errors, success} = response.data.createTipoCliente;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoTipoCliente = document.getElementById("codigoTipoCliente");
          var descrTipoCliente = document.getElementById("descrTipoCliente");
          codigoTipoCliente.value = ""
          descrTipoCliente.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTiposCliente.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          document.body.style.cursor = 'wait'
          const argsUpd = {
            _id: args._id,
            descrTipoCliente: args.descrTipoCliente,
            descrTipoClienteAnt: args.descrTipoClienteAnt,
          }
          const response = await this.props.editTipoCliente({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoCliente;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTiposCliente.refetch()
            this.estadosFalse()
            this.setState({showTipocli: true})
          }
          document.body.style.cursor = 'default'
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            descrTipoCliente: args.descrTipoCliente
          }
          const response = await this.props.deleteTipoCliente({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteTipoCliente;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTiposCliente.refetch()
            this.estadosFalse()
            this.setState({showTipocli: true})
          }
        }
      }
    }
  }

  handleGrupoaf = async (ev, args)=>{
    if(!args.codigoGrupoAfin||!args.descrGrupoAfin){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoGrupoAfin){
        argsAdd['codigoGrupoAfin'] = "";
        errors.push({path: 'codigoGrupoAfin', message: "Debe escribir el código"});
      }
      if(!args.descrGrupoAfin){
        argsAdd['descrGrupoAfin'] = "";
        errors.push({path: 'descrGrupoAfin', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addGrupoaf){
        if(this.props.allGruposAfin.allGruposAfin){
          let indexSearch = await this.props.allGruposAfin.allGruposAfin.findIndex( grupoAF => grupoAF.descrGrupoAfin === args.descrGrupoAfin );
          if(indexSearch!==-1){
            const errors = [];
            errors.push({path: 'descrGrupoAfin', message: "El Grupo de afinidad " + args.descrGrupoAfin + " YA existe"});
            this.setState({errorAdd: errors})
          }else{
            const response = await this.props.createGrupoAfin({
              variables: args
            });
            const {errors, success} = response.data.createGrupoAfin;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              var codigoGrupoAfin = document.getElementById("codigoGrupoAfin");
              var descrGrupoAfin = document.getElementById("descrGrupoAfin");
              codigoGrupoAfin.value = ""
              descrGrupoAfin.value = ""
              this.setState({errorAdd: []})
              this.setState({argsAdd: {}})
              this.props.allGruposAfin.refetch()
            }
          }
        }
      }else{
        if(this.state.permiteUpdate){
          if(this.props.allGruposAfin.allGruposAfin){
            let indexSearch = await this.props.allGruposAfin.allGruposAfin.findIndex( grupoAF => grupoAF.descrGrupoAfin === args.descrGrupoAfin );
            if(indexSearch!==-1&&args.descrGrupoAfin!==args.descrGrupoAfinAnt){
              const errors = [];
              errors.push({path: 'descrGrupoAfin', message: "El Grupo de afinidad " + args.descrGrupoAfin + " YA existe"});
              this.setState({errorAdd: errors})
            }else{
              document.body.style.cursor = 'wait'
              const argsUpd = {
                _id: args._id,
                descrGrupoAfin: args.descrGrupoAfin,
                descrGrupoAfinAnt: args.descrGrupoAfinAnt,
              }
              const response = await this.props.editGrupoAfin({
                variables: argsUpd
              });
              const {errors, success} = await response.data.editGrupoAfin;
              if (!success){
                this.setState({errorAdd: errors})
              }else{
                this.props.allGruposAfin.refetch()
                this.estadosFalse()
                this.setState({showGrupoaf: true})
              }
              document.body.style.cursor = 'default'
            }
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            descrGrupoAfin: args.descrGrupoAfin
          }
          const response = await this.props.deleteGrupoAfin({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteGrupoAfin;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allGruposAfin.refetch()
            this.estadosFalse()
            this.setState({showGrupoaf: true})
          }
        }
      }
    }
  }

  handleTipodoc = async (ev, args)=>{
    if(!args.codigoTipoDoc||!args.descrTipoDoc){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTipoDoc){
        argsAdd['codigoTipoDoc'] = "";
        errors.push({path: 'codigoTipoDoc', message: "Debe escribir el código"});
      }
      if(!args.descrTipoDoc){
        argsAdd['descrTipoDoc'] = "";
        errors.push({path: 'descrTipoDoc', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTipodoc){
        const response = await this.props.createTipoDoc({
          variables: args
        });
        const {errors, success} = response.data.createTipoDoc;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoTipoDoc = document.getElementById("codigoTipoDoc");
          var descrTipoDoc = document.getElementById("descrTipoDoc");
          codigoTipoDoc.value = ""
          descrTipoDoc.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTiposDoc.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrTipoDoc: args.descrTipoDoc,
          }
          const response = await this.props.editTipoDoc({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoDoc;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTiposDoc.refetch()
            this.estadosFalse()
            this.setState({showTipodoc: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteTipoDoc({
            variables: argsDel
          });

          this.props.allTiposDoc.refetch()

          this.estadosFalse()
          this.setState({showTipodoc: true})
        }
      }
    }
  }

  handleCicloFact = async (ev, args, cicloFactAnt)=>{
    // console.log(args)
    if(!args.cicloFact){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.cicloFact){
        argsAdd['cicloFact'] = "";
        errors.push({path: 'cicloFact', message: "Debe escribir el ciclo de facturación"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addCicloFact){
        let argsAdd = this.state.argsAdd
        if(!args.noFactRET){
          argsAdd.noFactRET = false
        }
        // console.log(argsAdd)
        const response = await this.props.createCicloFact({
          variables: argsAdd
        });
        const {errors, success} = response.data.createCicloFact;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var cicloFact = document.getElementById("cicloFact");
          cicloFact.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {noFactRET: argsAdd.noFactRET}})
          this.props.allCicloFact.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            cicloFact: args.cicloFact,
            noFactRET: args.noFactRET
          }
          // console.log(argsUpd)
          const response = await this.props.editCicloFact({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCicloFact;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allCicloFact.refetch()
            this.estadosFalse()
            this.setState({showCicloFact: true})

            if(cicloFactAnt!==args.cicloFact){
              //ACTUALIZA EN clientes, tarifas, odes Y procfacts
              let updDoc = [], updDocMany = [], updDocMany1 = []

              let updMatch1 = cicloFactAnt
              let updSet4 = args.cicloFact
              let argsMatchCl1 = `'cicloFact': '${updMatch1}'`
              let argsSetCl1 = `'cicloFact': '${updSet4}'`
              let argsUpdCl1 = {tipoqry: `{${argsMatchCl1}}, {$set: {${argsSetCl1}}}`, modelo: 'models.Cliente.updateMany'}
              // console.log(argsUpdCl)

              let argsMatchCl2 = `'cicloFact': '${updMatch1}'`
              let argsSetCl2 = `'cicloFact': '${updSet4}'`
              let argsUpdCl2 = {tipoqry: `{${argsMatchCl2}}, {$set: {${argsSetCl2}}}`, modelo: 'models.Tarifa.updateMany'}

              let argsMatchCl3 = `'tarifa.cicloFact': '${updMatch1}'`
              let argsSetCl3 = `'tarifa.cicloFact': '${updSet4}'`
              let argsUpdCl3 = {tipoqry: `{${argsMatchCl3}}, {$set: {${argsSetCl3}}}`, modelo: 'models.OdeS.updateMany'}

              let argsMatchCl4 = `'cicloFact': '${updMatch1}'`
              let argsSetCl4 = `'cicloFact': '${updSet4}'`
              let argsUpdCl4 = {tipoqry: `{${argsMatchCl4}}, {$set: {${argsSetCl4}}}`, modelo: 'models.ProcFact.updateMany'}

              // console.log(argsUpdCl)
              // console.log(argsUpdDM)
              updDoc.push(argsUpdCl1)
              updDoc.push(argsUpdCl2)
              updDoc.push(argsUpdCl3)
              updDoc.push(argsUpdCl4)

              // console.log(updDoc)

              updDoc.forEach((elemento, ii) => {
                // console.log(elemento)
                updDocMany.push(elemento)
                updDocMany1.push({docum: updDocMany})
                updDocMany = []
              })
              // updDocMany1.push({docum: updDocMany})

              let numDocCRUD = 0, totDocCRUD = 4, argsCrud = [], crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }
              // console.log(updDocMany1[0])
              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDocMany1[1]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDocMany1[2]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDocMany1[3]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              // console.log(argsCrud)
              await this.updColecc(crudColecc, argsCrud, totDocCRUD)
              //FIN ACTUALIZA EN clientes, tarifas, odes Y procfacts
            }
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "cicloFact": args.cicloFact
          }
          const response = await this.props.deleteCicloFact({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteCicloFact;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allCicloFact.refetch()
            this.estadosFalse()
            this.setState({showCicloFact: true})
          }
        }
      }
    }
  }

  handleOtrosPagCl = async (ev, args)=>{
    if(!args.descrOtrosPagCl){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrOtrosPagCl){
        argsAdd['descrOtrosPagCl'] = "";
        errors.push({path: 'Otros pagos', message: "Debe escribir el concepto"});
      }
      if(!args.descrClaseServ||args.descrClaseServ==="Seleccionar..."){
        argsAdd['_idClaseserv'] = "";
        argsAdd['descrClaseServ'] = "Seleccionar...";
        errors.push({path: 'Clase', message: "Debe seleccionar la clase"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addOtrosPagCl){
        // console.log(args)
        if(args.descrImpto==="No tiene impuesto"){
          args['codigoImpto'] = null
          args['porcImpto'] = null
          args['descrImpto'] = null
        }
        const response = await this.props.createOtrosPagCl({
          variables: args
        });
        const {errors, success} = response.data.createOtrosPagCl;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrOtrosPagCl = document.getElementById("descrOtrosPagCl");
          var imptoOP = document.getElementById("miLista");
          var clase = document.getElementById("miLista1");
          clase.options.selectedIndex = 0
          imptoOP.options.selectedIndex = 0
          descrOtrosPagCl.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allOtrosPagCl.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrOtrosPagCl: args.descrOtrosPagCl,
            codigoImpto: args.descrImpto==="No tiene impuesto"?null:args.codigoImpto,
            descrImpto: args.descrImpto==="No tiene impuesto"?null:args.descrImpto,
            porcImpto: args.descrImpto==="No tiene impuesto"?null:args.porcImpto,
            descrClaseServ: args.descrClaseServ,
          }
          const response = await this.props.editOtrosPagCl({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOtrosPagCl;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allOtrosPagCl.refetch()
            this.estadosFalse()
            this.setState({showOtrosPagCl: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteOtrosPagCl({
            variables: argsDel
          });
          this.props.allOtrosPagCl.refetch()
          this.estadosFalse()
          this.setState({showOtrosPagCl: true})
        }
      }
    }
  }

  handleOficina = async (ev, args)=>{
    if(!args.descrOficina||!args.dirOficina){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrOficina){
        argsAdd['descrOficina'] = "";
        errors.push({path: 'descrOficina', message: "Debe escribir la descripción de la oficina"});
      }
      if(!args.dirOficina){
        argsAdd['dirOficina'] = "";
        errors.push({path: 'dirOficina', message: "Debe escribir la dirección de la oficina"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addOficina){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        let argsCreate = args
        argsCreate.fechaCreate = fechaHoraHoy

        // console.log(argsCreate)
        response = await this.props.createOficina({
          variables: argsCreate
        });
        const {errors, success} = response.data.createOficina;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrOficina = document.getElementById("descrOficina");
          descrOficina.value = ""
          var dirOficina = document.getElementById("dirOficina");
          dirOficina.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allOficina.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          document.body.style.cursor = 'wait'
          const argsUpd = {
            _id: args._id,
            descrOficina: args.descrOficina,
            descrOficinaAnt: args.descrOficinaAnt,
            dirOficina: args.dirOficina,
          }
          const response = await this.props.editOficina({
            variables: argsUpd
          });
          const {errors, success} = await response.data.editOficina;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allOficina.refetch()
            this.estadosFalse()
            this.setState({showOficina: true})
          }
          document.body.style.cursor = 'default'
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            descrOficina: args.descrOficina
          }
          const response = await this.props.deleteOficina({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteOficina;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allOficina.refetch()
            this.estadosFalse()
            this.setState({showOficina: true})
          }
        }
      }
    }
  }

  handleSegmento = async (ev, args)=>{
    if(!args.codigoSegmento||!args.descrSegmento){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoSegmento){
        argsAdd['codigoSegmento'] = "";
        errors.push({path: 'codigoSegmento', message: "Debe escribir el código"});
      }
      if(!args.descrSegmento){
        argsAdd['descrSegmento'] = "";
        errors.push({path: 'descrSegmento', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addSegmento){
        const response = await this.props.createSegmento({
          variables: args
        });
        const {errors, success} = response.data.createSegmento;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoSegmento = document.getElementById("codigoSegmento");
          var descrSegmento = document.getElementById("descrSegmento");
          codigoSegmento.value = ""
          descrSegmento.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allSegmento.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            codigoSegmento: args.codigoSegmento,
            descrSegmento: args.descrSegmento,
          }
          const response = await this.props.editSegmento({
            variables: argsUpd
          });
          const {errors, success} = response.data.editSegmento;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allSegmento.refetch()
            this.estadosFalse()
            this.setState({showSegmento: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            codigoSegmento: args.codigoSegmento
          }
          const response = await this.props.deleteSegmento({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteSegmento;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allSegmento.refetch()
            this.estadosFalse()
            this.setState({showSegmento: true})
          }
        }
      }
    }
  }

  handlePaquete = async (ev, args)=>{
    if(!args.codigoPaquete||!args.descrPaquete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoPaquete){
        argsAdd['codigoPaquete'] = "";
        errors.push({path: 'codigoPaquete', message: "Debe escribir el código"});
      }
      if(!args.descrPaquete){
        argsAdd['descrPaquete'] = "";
        errors.push({path: 'descrPaquete', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPaquete){
        const response = await this.props.createPaquete({
          variables: args
        });
        const {errors, success} = response.data.createPaquete;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoPaquete = document.getElementById("codigoPaquete");
          var descrPaquete = document.getElementById("descrPaquete");
          codigoPaquete.value = ""
          descrPaquete.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPaquete.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            codigoPaquete: args.codigoPaquete,
            descrPaquete: args.descrPaquete,
          }
          const response = await this.props.editPaquete({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPaquete;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPaquete.refetch()
            this.estadosFalse()
            this.setState({showPaquete: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            codigoPaquete: args.codigoPaquete
          }
          const response = await this.props.deletePaquete({
            variables: argsDel
          });
          const {errors, success} = response.data.deletePaquete;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPaquete.refetch()
            this.estadosFalse()
            this.setState({showPaquete: true})
          }
        }
      }
    }
  }

  handleTipoAju = async (ev, args)=>{
    if(!args.descrTipoAju){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrTipoAju){
        argsAdd['descrTipoAju'] = "";
        errors.push({path: 'Tipo Ajuste', message: "Debe escribir el tipo de ajuste"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTipoAju){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        let argsCreate = args
        argsCreate.fechaCreate = fechaHoraHoy

        // console.log(argsCreate)
        response = await this.props.createTipoAju({
          variables: argsCreate
        });
        const {errors, success} = response.data.createTipoAju;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrTipoAju = document.getElementById("descrTipoAju");
          descrTipoAju.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTipoAju.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrTipoAju: args.descrTipoAju,
          }
          const response = await this.props.editTipoAju({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoAju;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoAju.refetch()
            this.estadosFalse()
            this.setState({showTipoAju: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteTipoAju({
            variables: argsDel
          });
          this.props.allTipoAju.refetch()
          this.estadosFalse()
          this.setState({showTipoAju: true})
        }
      }
    }
  }

  handleListaGral = (ev, seleccLista) => {
    const argsAdd = this.state.argsAdd
    argsAdd[seleccLista] = ev.target.value
    this.setState({argsAdd});
    // console.log(argsAdd)
  }

  handleTipoOSOS = () => {
    var miLista = document.getElementById("miListaOS");
    const argsAdd = this.state.argsAdd
    argsAdd['_idTipoOS'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoTipoOS'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrTipoOS'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrTipoOS'] = "Seleccionar..."
    }
    // console.log(argsAdd)
    this.setState({argsAdd});
  }
  
  handleTipoOSCateg = () => {
    var miLista = document.getElementById("miListaCateg");
    const argsAdd = this.state.argsAdd
    argsAdd['descrCategOST'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleCicloFactCl = () => {
    var miLista = document.getElementById("miListaCF");
    const argsAdd = this.state.argsAdd
    argsAdd['cicloFact'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleTipoDocCl = () => {
    var miLista = document.getElementById("miListaTD");
    const argsAdd = this.state.argsAdd
    argsAdd['_idTipoDoc'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoTipoDoc'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrTipoDoc'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrTipoDoc'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleTipoClCl = () => {
    var miLista = document.getElementById("miListaTC");
    const argsAdd = this.state.argsAdd
    // console.log(argsAdd)
    // argsAdd['_idTipoCl'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoTipoCliente'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrTipoCliente'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrTipoCliente'] = "Seleccionar..."
    }
    // console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleGrAfCl = () => {
    var miLista = document.getElementById("miListaGA");
    const argsAdd = this.state.argsAdd
    argsAdd['_idGrupoAf'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoGrupoAfin'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrGrupoAfin'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrGrupoAfin'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleEstrCl = () => {
    var miLista = document.getElementById("miListaEstr");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEstrato'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSeg = () => {
    var miLista = document.getElementById("miListaSeg");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoSegmento'] =  miLista.options[miLista.selectedIndex].value
    argsAdd['descrSegmento'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleImptoOP = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoImpto'] = miLista.options[miLista.selectedIndex].value
    argsAdd['porcImpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
    if(miLista.options[miLista.selectedIndex].text==="No tiene impuesto"){
      argsAdd['descrImpto'] = "No tiene impuesto"
    }else{
      argsAdd['descrImpto'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }
      this.setState({argsAdd});
  }

  handleClaseOP = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrClaseServ'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_idClaseserv'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoClaseServ'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleListaInfAdic = () => {
    let miLista = document.getElementById("miListaInfAdic");
    const argsAdd = this.state.argsAdd
    argsAdd['infAdic1'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    this.setState({idLista: idLista})
    const argsBuscCliOS = this.state.argsBuscCliOS
    argsBuscCliOS['contrato'] = idLista.contrato
    this.setState({argsBuscCliOS});
// console.log(idLista)
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showClient) {
      this.setState({verCliente: true})
    }
    if (this.state.showTipocli) {
      this.setState({verTipocli: true})
    }
    if (this.state.showGrupoaf) {
      this.setState({verGrupoaf: true})
    }
    if (this.state.showTipodoc) {
      this.setState({verTipodoc: true})
    }
    if (this.state.showCicloFact) {
      this.setState({verCicloFact: true})
    }
    if (this.state.showOtrosPagCl) {
      this.setState({verOtrosPagCl: true})
    }
    if (this.state.showOficina) {
      this.setState({verOficina: true})
    }
    if (this.state.showSegmento) {
      this.setState({verSegmento: true})
    }
    if (this.state.showPaquete) {
      this.setState({verPaquete: true})
    }
    if (this.state.showTipoAju) {
      this.setState({verTipoAju: true})
    }

    // if (this.state.showUser) {
    //   this.setState({verUsuario: true})
    // }
  };

  handleClickView = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickHistFinanc = async (ev) => {
    ev.preventDefault()

//ej de jspdf utilizando fromHTML => funciona pero en el pdf la table sale muy mal
    // var doc = new jsPDF({orientation: 'portrait', unit: 'pt', format: 'letter'})
    // let margins = {top: 80, bottom: 60, left: 40, width: 522}
    // var source = document.getElementById("histFinanciera");
    // var specialElementHandlers = {
    //   '#editor': function(element, renderer){return true;}
    // };
    // doc.fromHTML(
    //   source,
    //   margins.left,
    //   margins.top,
    //   {'width': margins.width, 'elementHandlers': specialElementHandlers})
    // doc.save('prueba1.pdf')

    let argsBuscarMC={}
    argsBuscarMC.orden='-_id'
    if(this.state.argsBuscCliOS.contrato){
      argsBuscarMC.contrato=this.state.argsBuscCliOS.contrato
    }else{
      argsBuscarMC.contrato=null
    }

    await this.props.allMovClientes.refetch(argsBuscarMC)
    await this.props.allMovClientesCC.refetch(argsBuscarMC)
    await this.props.allProgServ.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: true,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickHistPago = async (ev, args) => {
    ev.preventDefault()

    let argsBuscarMC={}
    // argsBuscarMC.orden='_id'
    argsBuscarMC.orden='-_id'
    // if(this.state.argsBuscCliOS.contrato){
    //   argsBuscarMC.contrato=this.state.argsBuscCliOS.contrato
    // }else{
    //   argsBuscarMC.contrato=null
    // }
    argsBuscarMC.contrato=args.contrato

    await this.props.getPagoCliente.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: true,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickProgNvoServ = async (ev, args) => {
    let argsBuscarPS={}
    if(this.state.argsBuscCliOS.contrato){
      argsBuscarPS = {contrato: this.state.argsBuscCliOS.contrato, procesado: "N"}
    }else{
      argsBuscarPS = {contrato: "XYZ123", procesado: "N"}
    }
    await this.props.allProgServ.refetch(argsBuscarPS)
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: true,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickHistFact = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    // argsBuscarMC.orden='numeroFra'
    argsBuscarMC.orden='-_id'
    // if(this.state.argsBuscCliOS.contrato){
    //   argsBuscarMC.contrato=this.state.argsBuscCliOS.contrato
    // }else{
    //   argsBuscarMC.contrato=null
    // }
    argsBuscarMC.contrato=args.contrato

    await this.props.allFacturacion1.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: true,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickHistCE = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    // argsBuscarMC.orden='numeroCE'
    argsBuscarMC.orden='-_id'

    argsBuscarMC.contrato=args.contrato

    await this.props.allCargoEsp1.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: true,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickHistNot = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    argsBuscarMC.orden='numeroNota'
    argsBuscarMC.contrato=args.contrato

    await this.props.allNotasDebCre.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: true,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickHistAj = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    argsBuscarMC.orden='-_id'
    argsBuscarMC.contrato=args.contrato

    await this.props.allAjuste.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: true,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }
  
  handlePyS = async (ev, idLista, empresa) => {
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha

    ImprPS(idLista, empresa, fechaHoraHoy)
  }
  
  handleImpContr = async (ev, idLista, empresa) => {
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha

    // await this.props.allOdeS.refetch({contrato: idLista.contrato})

// console.log(idLista, empresa, fechaHoraHoy)
    ImprContr(idLista, empresa, fechaHoraHoy)
  }

  handleClickNCPF = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    // argsBuscarMC.orden='numeroFra'
    argsBuscarMC.orden='-_id'
    argsBuscarMC.contrato=args.contrato

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: true,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickNDF = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    // argsBuscarMC.orden='numeroFra'
    argsBuscarMC.orden='-_id'
    argsBuscarMC.contrato=args.contrato

    await this.props.allFacturacion1.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: true,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickNCF = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    // argsBuscarMC.orden='numeroFra'
    argsBuscarMC.orden='-_id'
    argsBuscarMC.contrato=args.contrato

    await this.props.allFacturacion1.refetch(argsBuscarMC)

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: true,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickNCA = async (ev, args) => {
    ev.preventDefault()
    let argsBuscarMC={}
    // argsBuscarMC.orden='numeroFra'
    argsBuscarMC.orden='-_id'
    argsBuscarMC.contrato=args.contrato

    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: true,
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickAjP = async (ev, args) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: true,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickAjN = async (ev, args) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: true,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickMNF = async (ev, args) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: true,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickUpdDir = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: true,
      permiteDelete: false,
    })
  }

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: true,
      permiteUpdateDir: false,
      permiteDelete: false,
    })
  }

  handleClickDel = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteHistFinanc: false,
      permiteHistPago: false,
      permiteProgNvoServ: false,
      permiteHistFact: false,
      permiteHistCE: false,
      permiteHistNot: false,
      permiteHistAj: false,
      permiteNCPF: false,
      permiteNDF: false,
      permiteNCF: false,
      permiteNCA: false,  
      permiteAjP: false,
      permiteAjN: false,
      permiteMNF: false,
      permiteUpdate: false,
      permiteUpdateDir: false,
      permiteDelete: true,
    })
  }

  handleClickAddServ = async (ev, args)=>{
    console.log(args)
    console.log("Agregar un servicio seleccionado")

    // const argsUpd = {
    //   "_id": args._id,
    //   "_idServicio": "5b364201dd01c128a0b390a6",
    //   "codigoServicio" : "TVD",
    //   "nombreResumido" : "TV DIGITAL",
    //   "descripcionServicio" : "TELEVISION DIGITAL",
    //   "_idSubclaseServ" : "5b12cea12365ee148c10a07f",
    //   "codigoSubclaseServ" : "12",
    //   "descrSubclaseServ" : "TV Digital",
    //   "_idClaseServ" : "5b1174edeb417f15acc97a9a",
    //   "codigoClaseServ" : "1",
    //   "descrClaseServ" : "Television"
    //   }

    const argsUpd = {
      "_id": args._id,
      "_idServicio": args._idServicio,
      "codigoServicio" : args.codigoServicio,
      "nombreResumido" : args.nombreResumido,
      "descripcionServicio" : args.descripcionServicio,
      "_idSubclaseServ" : args._idSubclaseServ,
      "codigoSubclaseServ" : args.codigoSubclaseServ,
      "descrSubclaseServ" : args.descrSubclaseServ,
      "_idClaseServ" : args._idClaseServ,
      "codigoClaseServ" : args.codigoClaseServ,
      "descrClaseServ" : args.descrClaseServ
      }
  
  // const argsUpd = {
  //   _id: args._id,
  //   nombreCliente: args.nombreCliente,
  //   apellidoCliente: args.apellidoCliente,
  // }
  const response = await this.props.editClienteUpdDoc({
    variables: argsUpd
  });
  const {errors, success} = response.data.editClienteUpdDoc;
  if (!success){
    this.setState({errorAdd: errors})
    
  }else{
    console.log("Creó el aervicio ?")
  }
}

  handleClickDelServ = async (ev, args)=>{
    // console.log(args)
    // console.log("Eliminar un servicio seleccionado")

    const argsDel = {
      "_id": args._id,
      "_idServicio": args._idServicio,
    }
  // console.log(argsDel)
    const response = await this.props.deleteClienteUpdDoc({
      variables: argsDel
    });
    const {errors, success} = response.data.deleteClienteUpdDoc;
    if (!success){
      this.setState({errorAdd: errors})
      
    }else{
      console.log("Eliminó el aervicio ?")
    }
  }

handleRecPago = async (ev, args, listServTarRC, totRecibido, listaR, ajCero)=>{
  // console.log(listServTar)
// console.log(args)
// console.log(listServTarRC)
// console.log(listaR)
// console.log(this.state.idLista)
// const path = require('path');
// console.log("path.resolve() : ", path.resolve());
// console.log(ajCero)

// console.log(data.allClientes[0].saldoPendiente)
// let allClientes = await data.allClientes
// clienteSel = allClientes[0]

let errors = []

let saldoPendiente = -99999999
if(this.props.allClientes.allClientes){
  let {data} = await this.props.allClientes.refetch({contrato: args.contrato})
  saldoPendiente = await data.allClientes[0].saldoPendiente
}
if(saldoPendiente === -99999999){
  errors.push({path: 'Valor pagado', message: `Cargando la información del cliente`});
}else{
  // if(args.numSorteos){
  //   if(this.props.allClientesRtes.allClientesRtes){
  //     let numSorteos = []      
  //     let argsBuscarCL = `'contrato': {$ne: '${args.contrato}'}, numSorteos: '${args.numSorteos}'`
  //     argsBuscarCL = '{' + argsBuscarCL + '}'
  //     argsBuscarCL = {tipoqry: `[{$match: ${argsBuscarCL}}]`}
  //     // console.log(argsBuscarCL)
  //     let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
  //     numSorteos = await data.allClientesRtes
  //     if(numSorteos.length>0){
  //       errors.push({path: '# para Sorteos', message: `El cliente ${numSorteos[0].contrato} ya tiene asignado el # para Sorteos ${args.numSorteos}` });
  //     }
  //   }
  // }
  if(!args.descrOficina||args.descrOficina==="Todas..."||args.descrOficina==="Seleccionar..."){
    errors.push({path: 'Oficina', message: `Por favor seleccione la Oficina` });
  }
}

//cuando tienen varias sesiones abiertas, en una hacen ajuste que cambia el saldo y en otra tenian
//cargada la pantalla de recibir pagos (el detalle esta antes del ajuste) => al hacer pago
//el detalle pend x pagar es diferente para solucionar =>
let pxp = 0
listServTarRC.forEach((elemento, ii) => {
  pxp += elemento.valorTotal - elemento.valorPagado
})
let listServTar = []
// console.log(pxp, saldoPendiente)
if(pxp!==saldoPendiente){
  // console.log(pxp, saldoPendiente)
  // errors.push({path: 'Valor pagado', message: `El saldo del cliente ha cambiado, por favor actualice la pantalla`});
  await this.props.allMovClientes.refetch({contrato: args.contrato})
  listServTar = await this.props.allMovClientes.allMovClientes
  listServTar = await listServTar.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
  let totRecib = totRecibido
  listServTar.forEach((elemento, i) => {
    if(elemento.valorTotal<0){
      totRecib -= elemento.valorTotal
      listServTar[i].valorRecibido = elemento.valorTotal
    }
  })
  listServTar.forEach((elemento, i) => {
    if(elemento.valorTotal>0){
      if(totRecib > elemento.valorTotal - elemento.valorPagado){
        totRecib -= (elemento.valorTotal - elemento.valorPagado)
        listServTar[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
      }else{
        listServTar[i].valorRecibido = totRecib
        totRecib = 0
      }
    }
  })
}else{
  listServTar = listServTarRC
}
//Fin controlar pxp

let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = [], argsUpd = {}

// console.log(listServTar)

  let totRecib = 0
  listServTar.forEach((elemento, i) => {
    if(elemento.valorTotal<0&&elemento.valorTotal!==elemento.valorRecibido){
      errors.push({path: 'Valor pagado', message: `Para el concepto ${elemento.descripcionServicio} debe descontar todo el valor ($${elemento.valorTotal}) `});
    }else{
      if(elemento.valorRecibido){
        if(elemento.valorRecibido<0&&elemento.valorTotal>0){
          errors.push({path: 'Valor pagado', message: `El valor del pago ${elemento.valorRecibido} no puede ser menor que cero`});
        }else{
          if(elemento.valorRecibido>elemento.valorTotal - elemento.valorPagado){
            errors.push({path: 'Valor pagado', message: `El valor del pago ${elemento.valorRecibido} no puede ser mayor que el pendiente por pagar ${elemento.valorTotal - elemento.valorPagado}`});
          }else{
            totRecib += parseInt(elemento.valorRecibido, 10)
          }
        }
      }
    }
  })
  if(totRecibido<=0){
    errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} debe ser mayor que cero`});
  }
  // if(totRecibido>saldoPendiente){
  //   errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} es mayor al saldo pendiente ${saldoPendiente}`});
  // }
  // if(totRecib!==totRecibido){
  if(totRecibido<=saldoPendiente&&totRecib!==totRecibido){
    errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} no coincide con el valor relacionado en el detalle por pagar ${totRecib}`});
  }
  if(totRecibido>saldoPendiente&&totRecib!==saldoPendiente&&saldoPendiente>0){
    errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} es mayor al valor relacionado en el detalle por pagar ${totRecib}, debe quedar pago todo el detalle relacionado como pendiente por pagar o el saldo pendiente acaba de ser modificado por otro movimiento`});
  }

  this.setState({errorAdd: errors})

//PARA CONTROLAR QUE NO SE ENTRE A RECIBIR PAGOS POR OPCIONES DIFERENTES A ENTRADA DEL USUARIO
//ESTO PORQUE SE ESTAN CREANDO PAGOS DUPLICADOS
  let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
  let horaEntrada = new Date().getTime();
  let difHoraEntrada = 3000
  if(horaEntradaAnt){
    // console.log(horaEntradaAnt)
    difHoraEntrada = horaEntrada - horaEntradaAnt
  }else{
    difHoraEntrada = 12000
  }

  let aleatorio1 = sessionStorage.getItem('aleatorio1')
  let aleatorio2 = sessionStorage.getItem('aleatorio2')
  if(errors.length===0&&difHoraEntrada>10000&&aleatorio1!==aleatorio2){
    sessionStorage.setItem("horaEntrada", horaEntrada);
    sessionStorage.setItem("aleatorio2", aleatorio1);

    let mayorValPag = 0
    let listColecc = listServTar.map(recpago => ({...recpago}))

    let numeroRC = await this.nextVal('reccajas')
    numeroRC = numeroRC.toString()

    if(totRecibido>saldoPendiente){
//traer clase si todos los servicios de la tarifa son d la misma clase
      let claseServSig = "NoDefinida", claseServSig1 = ""
      if(this.state.idLista.tarifa.codigoTarifa){
        claseServSig1 = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        claseServSig = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        this.state.idLista.tarifa.servicios.forEach((elemento, _id) => {
          if(claseServSig1!==claseServSig){
            claseServSig = "NoDefinida"
          }
        })
      }
// console.log(claseServSig)

      if(saldoPendiente>=0){
        mayorValPag = totRecibido - saldoPendiente
      }else{
        mayorValPag = totRecibido
      }
      argsUpd = {
        // "idMovClientes": "0",
        "contrato": args.contrato,
        "codigoServicio": "MAYPAG",
        "nombreResumido": "Mayor valor pagado",
        "descripcionServicio": "Mayor valor pagado",
        "descrClaseServ": claseServSig,
        "concepto": "Mayor valor pagado",
        "periodo": "",
        "valorTotal": mayorValPag,
        "valorRecibido": mayorValPag,
        "numeroOdeDX": 0,
        "procesado": "S",
      }
      listColecc.push(argsUpd)
    }
    // console.log(listServTar)
    // console.log(listColecc)

    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let fechaHoy = fechaHoraHoy.substr(0, 10)
    let horaHoy = fechaHoraHoy.substr(11, 8)
    // let fechaHoy = new Date()
    // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
// console.log(horaHoy)
// console.log(fechaHoy + ' ' + horaHoy)
    let argsAdd = args
    // let numeroRC = await this.nextVal('reccajas')
    let creaColecc = [], movColecc = []

    let numDX = this.state.idLista.numeroOdeDX
    let saldoCl = parseInt(saldoPendiente, 10) - parseInt(totRecibido, 10)
    let saldoClRC = parseInt(saldoPendiente, 10) - parseInt(totRecibido, 10)

    let saldoClAjCero = saldoCl, hacerAjCero = false
    if(Math.abs(saldoCl)<=ajCero&&saldoCl!==0&&ajCero>0){
//Ajuste a CERO por parametro ajCero
      saldoClAjCero = 0
      hacerAjCero = true
    }
// console.log(saldoClAjCero, hacerAjCero)
    argsAdd['saldoPendiente'] = saldoCl
    argsAdd['fechaPago'] = fechaHoy
    // if(argsAdd.numeroRT){
    //   argsAdd['tipo'] = "PT"
    //   argsAdd['descripcionPago'] = "Pago en tercero"
    // }else{
      argsAdd['tipo'] = "PO"
      argsAdd['descripcionPago'] = "Pago en oficina"
    // }
    argsAdd['numeroRC'] = numeroRC
    argsAdd['documento'] = numeroRC
    argsAdd['valorTotal'] = totRecibido
    argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
    argsAdd['usuarioCreate'] = sessionStorage.getItem('userLogin')
    if(!argsAdd.valorEf){
      argsAdd['valorEf'] = 0
    }
    creaColecc.push(argsAdd)
    // console.log(argsAdd)

    listColecc.forEach((elemento1, ii) => {
      if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
        argsUpd = {
          "contrato": args.contrato,
          "tipoAct": ii===0?"CreardetallePC1":"CreardetallePC2",
          "idMovClientes": elemento1._id,
          "codigoServicio": elemento1.codigoServicio,
          "nombreResumido": elemento1.nombreResumido,
          "descripcionServicio": elemento1.descripcionServicio,
          "descrClaseServ": elemento1.descrClaseServ,
          "concepto": elemento1.concepto,
          "periodo": elemento1.periodo,
          "valorTotal": elemento1.valorTotal,
          "valorDetalle": elemento1.valorRecibido,
        }
        movColecc.push(argsUpd)
        // console.log(argsUpd)
      }
    })
    // console.log(movColecc)
    // Actualiza numSorteos
    // if(args.numSorteos){
    //   let editNumSorteos = []
    //   argsUpd = {
    //     "accionBD": this.props.editCliente,
    //     "tipoAct": "EditarNumSorteos",
    //     "contrato": args.contrato,
    //     "numSorteos": args.numSorteos,
    //   }
    //   editNumSorteos.push(argsUpd)
    //   // console.log(editNumSorteos[0])
    //   await this.props.editCliente({
    //     variables: editNumSorteos[0]
    //   });
    // }
    // FIN Actualiza numSorteos

    // Actualiza email, telefono 1 y fecha de cumpleaños
    // if(datosConfirmados){
      // console.log(args)
      let editDatosBas = []
      argsUpd = {
        "accionBD": this.props.editCliente,
        "tipoAct": "EditarDatosBas",
        "contrato": args.contrato,
        "telefono1": args.telefono1,
        "eMail": args.eMail,
        "fechaCumple": !args.fechaCumple?null:args.fechaCumple,
      }
      editDatosBas.push(argsUpd)
      // console.log(editDatosBas[0])
      await this.props.editCliente({
        variables: editDatosBas[0]
      });
    // }
    // FIN Actualiza email, telefono 1 y fecha de cumpleaños
    
    //CREA REGISTRO EN HISTCLIENTES
    let creaHC = []
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": args.contrato,
      "movimiento": "Pago",
      "descripcion": "Oficina",
      "detalle": "A saldo pendiente",
      "relacion": numeroRC,
      "valor": totRecibido,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)
// console.log(argsAddHC, creaHC)
    // let mayorValPag = 0
    // if(totRecibido>saldoPendiente){
    //   mayorValPag = totRecibido - saldoPendiente

    //   let argsUpd = {
    //     "contrato": args.contrato,
    //     "tipoAct": movColecc.length===0?"CreardetallePC1":"CreardetallePC2",
    //     // "idMovClientes": elemento1._id,
    //     "codigoServicio": "MAYPAG",
    //     "nombreResumido": "Mayor valor pagado",
    //     "descripcionServicio": "Mayor valor pagado",
    //     "descrClaseServ": "Mayor valor pagado",
    //     "concepto": "Mayor valor pagado",
    //     "periodo": "",
    //     "valorTotal": mayorValPag,
    //     "valorDetalle": mayorValPag,
    //   }
    //   movColecc.push(argsUpd)
    // }
    // console.log(listColecc)
    // console.log(movColecc)

//Crear el pago y su detalle
    numDocCRUD = 0
    totDocCRUD = movColecc.length + 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editPagoClientesUpdDoc)
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'SI_ID'
    crudColecc[numDocCRUD] = this.props.createPagoClientes

    numDocCRUD += 1

    movColecc.forEach((elemento1, ii) => {
      argsCrud[numDocCRUD] = elemento1
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
    })

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
    await this.updColecc(crudColecc, argsCrud, totDocCRUD)

//Crear el registro en histclientes
    let creaHCMany = [], creaHCMany1 = []
    // console.log(creaHC)
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})
// console.log(creaHCMany, creaHCMany1)
    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createHistClienteMany)
    }

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
    await this.updColecc(crudColecc, argsCrud, totDocCRUD)


//actualizar saldo en clientes
//crear mov de pago en movclientes
//actualizar valor pagado en movclientes
    let estCl = this.state.idLista.estadoCliente
    let ultFRX = this.state.idLista.fecgaUltRX

    let actColecc = [], movCli = [], movCliRX = [], actServCli = []
    // creaColecc = []
    movColecc = []
//se pasa despues de verificar si se crean movcliente de RX por DX masiva porque afecta el saldo y estado
    // let argsUpd = {
    //   "tipoAct": "EditarCliOdeS",
    //   "_id": this.state.idLista._id,
    //   "estadoCliente": estCl,
    //   "cargoMensual": this.state.idLista.cargoMensual,
    //   "saldoPendiente": saldoCl,
    // }
    // actColecc.push(argsUpd)

    argsAdd = {
      "contrato": args.contrato,
      "fechaMov": fechaHoy,
      "tipo": "D",
      "subTipo": "PO",
      "procesado": "S",
      "origen": "Pago en oficina",
      "saldoCliente": saldoCl,
      "valorTotal": totRecibido,
      "valorAntesImptos": totRecibido,
      "numeroRC": numeroRC,
      "documento": numeroRC,
      "valorPagado": totRecibido,
      "fechaUltPago": fechaHoy,
      "valorUltPago": totRecibido,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
      "fechaCreate": fechaHoraHoy,
    };
    // creaColecc.push(argsAdd)
    movCli.push(argsAdd)
    // console.log(argsAdd)

    let valorparaPermRX = this.props.getParametro.getParametro.valorparaPermRX
    let hacerRX = true
    if(numDX===0){
      hacerRX = false
    }
// console.log(listServTar)
// console.log(numDX)
// console.log(estCl)
    listServTar.forEach((elemento1, ii) => {
      // console.log(elemento1)
      // console.log("22", numDX, elemento1.numeroOdeDX, elemento1.valorRecibido, elemento1.valorPagado, elemento1.valorTotal, hacerAjCero)
      if(numDX>0&&elemento1.numeroOdeDX>0&&(!elemento1.valorRecibido||elemento1.valorRecibido===0)&&
        elemento1.valorTotal>0&&!hacerAjCero){
          // console.log(elemento1.valorTotal)
        hacerRX = false
      }
      if((elemento1.valorRecibido&&elemento1.valorRecibido!==0) || hacerAjCero){
        let valPagado = 0
        if(elemento1.valorPagado){
          valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
        }else{
          valPagado = parseInt(elemento1.valorRecibido, 10)
        }
        let valParaHacerRX = parseInt(valPagado, 10) + parseInt(valorparaPermRX, 10)
        // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal, hacerAjCero)
        // if(numDX>0&&elemento1.numeroOdeDX>0&&valPagado<elemento1.valorTotal&&elemento1.valorTotal>0&&!hacerAjCero){
        if(numDX>0&&elemento1.numeroOdeDX>0&&valParaHacerRX<elemento1.valorTotal&&elemento1.valorTotal>0&&!hacerAjCero){
          // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal, hacerAjCero)
          hacerRX = false
        }

        let valorPagadoDet = valPagado, valorPendienteDet = elemento1.valorTotal - valPagado
        if(hacerAjCero){
          //Ajuste a CERO por parametro ajCero
          valorPagadoDet = elemento1.valorTotal
          valorPendienteDet = 0
        }
  
        argsUpd = {
          "contrato": args.contrato,
          "_id": elemento1._id,
          "procesado": elemento1.procesado,
          "concepto": elemento1.concepto,
          "numeroFra": elemento1.numeroFra,
          "numeroRC": elemento1.numeroRC,
          "numeroCE": elemento1.numeroCE,
          "numeroOdeDX": elemento1.numeroOdeDX,
          "documento": elemento1.documento,
          "fechaUltPago": fechaHoy,
          "valorUltPago": elemento1.valorRecibido,
          "valorPagado": valorPagadoDet,
          "valorPendiente": valorPendienteDet
        }
        // console.log(argsUpd)
        movColecc.push(argsUpd)
      }
    })
    // console.log(hacerRX, saldoCl)
    // console.log(movColecc)
    if(hacerRX){
      //PROCESO CREAR DOCUM DE CARGUE EN MOVIMCLIENTE POR DX
      // console.log(this.props.getParametro.getParametro.comoAsigCargosAlCliente)
      // console.log(saldoCl)
      let saldoClCC = saldoCl

      // let fechaHoy = new Date()
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)

      //traer el número de días del mes
      const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
      const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1

      let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
      let diaFra= parseInt(fechaHoy.substr(8, 2), 10)
      let periodoFrado = ""
      // let numServ=0

      let elemento3 = []
      let difSaldoNeg = 0, valorPagNeg = 0
      //verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
      //los cargos positivos
      if(this.state.idLista.tarifa.codigoTarifa){
        elemento3 = this.state.idLista.tarifa
        elemento3.servicios.forEach((elemento1, i) => {
          if(elemento1.estadoServicio==="D"){
            let numDNvo = numDM - ddI
            let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
            
            if(valorServ<0){
              valorPagNeg += valorServ
            }
          }
        })
        if(saldoCl<(valorPagNeg * -1)){
          difSaldoNeg = (valorPagNeg * -1) - saldoCl
        }
      }

      // console.log("Hacer RX")
      let agnoFra = fechaHoy.substr(0, 4)
      let mesFra = fechaHoy.substr(5, 2)

      elemento3 = []

      // listServTar.forEach((elemento, ii) => {
      //   if(numDX>0&&elemento.numeroOdeDX>0){
      if(this.state.idLista.tarifa.codigoTarifa){
        elemento3 = this.state.idLista.tarifa
        // console.log(elemento3)
        elemento3.servicios.forEach((elemento1, i) => {
          // if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
          if(elemento1.estadoServicio==="D"){
            //Si esta DX => crear movcliente => siempre carga porque al dx se le descontó
            // let listServCargoFra = []
            let numDNvo = numDM - ddI
            let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
            let valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)

            let valorPag = 0
            if(difSaldoNeg>0&&valorServ>0){
              if(difSaldoNeg-valorServ>=0){
                valorPag = valorServ
              }else{
                valorPag = difSaldoNeg
              }
              difSaldoNeg -= valorPag
            }

            if(saldoCl<0&&valorServ>0){
              if(saldoCl+valorServ>0){
                valorPag = saldoCl * -1
              }else{
                valorPag = valorServ
              }
            }
            if(valorServ<0){
              valorPag = valorServ
            }                

            periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
            periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM

            let numServ = elemento1.numeroServicios

            if(numServ!==0){
              let imptosServ = elemento1.imptos.map(impto => ({
                ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
    
              if(valorServ!==0){
                // listServCargoFra.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
                //   codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                //   _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                //   descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                //   codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                //   numeroServicios: numServ, valorServicios: valorServ, imptos: imptosServ,
                //   agnoFra: agnoFra, mesFra: mesFra, fechaCargo: fechaHoy, periodoFrado: periodoFrado,
                //   valorAntesImptos: valorAntesI,
                //   _id: i
                // });

                //CREA REGISTRO EN movclientes
                saldoCl += valorServ
                argsUpd = {}

                let movCliI = [], actCargoFra = []
                argsUpd = {}
                imptosServ.forEach((elementoI, ii) => {
                  if(elementoI.codigoImpto!==null){
                    argsUpd = {
                      "codigoImpto": elementoI.codigoImpto,
                      "descrImpto": elementoI.descrImpto,
                      "porcImpto": elementoI.porcImpto,
                      "valorImpto": elementoI.valorImpto,
                    }
                    movCliI.push(argsUpd)
                  }
                })

                //PARA CUANDO SE FACTURA UN MES ANTERIOR
                let ultMF = ""
                let tieneMCCMesAnt = true
                let lista8CC = this.props.allMovClientesCC.allMovClientesCC

                let agno = fechaHoy.substr(0, 4)
                let mes = fechaHoy.substr(5, 2)

                let ultPF = this.props.allProcFact1.allProcFact.filter(elemento => elemento.cicloFact===this.state.idLista.cicloFact)
                if(ultPF.length>0){
                  ultMF = ultPF[ultPF.length-1].mes
                }
                let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
                // console.log(difmesesUMF)
                //Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
                //en movcliccs
                if(difmesesUMF>1){
                  let mesMA = parseInt(mes, 10)
                  let agnoMA = agno
                  if(mes==="01"){
                    agnoMA = (parseInt(agno, 10) - 1).toString()
                    mesMA = "12"
                  }else{
                    mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                  }
                  // console.log(agnoMA + "-" + mesMA)
                  let indexFrado = lista8CC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
                  if(indexFrado===-1){
                    //NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
                    //como NO FACTURAR
                    tieneMCCMesAnt = false
                  }  
                }

                //verificar si NO tiene mov en el mes ant
                if(!tieneMCCMesAnt){
                //verificar si esta des, sus o ret, la os lo va a pasar a act
                  if(this.state.idLista.estadoCliente==="DESCONECTADO"||this.state.idLista.estadoCliente==="SUSPENDIDO"||
                      this.state.idLista.estadoCliente==="RETIRADO"){
                    //crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
                    //esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
                    let fechaHoyMA = new Date()
                    let agnoMA = (fechaHoyMA.getFullYear()).toString()
                    let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
                    mesMA = parseInt(mesMA, 10)
                    if(mesMA==="01"){
                      agnoMA = (parseInt(agnoMA, 10) - 1).toString()
                      mesMA = "12"
                    }else{
                      mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                    }
                    // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
                    let periodoFradoMA = "NO FACTURAR"
                    // let pruebaFMA =[]
                    // pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,

                    argsUpd = {}
                    argsUpd = {
                      "contrato": args.contrato,
                      "fechaMov": fechaHoy,
                      "tipo": "C",
                      "subTipo": "RX",
                      "procesado": "N",
                      "codigoServicio": elemento1.codigoServicio,
                      "nombreResumido": elemento1.nombreResumido,
                      "descripcionServicio": elemento1.descripcionServicio,
                      "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                      "periodo": periodoFradoMA,
                      "origen": "DX-" + this.state.idLista.numeroOdeDX,
                      "saldoCliente": saldoCl,
                      "valorTotal": 0,
                      "valorAntesImptos": 0,
                      "agno": agnoMA,
                      "mes": mesMA,
                      "valorPagado": 0,
                      // "valorPendiente": elemento1.valorTotal - valorPag,
                      "usuarioCreate": sessionStorage.getItem('userLogin'),
                      "imptos": []
                    };
                    actCargoFra.push(argsUpd)

                    // console.log(pruebaFMA)
                    // console.log(listServCargoFra)
                  }
                }
                //FIN PARA CUANDO SE FACTURA UN MES ANTERIOR

                argsUpd = {}
                argsUpd = {
                  "contrato": args.contrato,
                  "fechaMov": fechaHoy,
                  "tipo": "C",
                  "subTipo": "RX",
                  "procesado": "N",
                  "codigoServicio": elemento1.codigoServicio,
                  "nombreResumido": elemento1.nombreResumido,
                  "descripcionServicio": elemento1.descripcionServicio,
                  "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                  "periodo": periodoFrado,
                  "origen": "DX-" + this.state.idLista.numeroOdeDX,
                  "saldoCliente": saldoCl,
                  "valorTotal": valorServ,
                  "valorAntesImptos": valorAntesI,
                  "agno": agnoFra,
                  "mes": mesFra,
                  "valorPagado": valorPag,
                  // "valorPendiente": elemento1.valorTotal - valorPag,
                  "usuarioCreate": sessionStorage.getItem('userLogin'),
                  "imptos": movCliI
                };
                actCargoFra.push(argsUpd)
                // console.log(actCargoFra)
                // console.log("66")

                // //Verificar si el servicio tiene oferta
                // if(this.state.idLista.oferta.codigoOferta){
                //   let elemento3Of = this.state.idLista.oferta

                //   elemento3Of.servicios.forEach((elementoOf, i) => {
                //   // console.log(elementoOf)
                //     if(elementoOf.codigoServicio === elemento1.codigoServicio){
                //       let fechaInicial, fechaFinal
                //       !elementoOf.fechaInicioOferta?fechaInicial = fechaHoy:fechaInicial = elementoOf.fechaInicioOferta
                //       if(!elementoOf.fechaFinOferta){
                //         fechaFinal = new Date(elementoOf.fechaInicioOferta?elementoOf.fechaInicioOferta:fechaHoy)
                //         fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elementoOf.numDiasOferta, 10))
                //         fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
                //       }else{
                //         fechaFinal = elementoOf.fechaFinOferta
                //       }

                //       let fechaInicio = new Date(fechaInicial).getTime();
                //       let fechaFin    = new Date(fechaFinal).getTime();
                //       let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
                //       if(numdiApliOf>numDF){
                //         numdiApliOf = numDF
                //       }

                //       // listServOfAct.push({codigoOferta: elemento3Of.codigoOferta, descrOferta: elemento3Of.descrOferta,
                //       //   codigoServicio: elementoOf.codigoServicio, nombreResumido: elementoOf.nombreResumido, descripcionServicio: elementoOf.descripcionServicio,
                //       //   _idSubclaseServ: elementoOf.subclaseserv._id, codigoSubclaseServ: elementoOf.subclaseserv.codigoSubclaseServ,
                //       //   descrSubclaseServ: elementoOf.subclaseserv.descrSubclaseServ, _idClaseServ: elementoOf.subclaseserv.claseserv._id,
                //       //   codigoClaseServ: elementoOf.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elementoOf.subclaseserv.claseserv.descrClaseServ,
                //       //   porcDctoOferta: elementoOf.porcDctoOferta, numDiasOferta: elementoOf.numDiasOferta,
                //       //   numdiApliOf: numdiApliOf, _id: i
                //       // });

                //       // console.log(elemento.codigoServicio)
                //       let valorDcto = 0
                //       let valorDctoAI = 0
                //       if(numDF===numdiApliOf){
                //         // console.log("of11")
                //         valorDcto = actCargoFra[0].valorTotal - (actCargoFra[0].valorTotal * elementoOf.porcDctoOferta / 100)
                //         valorDctoAI = actCargoFra[0].valorAntesImptos - (actCargoFra[0].valorAntesImptos * elementoOf.porcDctoOferta / 100)
                //       }else{
                //         // console.log("of22")
                //         valorDcto = (actCargoFra[0].valorTotal - (actCargoFra[0].valorTotal * elementoOf.porcDctoOferta / 100)) / numDF
                //         valorDcto = valorDcto * numdiApliOf
                //         valorDctoAI = (actCargoFra[0].valorAntesImptos - (actCargoFra[0].valorAntesImptos * elementoOf.porcDctoOferta / 100)) / numDF
                //         valorDctoAI = valorDctoAI * numdiApliOf
                //       }
                //       // const indexLis = actCargoFra.findIndex(codServ => codServ.codigoServicio === elemento2.codigoServicio);
                //       valorDcto = parseInt(valorDcto, 10)
                //       valorDctoAI = parseInt(valorDctoAI, 10)
                //       // console.log(valorDcto)
                //       if(valorDcto!==0){
                //         saldoCl += valorDcto - valorServ
                //         actCargoFra[0].valorTotal = valorDcto
                //         actCargoFra[0].valorAntesImptos = valorDctoAI
                //         actCargoFra[0].saldoCliente = saldoCl

                //         //Actualizar imptos con la oferta
                //         actCargoFra[0].imptos.forEach((elemento2, i) => {
                //           elemento2.valorImpto = Math.round(valorDctoAI * elemento2.porcImpto / 100)
                //         })
                //       }else{
                //         // if(indexLis!==-1){
                //         //pongo comentario porque no veo para que se elimina del array => ????
                //         // actCargoFra.splice(indexLis, 1);
                //         // }
                //       }
                //     }
                //   })
                // }
                // // console.log(actCargoFra)

                actCargoFra.forEach((elementoDX, ii) => {
                  if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                    movCliRX.push(elementoDX)
                  }else{
                    movCli.push(elementoDX)
                  }
                  // console.log("77")

                  argsUpd = {}
                  argsUpd['tipoAct'] = "EditarServDX"
                  argsUpd['contrato'] = args.contrato
                  argsUpd['tarifa'] = { codigoTarifa: this.state.idLista.tarifa.codigoTarifa, servicios: 
                                    [{"codigoServicio": elementoDX.codigoServicio,
                                      "estadoServicio": "A"}]}
                  actServCli.push(argsUpd)
                })
              }
            }
          }
        })
      }
      //   }
      // })
      // //FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
      if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
        saldoCl = saldoClCC
      }
      creaHC = []
      argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": args.contrato,
        "movimiento": "Pago",
        "descripcion": `Oficina`,
        "detalle": "Se hace RX por pago",
        "relacion": numeroRC,
        "valor": totRecibido,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      creaHC.push(argsAddHC)
      //Crear el registro en histclientes
      let creaHCMany = [], creaHCMany1 = []
      creaHC.forEach((elementoHC, ii) => {
        creaHCMany.push(elementoHC)
      })
      creaHCMany1.push({histcliente: creaHCMany})

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createHistClienteMany)
      }

      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createHistClienteMany

      // console.log(crudColecc)
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)
      // console.log(saldoCl)
    }

    // console.log(movCli.length, movCliRX.length)
    if(movCli.length>0){
      let actCli = [], actCliMany = [], movCliMany = [], movCliRXMany = [], actServCliMany = []

      let numOdeDX = 0
      if(!hacerRX&&this.state.idLista.numeroOdeDX>0){
        numOdeDX = this.state.idLista.numeroOdeDX
      }
      argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarCliDX",
        "contrato": args.contrato,
        "numeroOdeDX": numOdeDX,
      }
      actCli.push(argsUpd)
      actCli.forEach((elementoDX, ii) => {
        actCliMany.push(elementoDX)
      })
      movCli.forEach((elementoDX, ii) => {
        movCliMany.push(elementoDX)
      })
      movCliRX.forEach((elementoDX, ii) => {
        movCliRXMany.push(elementoDX)
      })
      actServCli.forEach((elementoDX, ii) => {
        actServCliMany.push(elementoDX)
      })

      let actCliMany1 = []
      actCliMany1.push({cliente: actCliMany})
      let movCliMany1 = [], movCliRXMany1 = []
      movCliMany1.push({movcliente: movCliMany})
      if(movCliRX.length>0){
        movCliRXMany1.push({movcliente: movCliRXMany})
      }
      let actServCliMany1 = []
      actServCliMany1.push({cliente: actServCliMany})

      numDocCRUD = 0
      if(movCliRX.length>0){
        totDocCRUD = 4
      }else{
        totDocCRUD = 3
      }
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createMovClientesMany)
      }

      argsCrud[numDocCRUD] = actCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actServCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

      numDocCRUD += 1

      if(movCliRX.length>0){
        argsCrud[numDocCRUD] = movCliRXMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createMovCliCCMany

        numDocCRUD += 1
      }

      argsCrud[numDocCRUD] = movCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createMovClientesMany

      // console.log(argsCrud)
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      // console.log(this.state.idLista.estadoCliente, hacerRX)
      if(this.state.idLista.estadoCliente!=="ACTIVO"&&hacerRX){
        estCl = "ACTIVO"
        ultFRX = fechaHoy
      }
    }

    //ACTUALIZAR DIASMORA
    //para calcular diasmora =>
    //diasMora = movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0
    // let movimDX1 = await listServTar.map(movim => ({
    //   ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0}))
    let actCli = [], fechaPH = null
    if(saldoCl>0){
      let fechaMora = new Date()
      fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
      let movimDX1 = await listServTar.map(movim => ({
        ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
      let fechaHoy1 = new Date()
      let diasHoy = fechaHoy1.getUTCDate()
      let mesHoy = fechaHoy1.getMonth()+1

      let diasMora = 0, diasMoraMayor = 0
      await movimDX1.forEach((movim, ii) => {
        // console.log(movim)
        diasMora = 0
        if(movim.pagueHasta&&movim.valorTotal>(movim.valorPagado+movim.valorRecibido)&&movim.valorTotal>0){
          if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&this.state.idLista.cargoMensual>0){
            //Math.ceil redondea al entero por encima
              let mesesM = Math.ceil((movim.valorTotal - (movim.valorPagado+movim.valorRecibido)) / this.state.idLista.cargoMensual)
              if(movim.codigoServicio==="SISTV"){
                diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
              }else{
                diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
              }
            // console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
          }else{
            diasMora = movim.diasMora
          }
        }
        if(diasMora>diasMoraMayor||(diasMora<0&&diasMoraMayor===0)){
          diasMoraMayor = diasMora
        }
      })
      if(diasMoraMayor!==0){
        let fechaInicio = new Date(fechaMora).getTime();
        let fechaFin = new Date(fechaInicio-(diasMoraMayor*1000*60*60*24)+(1000*60*60*24));
        fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
      }else{
        fechaPH = null
      }
    }else{
      fechaPH = null
    }
    argsUpd = {}
    argsUpd = {
      "tipoAct": "EditarCliPagueHasta",
      "contrato": this.state.idLista.contrato,
      "pagueHasta": fechaPH,
    }
    actCli.push(argsUpd)
    //FIN ACTUALIZAR DIASMORA

    argsUpd = {
      "tipoAct": "EditarCliOdeS",
      "_id": this.state.idLista._id,
      "estadoCliente": estCl,
      "cargoMensual": this.state.idLista.cargoMensual,
      "saldoPendiente": saldoClAjCero,
    }
    actColecc.push(argsUpd)

    // console.log(this.state.idLista)

    let actFechas = []
    argsUpd = {
      "tipoAct": "EditarFechCli",
      "_id": this.state.idLista._id,
      "fechaUltOSAb": this.state.idLista.fechaUltOSAb,
      "fechaPrimeraActivacion": this.state.idLista.fechaPrimeraActivacion,
      "fechaUltDX": this.state.idLista.fechaUltDX,
      "fecgaUltRX": ultFRX,
      "estadoAnterior": this.state.idLista.estadoAnterior,
      "fechaUltOSCe": this.state.idLista.fechaUltOSCe,
      "fechaUltPago": fechaHoy,
      "valorUltPago": totRecibido,
    }
    actFechas.push(argsUpd)

//Actualizar BD
    numDocCRUD = 0
    // totDocCRUD = movColecc.length + 2
    totDocCRUD = movColecc.length + 3
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editMovClientes)
    }

    argsCrud[numDocCRUD] = actFechas[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    numDocCRUD += 1

    argsCrud[numDocCRUD] = actCli[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    numDocCRUD += 1

// console.log(movColecc)
    movColecc.forEach((elemento1, ii) => {
      argsCrud[numDocCRUD] = elemento1
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
    })

    argsCrud[numDocCRUD] = actColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    // numDocCRUD += 1


    // console.log(crudColecc)
    // console.log(argsCrud)
    // console.log(totDocCRUD)
    await this.updColecc(crudColecc, argsCrud, totDocCRUD)

//revisar si paga o descuenta mov no facturados
let valorAFact = 0
listServTar.forEach((elemento1, ii) => {
  if(elemento1.procesado==="N"&&elemento1.valorRecibido&&elemento1.valorRecibido!==0&&
      elemento1.subTipo!=="CE"){
    valorAFact += elemento1.valorTotal
  }
})
//
// console.log(args._idRango)
if(valorAFact!==0&&args._idRango){
//calcula el valor total de lo no facturado
  valorAFact = 0
  listServTar.forEach((elemento1, ii) => {
    if(elemento1.procesado==="N"&&elemento1.subTipo!=="CE"){
      valorAFact += elemento1.valorTotal
    }
  })
}
// console.log(valorAFact)
if(valorAFact>0&&args._idRango){
  console.log("entro a fact")
  //FACTURAR MOVIMIENTOS NO FACTURADOS
  let listServDetFra = [];
  let valorAntesImptos = 0
  let valorFacturado = 0
  let argsUpdDet
  let proxFact = await this.nextValFra(args._idRango)

  let agnoFra = fechaHoy.substr(0, 4)
  let mesFra = fechaHoy.substr(5, 2)

  let movFras = [], creaFra = [], actmovCli = []

  listServTar.forEach((elemento1, ii) => {
    if(elemento1.procesado==="N"&&elemento1.subTipo!=="CE"){
      const valorServ = elemento1.valorTotal
      const valorAntesI = elemento1.valorAntesImptos
      if(valorServ!==0){
        valorAntesImptos += valorAntesI
        valorFacturado += valorServ

        listServDetFra.push({codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
          descripcionServicio: elemento1.descripcionServicio, descrClaseServ: elemento1.descrClaseServ,
          numeroCE: elemento1.numeroCE, numeroRC: elemento1.numeroRC, valorPagado: elemento1.valorPagado,
          fechaUltPago: elemento1.fechaUltPago, valorUltPago: elemento1.valorUltPago,
          numeroOdeDX: elemento1.numeroOdeDX, valorServicios: valorServ, imptos: elemento1.imptos,
          agnoFra: agnoFra, mesFra: mesFra, fechaCargo: elemento1.fechaMov,
          periodoFrado: elemento1.periodo, valorAntesImptos: valorAntesI, agno: elemento1.agno, mes: elemento1.mes,
          _id: elemento1._id
        });
      }
    }
  })

  let linea1DNN = ""
  if(this.state.idLista.direccion.descrTipoVia1){
    linea1DNN = this.state.idLista.direccion.descrTipoVia1?this.state.idLista.direccion.descrTipoVia1:""
    linea1DNN += this.state.idLista.direccion.numeroTipoVia1?" " + this.state.idLista.direccion.numeroTipoVia1:""
    linea1DNN += this.state.idLista.direccion.descrTipoVia2?" " + this.state.idLista.direccion.descrTipoVia2:""
    linea1DNN += this.state.idLista.direccion.numeroTipoVia2?" " + this.state.idLista.direccion.numeroTipoVia2:""
    linea1DNN += this.state.idLista.direccion.numeroTipoVia2F?" " + this.state.idLista.direccion.numeroTipoVia2F:""
    linea1DNN += this.state.idLista.direccion.descrTipoUnd1?" " + this.state.idLista.direccion.descrTipoUnd1:""
    linea1DNN += this.state.idLista.direccion.numeroTipoUnd1?" " + this.state.idLista.direccion.numeroTipoUnd1:""
    linea1DNN += this.state.idLista.direccion.descrTipoUnd2?" " + this.state.idLista.direccion.descrTipoUnd2:""
    linea1DNN += this.state.idLista.direccion.numeroTipoUnd2?" " + this.state.idLista.direccion.numeroTipoUnd2:""
  }

  argsUpd = {
    "codProcFact": args._idRango,
    "idRangoFact": args._idRango,
    "numeroFra": proxFact,
    "fechaFact": fechaHoy,
    "contrato": args.contrato,
    "pagueHasta": fechaHoy,
    "direccion": linea1DNN,
    "descrDpto": this.state.idLista.dirmayor.descrDpto,
    "nombreCiudad": this.state.idLista.dirmayor.ciudades.nombreCiudad,
    "nombreZona": this.state.idLista.dirmayor.ciudades.zonas.nombreZona,
    "nombreBarrio": this.state.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio,
    "nombreCliente": this.state.idLista.nombreCliente,
    "apellidoCliente": this.state.idLista.apellidoCliente,
    "numeroDoc": this.state.idLista.numeroDoc,
    "eMail": this.state.idLista.eMail,
    "saldoPendiente": saldoCl,                  
    "fechaMov": fechaHoy,
    "valorAntesImptos": valorAntesImptos,
    "valorFacturado": valorFacturado,
    "valorFactura": valorFacturado,
    "agno": agnoFra,
    "mes": mesFra,
    "usuarioCreate": sessionStorage.getItem('userLogin'),
  };
  creaFra.push(argsUpd)
// console.log(argsUpd)

//Crear array con el detallado de los movimientos incluyendo impuestos
  let listServCargoFra = [];
  let numS = new Date().getTime();
  listServDetFra.forEach((elemento2, i) => {
    if(elemento2.valorAntesImptos!==0){
      listServCargoFra.push({codigoServicio: elemento2.codigoServicio, concepto: elemento2.descripcionServicio,
                          porcImpto: 0, tipo: "SF", agno: elemento2.agno, mes: elemento2.mes});
    }

    elemento2.imptos.forEach((elemento1, ii) => {
      if(elemento1.codigoImpto!==null){
        numS = numS + ii + 1
        listServCargoFra.push({codigoServicio: elemento2.codigoServicio, concepto: elemento1.descrImpto,
          porcImpto: elemento1.porcImpto, tipo: "IF", agno: elemento2.agno, mes: elemento2.mes});
      }
    })
  })
// console.log(listServCargoFra)
//AGRUPAR LOS MOVIMIENTOS DEL MISMO SERVICIO Y TOTALIZAR
  const groupLista = _.uniqWith(listServCargoFra, _.isEqual);
// console.log(groupLista)
// console.log(salida)
  groupLista.forEach((elemento1, ii) => {
    // let servicioFra = this.props.allServicios.allServicios.filter(servicio => servicio.codigoServicio === elemento1.codigoServicio)
    let conceptoEnFra = elemento1.concepto
    let consecEnFra = 1
    // if(servicioFra.length>0){
    //   conceptoEnFra = servicioFra[0].conceptoEnFra
    //   consecEnFra = servicioFra[0].consecEnFra
    // }
    
    let valorAntesI = 0, valorImpto = 0
    let nombreRes = "", descrServ = "", descrClase = "", descrImpto = "", porcImpto = 0
    listServDetFra.forEach((elemento2, _id) => {
// console.log(elemento2)
      if(elemento2.codigoServicio===elemento1.codigoServicio&&
        elemento2.descripcionServicio===elemento1.concepto&&elemento1.tipo==="SF"&&
        elemento2.agno===elemento1.agno&&elemento2.mes===elemento1.mes){
          nombreRes = elemento2.nombreResumido
          descrServ = elemento2.descripcionServicio
          descrClase = elemento2.descrClaseServ
          if(elemento2.codigoServicio==="CPTO1"||elemento2.codigoServicio==="CPTO2"||elemento2.codigoServicio==="CPTO3"){
            conceptoEnFra = elemento2.descripcionServicio
            consecEnFra = 9
          }

          valorAntesI += elemento2.valorAntesImptos
// console.log(elemento2)
// console.log(valorAntesI)
//Para actualizar concepto y numfra en movclientes
          argsUpdDet = {
            "_id": elemento2._id,
            "numeroFra": proxFact,
            "numeroCE": elemento2.numeroCE,
            "numeroRC": elemento2.numeroRC,
            "concepto": conceptoEnFra,
            "procesado": "S",
            "documento": proxFact,
            // "valorPagado": elemento2.valorPagado,
            // "fechaUltPago": elemento2.fechaUltPago,
            // "valorUltPago": elemento2.valorUltPago,
            "numeroOdeDX": elemento2.numeroOdeDX,
          }
          actmovCli.push(argsUpdDet)
      }
      if(elemento2.codigoServicio===elemento1.codigoServicio&&
        elemento2.agno===elemento1.agno&&elemento2.mes===elemento1.mes){
        elemento2.imptos.forEach((elemento3, ii) => {
// console.log(elemento3)
          if(elemento3.codigoImpto!==null){
            if(elemento3.descrImpto===elemento1.concepto&&
              elemento3.porcImpto===elemento1.porcImpto&&elemento1.tipo==="IF"){
                nombreRes = elemento2.nombreResumido
                descrServ = elemento2.descripcionServicio
                descrClase = elemento2.descrClaseServ
                descrImpto = elemento3.descrImpto
                porcImpto = elemento3.porcImpto
                valorImpto += elemento3.valorImpto
// console.log(elemento3.valorImpto)
// console.log(elemento3.porcImpto)
              }
          }
        })
      }
    })

    if(valorAntesI!==0){
      argsUpd = {
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": nombreRes,
        "descripcionServicio": descrServ,
        "descrClaseServ": descrClase,
        "concepto": conceptoEnFra,
        "periodo": elemento1.agno + '-' + elemento1.mes,
        "tipo": "SF",
        "consecEnFra": consecEnFra,
        "valor": valorAntesI,
      }
      movFras.push(argsUpd)
// console.log(argsUpd)
    }

    if(valorImpto!==0){
      // argsUpdDet = {}
      argsUpdDet = {
        // "tipoAct": "CrearDetFra2",
        // "numeroFra": proxFact,
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": nombreRes,
        "descripcionServicio": descrServ,
        "descrClaseServ": descrClase,
        "concepto": descrImpto,
        "periodo": elemento1.agno + '-' + elemento1.mes,
        "tipo": "IF",
        "consecEnFra": consecEnFra,
        "porcImpto": porcImpto,
        "valor": valorImpto,
      }
      movFras.push(argsUpdDet)
// console.log(argsUpdDet)
    }
  })
  // console.log(movFras)
  // console.log(creaFra)
  // console.log(actmovCli)
//Actualizar BD
  let creaFraMany = [], actmovCliMany = []

  let creaFra1 = {}
  creaFra1 = (creaFra[0])
  if(movFras.length){
    creaFra1.detalleFact = movFras
  }
  creaFraMany.push(creaFra1)

  actmovCli.forEach((elementoFra, ii) => {
    actmovCliMany.push(elementoFra)
  })

  let creaFraMany1 = []
  creaFraMany1.push({facturacion: creaFraMany})

  let actmovCliMany1 = []
  actmovCliMany1.push({movcliente: actmovCliMany})

  numDocCRUD = 0
  totDocCRUD = 2
  argsCrud = []
  crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(this.props.editMovClientesMany)
  }

  argsCrud[numDocCRUD] = creaFraMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.createFacturacionMany

  numDocCRUD += 1
  
  argsCrud[numDocCRUD] = actmovCliMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.editMovClientesMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
  await this.updColecc(crudColecc, argsCrud, totDocCRUD)
//FIN FACTURAR MOVIMIENTOS NO FACTURADOS     
}

  if(hacerAjCero){
//HACER AJUSTE A SALDO CERO
    let numeroAjuste = await this.nextVal('aju')
    numeroAjuste = numeroAjuste.toString()
    let tipoAjuste = "", clase = "", origen = ""

    if(saldoCl<0){
      tipoAjuste = "AP"
      origen = `Ajuste positivo ${numeroAjuste}`
      clase = "Ajuste positivo"
    }else{
      tipoAjuste = "AN"
      origen = `Ajuste negativo ${numeroAjuste}`
      clase = "Ajuste negativo"
    }

    let argsAddAj = {}
    creaColecc = []
    argsAddAj['tipoAjuste'] = tipoAjuste
    argsAddAj['numeroAjuste'] = numeroAjuste
    argsAddAj['fechaAjuste'] = fechaHoy
    argsAddAj['contrato'] = args.contrato
    argsAddAj['concepto'] = "Ajuste a saldo cero"
    argsAddAj['valorAjuste'] = saldoCl
    creaColecc.push(argsAddAj)

    creaHC = []
    argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": args.contrato,
      "movimiento": "Ajuste",
      "descripcion": clase,
      "detalle": "Ajuste a saldo cero",
      "relacion": numeroAjuste,
      "valor": saldoCl,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

    let claseServSig = "NoDefinida", claseServSig1 = ""
    if(this.state.idLista.tarifa.codigoTarifa){
      claseServSig1 = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
      claseServSig = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
      this.state.idLista.tarifa.servicios.forEach((elemento, _id) => {
        if(claseServSig1!==claseServSig){
          claseServSig = "NoDefinida"
        }
      })
    }
    // console.log(claseServSig)
    
    let creaColeccMC = []
    let valorMC = saldoCl * -1
    let argsAddMC = {
      "contrato": args.contrato,
      "fechaMov": fechaHoy,
      "tipo": "C",
      "subTipo": tipoAjuste,
      "procesado": "S",
      "nombreResumido": "Ajuste a saldo cero",
      "descripcionServicio": "Ajuste",
      "descrClaseServ": claseServSig,
      "concepto": "Ajuste",
      "origen": origen,
      "saldoCliente": 0,
      "valorTotal": valorMC,
      "valorAntesImptos": valorMC,
      "documento": numeroAjuste,
      "valorPagado": valorMC,
      "valorPendiente": 0,
      "numeroOdeDX": 0,
      "fechaCreate": fechaHoraHoy,
    };
    creaColeccMC.push(argsAddMC)

//Crear el ajuste, histclientes y movclientes
    creaHCMany = []
    creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    numDocCRUD = 0
    totDocCRUD = 3
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createAjuste

    numDocCRUD += 1

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany

    numDocCRUD += 1

    argsCrud[numDocCRUD] = creaColeccMC[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createMovClientes

// console.log(argsCrud)
    await this.updColecc(crudColecc, argsCrud, totDocCRUD)
//FIN HACER AJUSTE A SALDO CERO
  }

// console.log(listColecc)

//IMPRIMIR RC => GENERAR ARCHIVO PDF

    const usuActivo = this.props.allUsuarios.allUsuarios.filter(usuario => usuario.email===sessionStorage.getItem('userLogin'))
    let nombreUA = ""
    if(usuActivo[0]){
      nombreUA = usuActivo[0].nombreUsuario
    }

    this.setState({stImprRC: true, numeroRC, listServTar: listColecc, nombreUA, saldoCl: saldoClRC, totRecibido})
    // console.log(numeroRC)
// console.log("22")
//FIN IMPRIMIR RC

    setTimeout(async () => {
      this.props.allClientes.refetch()
    }, 1000)


    this.estadosFalse()
    this.setState({showClient: true})
  }
}

handleRecPagoOtr = async (ev, args, argsDocum, totRecibido, saldoPendiente, listaR, empresa)=>{
  // console.log(argsDocum)
  // console.log(args)
  // console.log(args, argsDocum, totRecibido, saldoPendiente)
  // console.log(listaR, empresa)
  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []

  const errors = []
  if(argsDocum.descrOtrosPagCl==="Seleccionar..."){
    errors.push({path: 'Concepto', message: `Debe seleccionar el concepto`});
  }
  if(!args._idRango){
    errors.push({path: 'Rango', message: `Debe seleccionar el rango de facturación`});
  }
  if(totRecibido<=0){
    errors.push({path: 'Valor pagado', message: `El valor del pago debe ser mayor que cero`});
  }
  if(!args.descrOficina||args.descrOficina==="Todas..."||args.descrOficina==="Seleccionar..."){
    errors.push({path: 'Oficina', message: `Por favor seleccione la Oficina` });
  }

  this.setState({errorAdd: errors})

  if(errors.length===0){
    let saldoCl = parseInt(saldoPendiente, 10)

    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let fechaHoy = fechaHoraHoy.substr(0, 10)
    let horaHoy = fechaHoraHoy.substr(11, 8)
    // let fechaHoy = new Date()
    // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let argsAdd = args

    let numeroFra = await this.nextValFra(argsAdd._idRango)
    numeroFra = numeroFra.toString()
    if(argsAdd.prefijoFact){
      numeroFra = argsAdd.prefijoFact + "-" + numeroFra
    }
    // console.log(numeroFra)

    let creaColecc = [], movColecc = []

    argsAdd['saldoPendiente'] = saldoCl    
    argsAdd['fechaPago'] = fechaHoy.substr(0, 10)
    argsAdd['tipo'] = "OP"
    argsAdd['descripcionPago'] = "Otros pagos del cliente"
    argsAdd['numeroFra'] = numeroFra
    argsAdd['documento'] = numeroFra
    argsAdd['valorTotal'] = totRecibido
    argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
    argsAdd['usuarioCreate'] = sessionStorage.getItem('userLogin')
    creaColecc.push(argsAdd)
    
    let argsUpd = {}
    // let codigoServicio = "OTPACL"
    let codigoServicio = argsDocum.descrOtrosPagCl
    argsUpd = {
      "contrato": args.contrato,
      "tipoAct": "CreardetallePC1",
      "codigoServicio": codigoServicio,
      "nombreResumido": argsDocum.descrOtrosPagCl,
      "descripcionServicio": argsDocum.descrOtrosPagCl,
      "descrClaseServ": argsDocum.descrClaseServ,
      "concepto": argsDocum.descrOtrosPagCl,
      "periodo": "",
      "valorTotal": totRecibido,
      "valorDetalle": totRecibido,
    }
    movColecc.push(argsUpd)

//CREA REGISTRO EN HISTCLIENTES
    let creaHC = []
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": args.contrato,
      "movimiento": "Pago",
      "descripcion": "Otros pagos del cliente",
      "detalle": argsDocum.descrOtrosPagCl,
      "relacion": numeroFra,
      "valor": totRecibido,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

//Crear el pago y su detalle
    numDocCRUD = 0
    totDocCRUD = 2
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editPagoClientesUpdDoc)
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'SI_ID'
    crudColecc[numDocCRUD] = this.props.createPagoClientes

    numDocCRUD += 1

    argsCrud[numDocCRUD] = movColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editPagoClientesUpdDoc

    this.updColecc(crudColecc, argsCrud, totDocCRUD)

//Crear el registro en histclientes
    let creaHCMany = [], creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createHistClienteMany)
    }

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
    this.updColecc(crudColecc, argsCrud, totDocCRUD)

//Crear la factura y su detalle
    let creaFra = [], movFras = []
    let valorFact = parseInt(totRecibido, 10), valorAntesI = parseInt(totRecibido, 10)
    // console.log(valorFact)
    // console.log(valorAntesI)
    if(argsDocum.descrImpto){
      valorAntesI = (valorAntesI / ((100 + parseInt(argsDocum.porcImpto, 10))/100))
      // console.log(valorAntesI)
      valorAntesI = parseInt(valorAntesI, 10)
      // console.log(valorAntesI)
    }

    // let codigoServicio = "OTPACL"
    argsUpd = {
      "codigoServicio": codigoServicio,
      "nombreResumido": argsDocum.descrOtrosPagCl,
      "descripcionServicio": argsDocum.descrOtrosPagCl,
      "descrClaseServ": argsDocum.descrClaseServ,
      "concepto": argsDocum.descrOtrosPagCl,
      "periodo": "",
      "tipo": "SF",
      "consecEnFra": 1,
      "valor": valorAntesI,
    }
    movFras.push(argsUpd)

    // let codigoServicio = "OTPACL"
    if(argsDocum.descrImpto){
      argsUpd = {
        "codigoServicio": codigoServicio,
        "nombreResumido": argsDocum.descrOtrosPagCl,
        "descripcionServicio": argsDocum.descrOtrosPagCl,
        "descrClaseServ": argsDocum.descrClaseServ,
        "concepto": argsDocum.descrImpto,
        "periodo": "",
        "tipo": "IF",
        "consecEnFra": 1,
        "porcImpto": argsDocum.porcImpto,
        "valor": totRecibido - valorAntesI,
      }
      movFras.push(argsUpd)
    }
// console.log(this.state.idLista)
    let linea1DNN = ""
    if(this.state.idLista.direccion.descrTipoVia1){
      linea1DNN = this.state.idLista.direccion.descrTipoVia1?this.state.idLista.direccion.descrTipoVia1:""
      linea1DNN += this.state.idLista.direccion.numeroTipoVia1?" " + this.state.idLista.direccion.numeroTipoVia1:""
      linea1DNN += this.state.idLista.direccion.descrTipoVia2?" " + this.state.idLista.direccion.descrTipoVia2:""
      linea1DNN += this.state.idLista.direccion.numeroTipoVia2?" " + this.state.idLista.direccion.numeroTipoVia2:""
      linea1DNN += this.state.idLista.direccion.numeroTipoVia2F?" " + this.state.idLista.direccion.numeroTipoVia2F:""
      linea1DNN += this.state.idLista.direccion.descrTipoUnd1?" " + this.state.idLista.direccion.descrTipoUnd1:""
      linea1DNN += this.state.idLista.direccion.numeroTipoUnd1?" " + this.state.idLista.direccion.numeroTipoUnd1:""
      linea1DNN += this.state.idLista.direccion.descrTipoUnd2?" " + this.state.idLista.direccion.descrTipoUnd2:""
      linea1DNN += this.state.idLista.direccion.numeroTipoUnd2?" " + this.state.idLista.direccion.numeroTipoUnd2:""
    }

    argsUpd = {
      "codProcFact": argsAdd._idRango,
      "idRangoFact": argsAdd._idRango,
      "numeroFra": numeroFra,
      "fechaFact": fechaHoy.substr(0, 10),
      "contrato": args.contrato,
      "pagueHasta": fechaHoy.substr(0, 10),
      "direccion": linea1DNN,
      "descrDpto": this.state.idLista.dirmayor.descrDpto?this.state.idLista.dirmayor.descrDpto:"",
      "nombreCiudad": this.state.idLista.dirmayor.descrDpto?this.state.idLista.dirmayor.ciudades.nombreCiudad:"",
      "codBarrasRdo": this.state.idLista.dirmayor.descrDpto?this.state.idLista.dirmayor.ciudades.codBarrasRdo:"",
      "nombreZona": this.state.idLista.dirmayor.descrDpto?this.state.idLista.dirmayor.ciudades.zonas.nombreZona:"",
      "nombreBarrio": this.state.idLista.dirmayor.descrDpto?this.state.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
      "nombreCliente": this.state.idLista.nombreCliente,
      "apellidoCliente": this.state.idLista.apellidoCliente,
      "numeroDoc": this.state.idLista.numeroDoc,
      "eMail": this.state.idLista.eMail,
      "saldoPendiente": this.state.idLista.saldoPendiente,                  
      "fechaMov": fechaHoy.substr(0, 10),
      "valorAntesImptos": valorAntesI,
      "valorFacturado": valorFact,
      "valorFactura": valorFact,
      "agno": fechaHoy.substr(0, 4),
      "mes": fechaHoy.substr(5, 2),
      "fechaCreate": fechaHoraHoy,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    };
    creaFra.push(argsUpd)
// console.log(creaFra)
// console.log(movFras)

  let creaFra1 = {}, creaFraMany = []
  creaFra1 = (creaFra[0])
  if(movFras.length){
    creaFra1.detalleFact = movFras
  }

  creaFraMany.push(creaFra1)
  let creaFraMany1 = []
  creaFraMany1.push({facturacion: creaFraMany})

  numDocCRUD = 0
  totDocCRUD = 1
  argsCrud = []
  crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(this.props.createFacturacionMany)
  }

  argsCrud[numDocCRUD] = creaFraMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.createFacturacionMany

  this.updColecc(crudColecc, argsCrud, totDocCRUD)

//crear mov de pago en movclientes
    creaColecc = []
    let argsAdd1 = {
      "contrato": args.contrato,
      "fechaMov": fechaHoy.substr(0, 10),
      "tipo": "D",
      "subTipo": "OP",
      "procesado": "S",
      "descripcionServicio": argsDocum.descrOtrosPagCl,
      "descrClaseServ": argsDocum.descrClaseServ,
      "periodo": "",
      "origen": "Otros pagos del cliente",
      "saldoCliente": saldoCl,
      "valorTotal": totRecibido,
      "valorAntesImptos": totRecibido,
      "numeroFra": numeroFra,
      "documento": numeroFra,
      "valorPagado": totRecibido,
      "fechaUltPago": fechaHoy.substr(0, 10),
      "valorUltPago": totRecibido,
      "fechaCreate": fechaHoraHoy,
    };
    creaColecc.push(argsAdd1)
// console.log(argsAdd1)
    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createMovClientes)
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createMovClientes

    numDocCRUD += 1

    this.updColecc(crudColecc, argsCrud, totDocCRUD)

//IMPRIMIR FRA => GENERAR ARCHIVO PDF
    let listFact = creaFra[0]
    // listFact.push(creaFra)
    
// //PARA IMPRIMIR CODIGO DE BARRAS
//     let factCodBarras = ""
//     // console.log(empresa)
//     if(empresa.modeloCodBarras==="1"){
//       //ultimo caracter=longitud del prefijo
//       //=> la referencia queda =>  prefijo factura + numero factura + longitud prefijo factura
//       //queda de 10 digitos => se completa con ceros a la izquierda      
//       let posic1 = creaFra[0].numeroFra.indexOf("-")
//       if(posic1===-1){
//         factCodBarras = `${creaFra[0].numeroFra}0`
//       }else{
//         factCodBarras = creaFra[0].numeroFra.substr(posic1 + 1)      
//         let prefijoFra = creaFra[0].numeroFra.substr(0, posic1)
//         let longPrefijo = prefijoFra.length
//         factCodBarras = `${prefijoFra}${factCodBarras}${longPrefijo}`
//       }
//     }
//     if(empresa.modeloCodBarras==="2"){
//       factCodBarras = `${creaFra[0].contrato}`
//     }
// //slice => para extraer caracteres de la derecha
//     let valorCodBarras = `00000000000000${factCodBarras}`
//     // valorCodBarras = valorCodBarras.slice(-14)
//     factCodBarras = valorCodBarras.slice(-10)
// //slice => para extraer caracteres de la derecha
//     // factCodBarras = factCodBarras.slice(-24)

//     // let valorCodBarras = `00000000000000${creaFra[0].valorFactura}`
//     // valorCodBarras = valorCodBarras.slice(-14)

//     let fechaCodBarras
//     if(creaFra[0].pagueHasta){
//       fechaCodBarras = `${creaFra[0].pagueHasta.substr(0,4)}${creaFra[0].pagueHasta.substr(5,2)}${creaFra[0].pagueHasta.substr(8,2)}`
//     }else{
//       fechaCodBarras = `${creaFra[0].fechaFact.substr(0,4)}${creaFra[0].fechaFact.substr(5,2)}${creaFra[0].fechaFact.substr(8,2)}`
//     }

//     // factCodBarras =  `000000000000000000000000${creaFra[0].numeroFra}`
//     // factCodBarras = factCodBarras.slice(-10)
//     valorCodBarras = `00000000000000${creaFra[0].valorFactura}`
//     // valorCodBarras = valorCodBarras.slice(-8)
//     valorCodBarras = valorCodBarras.slice(-10)

//     // let textoCB = `Ê415${this.props.getParametro.getParametro.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}Ê96${fechaCodBarras}`
//     // let textoCBTxt = `(415)${this.props.getParametro.getParametro.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}(96)${fechaCodBarras}`
//     let textoCB = `Ê415${this.props.getParametro.getParametro.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}`
//     let textoCBTxt = `(415)${this.props.getParametro.getParametro.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}`

//     let canvas = document.createElement("canvas");
// // JsBarcode("#barcodecanvasjs", textoCB, {
//     JsBarcode(canvas, textoCB, {
//       format: "CODE128",
//       ean128: true,
//       text: textoCBTxt,
//       lineColor: "#000000",
//       width: 2,
//       height: 50,
//       // width: 2,
//       // height: 50,
//       displayValue: true
// });
// // let canvas = document.getElementById('barcodecanvasjs');
//     let imgSource = canvas.toDataURL("image/png");
// //FIN PARA IMPRIMIR CODIGO DE BARRAS

    let documFra = creaFra[0]
    let modeloCodBarras = empresa.modeloCodBarras
    // let codBarrasRdo = this.props.getParametro.getParametro.codBarrasRdo
    let codBarrasRdo = creaFra[0].codBarrasRdo?creaFra[0].codBarrasRdo:this.props.getParametro.getParametro.codBarrasRdo
    let imgSource = await codBarras(documFra, modeloCodBarras, codBarrasRdo)

    listFact.codBarras = imgSource
// console.log(listFact)
    this.setState({stImprFact: true, numeroFra, listaR, listFact})

    setTimeout(async () => {
      this.props.allClientes.refetch()
    }, 1000)

    this.estadosFalse()
    this.setState({showClient: true})
  }
}

handleRecPagoAd = async (ev, args, listServTar, totRecibido, totAPagar, conceptoPA, ofertaPA, saldoPendiente, listServOfSel, listaR, empresa)=>{
  // console.log(listServTar)
// console.log(args)

  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []

  const errors = []
  if(!args._idRango){
    errors.push({path: 'Rango', message: `Debe seleccionar el rango de facturación`});
  }
  if(totRecibido<=0){
    errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} debe ser mayor que cero`});
  }
  if(totAPagar!==totRecibido){
    errors.push({path: 'Valor pagado', message: `El valor del pago ${totRecibido} no coincide con el valor a pagar ${totAPagar}`});
  }
  // if(!args._idRango){
  //   errors.push({path: 'Factura', message: `Para poder generar facturas, debe habilitar un rango de facturación`});
  // }
  if(!args.descrOficina||args.descrOficina==="Todas..."||args.descrOficina==="Seleccionar..."){
    errors.push({path: 'Oficina', message: `Por favor seleccione la Oficina` });
  }

  this.setState({errorAdd: errors})

  if(errors.length===0){
    let saldoCl = parseInt(saldoPendiente, 10) - parseInt(totRecibido, 10)
    let totPagoAdelSinFrar = parseInt(this.state.idLista.totPagoAdelSinFrar, 10) + parseInt(totRecibido, 10)

    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let fechaHoy = fechaHoraHoy.substr(0, 10)
    let horaHoy = fechaHoraHoy.substr(11, 8)
    // let fechaHoy = new Date()
    // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let argsAdd = args

    let numeroFra = await this.nextValFra(argsAdd._idRango)
    numeroFra = numeroFra.toString()
    if(argsAdd.prefijoFact){
      numeroFra = argsAdd.prefijoFact + "-" + numeroFra
    }
    // console.log(numeroFra)
    // let numeroRC = await this.nextVal('reccajas')

    let creaColecc = [], movColecc = []

    argsAdd['saldoPendiente'] = saldoCl    
    argsAdd['fechaPago'] = fechaHoy.substr(0, 10)
    argsAdd['tipo'] = "PA"
    argsAdd['descripcionPago'] = "Pago adelantado " + conceptoPA
    argsAdd['numeroFra'] = numeroFra
    argsAdd['documento'] = numeroFra
    argsAdd['valorTotal'] = totRecibido
    argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
    argsAdd['usuarioCreate'] = sessionStorage.getItem('userLogin')
    creaColecc.push(argsAdd)
// console.log(listServTar)
    let argsUpd = {}
    listServTar.forEach((elemento1, ii) => {
      argsUpd = {
        "contrato": args.contrato,
        "tipoAct": ii===0?"CreardetallePC1":"CreardetallePC2",
        // "idMovClientes": elemento1._id,
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": elemento1.nombreResumido,
        "descripcionServicio": elemento1.descripcionServicio,
        "descrClaseServ": elemento1.descrClaseServ,
        "concepto": elemento1.concepto,
        "periodo": elemento1.periodo,
        "valorTotal": elemento1.valorTotal,
        "valorDetalle": elemento1.valorDetalle,
      }
      movColecc.push(argsUpd)
    })

//CREA REGISTRO EN HISTCLIENTES
    let creaHC = []
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": args.contrato,
      "movimiento": "Pago",
      "descripcion": "Pago adelantado",
      "detalle": conceptoPA,
      "relacion": numeroFra,
      "valor": totRecibido,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

//Crear el pago y su detalle
    numDocCRUD = 0
    totDocCRUD = movColecc.length + 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editPagoClientesUpdDoc)
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'SI_ID'
    crudColecc[numDocCRUD] = this.props.createPagoClientes

    numDocCRUD += 1
// console.log(movColecc)
    movColecc.forEach((elemento1, ii) => {
      argsCrud[numDocCRUD] = elemento1
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
    })

    this.updColecc(crudColecc, argsCrud, totDocCRUD)

//Crear el registro en histclientes
    let creaHCMany = [], creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createHistClienteMany)
    }

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
    this.updColecc(crudColecc, argsCrud, totDocCRUD)

//Crear la factura y su detalle
    let creaFra = [], movFras = []
    let valorFact = 0, valorAntesI = 0

    listServTar.forEach((elemento1, ii) => {
      valorAntesI += elemento1.valorAntesImptos
      valorFact += elemento1.valorTotal
      argsUpd = {
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": elemento1.nombreResumido,
        "descripcionServicio": elemento1.descripcionServicio,
        "descrClaseServ": elemento1.descrClaseServ,
        "concepto": elemento1.concepto,
        "periodo": elemento1.periodo,
        "tipo": "SF",
        "consecEnFra": elemento1.consecEnFra,
        "valor": elemento1.valorAntesImptos,
      }
      movFras.push(argsUpd)

      elemento1.imptos.forEach((elemento2, ii) => {
        if(elemento2.codigoImpto!==null){
          argsUpd = {
            "codigoServicio": elemento1.codigoServicio,
            "nombreResumido": elemento1.nombreResumido,
            "descripcionServicio": elemento1.descripcionServicio,
            "descrClaseServ": elemento1.descrClaseServ,
            "concepto": elemento2.descrImpto,
            "periodo": elemento1.periodo,
            "tipo": "IF",
            "consecEnFra": elemento1.consecEnFra,
            "porcImpto": elemento2.porcImpto,
            "valor": elemento2.valorImpto,
          }
          movFras.push(argsUpd)
        }
      })
    })

    let linea1DNN = ""
    if(this.state.idLista.direccion.descrTipoVia1){
      linea1DNN = this.state.idLista.direccion.descrTipoVia1?this.state.idLista.direccion.descrTipoVia1:""
      linea1DNN += this.state.idLista.direccion.numeroTipoVia1?" " + this.state.idLista.direccion.numeroTipoVia1:""
      linea1DNN += this.state.idLista.direccion.descrTipoVia2?" " + this.state.idLista.direccion.descrTipoVia2:""
      linea1DNN += this.state.idLista.direccion.numeroTipoVia2?" " + this.state.idLista.direccion.numeroTipoVia2:""
      linea1DNN += this.state.idLista.direccion.numeroTipoVia2F?" " + this.state.idLista.direccion.numeroTipoVia2F:""
      linea1DNN += this.state.idLista.direccion.descrTipoUnd1?" " + this.state.idLista.direccion.descrTipoUnd1:""
      linea1DNN += this.state.idLista.direccion.numeroTipoUnd1?" " + this.state.idLista.direccion.numeroTipoUnd1:""
      linea1DNN += this.state.idLista.direccion.descrTipoUnd2?" " + this.state.idLista.direccion.descrTipoUnd2:""
      linea1DNN += this.state.idLista.direccion.numeroTipoUnd2?" " + this.state.idLista.direccion.numeroTipoUnd2:""
    }
  
    argsUpd = {
      "codProcFact": argsAdd._idRango,
      "idRangoFact": argsAdd._idRango,
      "numeroFra": numeroFra,
      "fechaFact": fechaHoy.substr(0, 10),
      "contrato": args.contrato,
      "pagueHasta": fechaHoy.substr(0, 10),
      "direccion": linea1DNN,
      "descrDpto": this.state.idLista.dirmayor.descrDpto,
      "nombreCiudad": this.state.idLista.dirmayor.ciudades.nombreCiudad,
      "codBarrasRdo": this.state.idLista.dirmayor.ciudades.codBarrasRdo,
      "nombreZona": this.state.idLista.dirmayor.ciudades.zonas.nombreZona,
      "nombreBarrio": this.state.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio,
      "nombreCliente": this.state.idLista.nombreCliente,
      "apellidoCliente": this.state.idLista.apellidoCliente,
      "numeroDoc": this.state.idLista.numeroDoc,
      "eMail": this.state.idLista.eMail,
      "saldoPendiente": saldoCl,      
      "fechaMov": fechaHoy.substr(0, 10),
      "valorAntesImptos": valorAntesI,
      "valorFacturado": valorFact,
      "valorFactura": valorFact,
      "agno": fechaHoy.substr(0, 4),
      "mes": fechaHoy.substr(5, 2),
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    };
    creaFra.push(argsUpd)
// console.log(creaFra)
// console.log(movFras)

  let creaFra1 = {}, creaFraMany = []
  creaFra1 = (creaFra[0])
  if(movFras.length){
    creaFra1.detalleFact = movFras
  }

  creaFraMany.push(creaFra1)
  let creaFraMany1 = []
  creaFraMany1.push({facturacion: creaFraMany})

  numDocCRUD = 0
  totDocCRUD = 1
  argsCrud = []
  crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(this.props.createFacturacionMany)
  }

  argsCrud[numDocCRUD] = creaFraMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = this.props.createFacturacionMany

  this.updColecc(crudColecc, argsCrud, totDocCRUD)

//actualizar saldo en clientes
//crear mov de pago en movclientes
//ASIGNAR OFERTA APLICADA EN EL PAGO ADEL AL CLIENTE
//Actualizar 
    let actColecc = []
    creaColecc = []
    movColecc = []
    let argsUpd1 = {
      "tipoAct": "EditarCliOdeS",
      "_id": this.state.idLista._id,
      "estadoCliente": this.state.idLista.estadoCliente,
      "cargoMensual": this.state.idLista.cargoMensual,
      "saldoPendiente": saldoCl,
    }
    actColecc.push(argsUpd1)

    let actPASFCli = []
    argsUpd1 = {}
    argsUpd1 = {
      "tipoAct": "EditarCliPagoAdelSF",
      "contrato": args.contrato,
      "totPagoAdelSinFrar": totPagoAdelSinFrar,
    }
    actPASFCli.push(argsUpd1)
  
    let argsAdd1 = {
      "contrato": args.contrato,
      "fechaMov": fechaHoy.substr(0, 10),
      "tipo": "D",
      "subTipo": "PA",
      "procesado": "S",
      "descripcionServicio": ofertaPA,
      "periodo": conceptoPA,
      "origen": "Pago adelantado",
      "saldoCliente": saldoCl,
      "valorTotal": totRecibido,
      "valorAntesImptos": totRecibido,
      "numeroFra": numeroFra,
      "documento": numeroFra,
      "valorPagado": totRecibido,
      "fechaUltPago": fechaHoy.substr(0, 10),
      "valorUltPago": totRecibido,
    };
    creaColecc.push(argsAdd1)

    if(listServOfSel.length>0){
      listServOfSel.forEach((elemento, i) => {
        argsUpd = {
          "tipoAct": i===0?"EditarOferta":"EditarServOf",
          "_id": this.state.idLista._id,
          "codigoOferta": elemento.codigoOferta,
          "descrOferta": elemento.descrOferta,
          "codigoServicioO": elemento.codigoServicio,
          "nombreResumidoO": elemento.nombreResumido,
          "descripcionServicioO": elemento.descripcionServicio,
          "_idSubclaseServO": elemento._idSubclaseServ,
          "codigoSubclaseServO": elemento.codigoSubclaseServ,
          "descrSubclaseServO": elemento.descrSubclaseServ,
          "_idClaseServO": elemento._idClaseServ,
          "codigoClaseServO": elemento.codigoClaseServ,
          "descrClaseServO": elemento.descrClaseServ,
          "porcDctoOferta": elemento.porcDctoOferta,
          "numDiasOferta": elemento.numDiasOferta,
          "fechaFinOferta": elemento.fechaFinOferta,
          "fechaInicioOferta": elemento.fechaInicioOferta
        };
        movColecc.push(argsUpd)
      })
    }

    numDocCRUD = 0
    totDocCRUD = movColecc.length + 3
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editClienteUpdDoc)
    }

    argsCrud[numDocCRUD] = actPASFCli[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    numDocCRUD += 1

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createMovClientes

    numDocCRUD += 1

    movColecc.forEach((elemento1, ii) => {
      argsCrud[numDocCRUD] = elemento1
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
    })

    argsCrud[numDocCRUD] = actColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editCliente

    // numDocCRUD += 1

    this.updColecc(crudColecc, argsCrud, totDocCRUD)


//IMPRIMIR FRA => GENERAR ARCHIVO PDF
    let listFact = creaFra[0]
    // listFact.push(creaFra)
    
// //PARA IMPRIMIR CODIGO DE BARRAS
//     // let textoCB = `${creaFra[0].contrato}Ê${creaFra[0].numeroFra}`
//     let factCodBarras = ""
//     // console.log(empresa)
//     if(empresa.modeloCodBarras==="1"){
//       //ultimo caracter=longitud del prefijo
//       //=> la referencia queda =>  prefijo factura + numero factura + longitud prefijo factura
//       //queda de 10 digitos => se completa con ceros a la izquierda      
//       let posic1 = creaFra[0].numeroFra.indexOf("-")
//       if(posic1===-1){
//         factCodBarras = `${creaFra[0].numeroFra}0`
//       }else{
//         factCodBarras = creaFra[0].numeroFra.substr(posic1 + 1)      
//         let prefijoFra = creaFra[0].numeroFra.substr(0, posic1)
//         let longPrefijo = prefijoFra.length
//         factCodBarras = `${prefijoFra}${factCodBarras}${longPrefijo}`
//       }
//     }
//     if(empresa.modeloCodBarras==="2"){
//       factCodBarras = `${creaFra[0].contrato}`
//     }
// //slice => para extraer caracteres de la derecha
//     let valorCodBarras = `00000000000000${factCodBarras}`
//     // valorCodBarras = valorCodBarras.slice(-14)
//     factCodBarras = valorCodBarras.slice(-10)

//     //slice => para extraer caracteres de la derecha
//     // factCodBarras = factCodBarras.slice(-24)

//     // let valorCodBarras = `00000000000000${creaFra[0].valorFactura}`
//     // valorCodBarras = valorCodBarras.slice(-14)

//     let fechaCodBarras
//     if(creaFra[0].pagueHasta){
//       fechaCodBarras = `${creaFra[0].pagueHasta.substr(0,4)}${creaFra[0].pagueHasta.substr(5,2)}${creaFra[0].pagueHasta.substr(8,2)}`
//     }else{
//       fechaCodBarras = `${creaFra[0].fechaFact.substr(0,4)}${creaFra[0].fechaFact.substr(5,2)}${creaFra[0].fechaFact.substr(8,2)}`
//     }

//     // factCodBarras =  `000000000000000000000000${creaFra[0].numeroFra}`
//     // factCodBarras = factCodBarras.slice(-10)
//     valorCodBarras = `00000000000000${creaFra[0].valorFactura}`
//     // valorCodBarras = valorCodBarras.slice(-8)
//     valorCodBarras = valorCodBarras.slice(-10)

//     // let textoCB = `Ê415${this.props.getParametro.getParametro.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}Ê96${fechaCodBarras}`
//     // let textoCBTxt = `(415)${this.props.getParametro.getParametro.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}(96)${fechaCodBarras}`
//     let textoCB = `Ê415${this.props.getParametro.getParametro.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}`
//     let textoCBTxt = `(415)${this.props.getParametro.getParametro.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}`

//     let canvas = document.createElement("canvas");
// // JsBarcode("#barcodecanvasjs", textoCB, {
//     JsBarcode(canvas, textoCB, {
//       format: "CODE128",
//       ean128: true,
//       text: textoCBTxt,
//       lineColor: "#000000",
//       width: 2,
//       height: 50,
//       // width: 2,
//       // height: 50,
//       displayValue: true
//     });
// // let canvas = document.getElementById('barcodecanvasjs');
//     let imgSource = canvas.toDataURL("image/png");
// //FIN PARA IMPRIMIR CODIGO DE BARRAS

    let documFra = creaFra[0]
    let modeloCodBarras = empresa.modeloCodBarras
    // let codBarrasRdo = this.props.getParametro.getParametro.codBarrasRdo
    let codBarrasRdo = creaFra[0].codBarrasRdo?creaFra[0].codBarrasRdo:this.props.getParametro.getParametro.codBarrasRdo
    let imgSource = await codBarras(documFra, modeloCodBarras, codBarrasRdo)

    listFact.codBarras = imgSource
// console.log(listFact)
    this.setState({stImprFact: true, numeroFra, listaR, listFact})

    setTimeout(async () => {
      this.props.allClientes.refetch()
    }, 1000)

    this.estadosFalse()
    this.setState({showClient: true})
  }
}

handleSubmitNot = async (ev, listFactDetN, totNota, idListaF, argsDocum, lista4, stObservacNota) => {
  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []
  let errors = []
  let saldoPendiente = -99999999
  if(this.props.allClientes.allClientes){
    let {data} = await this.props.allClientes.refetch({contrato: argsDocum.contrato})
    saldoPendiente = await data.allClientes[0].saldoPendiente
  }
  if(saldoPendiente === -99999999){
    errors.push({path: 'Información', message: `Cargando la información del cliente`});
  }
  if(listFactDetN.length===0){
    errors.push({path: 'Nota', message: `El cliente NO tiene facturas`});
  }
  // console.log(argsDocum)
  // console.log(argsDocum.contrato, saldoPendiente)
  // console.log(listFactDetN)
  if(totNota<=0){
    errors.push({path: 'Nota 0', message: `El valor de la nota ($${totNota}) no puede ser menor o igual a cero`});
  }
  
  let valorNotaFact = 0
  if(errors.length===0&&!this.state.permiteNDF){
    let valorSaldoNCFra = 0
    for(let iii=0; iii<listFactDetN.length; iii++){
      valorSaldoNCFra += (parseInt(listFactDetN[iii].valorSF, 10) + parseInt(listFactDetN[iii].valorIF, 10))
      if(parseInt(listFactDetN[iii].valorSF, 10) + parseInt(listFactDetN[iii].valorIF, 10) < parseInt(listFactDetN[iii].nuevoValor, 10)){
        errors.push({path: `Nota ${iii+1}`, message: `El valor de la nota ($${listFactDetN[iii].nuevoValor}) en ${listFactDetN[iii].descripcionServicio} no puede ser mayor al facturado ($${parseInt(listFactDetN[iii].valorSF, 10) + parseInt(listFactDetN[iii].valorIF, 10)})`});
      }
    }
    let valorNC = 0
    if(listFactDetN[0].valorNC){
      valorNC = listFactDetN[0].valorNC
    }
    valorSaldoNCFra -= valorNC
    valorNotaFact = valorNC + totNota
    if(totNota > valorSaldoNCFra){
      errors.push({path: `Nota`, message: `El valor de la nota ($${totNota}) es mayor al valor disponible en la factura para hacer Notas Crédito ($${valorSaldoNCFra})`});
    }
  }

  if(errors.length>0){
    this.setState({errorAdd: errors})
  }else{
  //crear registros en notasdebcre
  //crear registro en movclientes
  //actualizar saldo cliente

  //PARA CONTROLAR QUE NO SE ENTRE A RECIBIR PAGOS POR OPCIONES DIFERENTES A ENTRADA DEL USUARIO
  //ESTO PORQUE SE ESTAN CREANDO PAGOS DUPLICADOS
    let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
    let horaEntrada = new Date().getTime();
    let difHoraEntrada = 3000
    if(horaEntradaAnt){
      // console.log(horaEntradaAnt)
      difHoraEntrada = horaEntrada - horaEntradaAnt
    }else{
      difHoraEntrada = 8000
    }

    if(difHoraEntrada>7000){
      sessionStorage.setItem("horaEntrada", horaEntrada);

      // let fechaHoy = new Date()
      // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)
      let horaHoy = fechaHoraHoy.substr(11, 8)

      let numeroNota = 0, tipoNota = "", origen = "", clase = "", saldoCl = 0, valorMC = 0, valorPag = 0
      let argsAdd = {}
      let creaColecc = [], movColecc = []
      if(this.state.permiteNDF){
        numeroNota = await this.nextVal('nds')
        numeroNota = numeroNota.toString()
        tipoNota = "ND"
        origen = `Nota Debito ${numeroNota} a factura ${idListaF.numeroFra}`
        clase = "Nota Debito"
        saldoCl = parseInt(saldoPendiente, 10) + parseInt(totNota, 10)
      }else{
        numeroNota = await this.nextVal('ncs')
        numeroNota = numeroNota.toString()
        tipoNota = "NC"
        origen = `Nota Credito ${numeroNota} a factura ${idListaF.numeroFra}`
        clase = "Nota Credito"
        saldoCl = parseInt(saldoPendiente, 10) - parseInt(totNota, 10)
      }

      let valorAntesImptos = 0, valorAntesImptosMC = 0
      listFactDetN.forEach((elemento1, ii) => {
        if(elemento1.nuevoValor>0){
          let valor = 0, valorImpto = 0, porcImpto = 0
          // if(this.state.permiteNDF){
          // porcImpto = Math.round((elemento1.valorIF * 100) / elemento1.valorSF)
          porcImpto =elemento1.porcImpto
          valor = Math.round(elemento1.nuevoValor / ((100 + porcImpto) / 100))
          valorImpto = elemento1.nuevoValor - valor
          // console.log(porcImpto, valor, valorImpto)
          // }else{
          //   valor = elemento1.valor - elemento1.nuevoValor
          // }
          valorAntesImptos += valor

          let argsUpd = {
            "tipoAct": ii===0?"CrearDetNota1":"CrearDetNota2",
            "numeroFra": idListaF.numeroFra,
            "codigoServicio": elemento1.codigoServicio,
            "nombreResumido": elemento1.nombreResumido,
            "descripcionServicio": elemento1.descripcionServicio,
            "descrClaseServ": elemento1.descrClaseServ,
            "concepto": elemento1.nombreResumido,
            "periodo": elemento1.periodo,
            "tipo": "SF",
            "consecEnFra": elemento1.consecEnFra,
            "valor": valor,
          }
          movColecc.push(argsUpd)
          if(valorImpto>0){
            argsUpd = {
              "tipoAct": "CrearDetNota2",
              "numeroFra": idListaF.numeroFra,
              "codigoServicio": elemento1.codigoServicio,
              "nombreResumido": elemento1.nombreResumido,
              "descripcionServicio": elemento1.descripcionServicio,
              "descrClaseServ": elemento1.descrClaseServ,
              "concepto": "Impuesto",
              "periodo": elemento1.periodo,
              "tipo": "IF",
              "consecEnFra": elemento1.consecEnFra,
              "porcImpto": elemento1.porcImpto,
              "valor": valorImpto,
            }
            movColecc.push(argsUpd)
            }
        }
      })

      argsAdd['tipoNota'] = tipoNota
      argsAdd['numeroNota'] = numeroNota
      argsAdd['idRangoFact'] = idListaF.idRangoFact
      argsAdd['numeroFra'] = idListaF.numeroFra
      argsAdd['fechaNota'] = fechaHoy
      argsAdd['contrato'] = argsDocum.contrato
      argsAdd['valorAntesImptos'] = valorAntesImptos
      argsAdd['valorNota'] = totNota
      argsAdd['observacNota'] = stObservacNota
      argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
      argsAdd['valorNotaFact'] = valorNotaFact
      creaColecc.push(argsAdd)

      //CREA REGISTRO EN HISTCLIENTES
      let creaHC = []
      let argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": argsDocum.contrato,
        "movimiento": "Nota",
        "descripcion": clase,
        "detalle": `A fact ${idListaF.numeroFra}=>${stObservacNota}`,
        "relacion": numeroNota,
        "valor": totNota,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      creaHC.push(argsAddHC)

      //Crear la nota y su detalle
      numDocCRUD = 0
      totDocCRUD = movColecc.length + 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editNotasDebCreUpdDoc)
      }
      // console.log(creaColecc[0])
      argsCrud[numDocCRUD] = creaColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'SI_ID'
      crudColecc[numDocCRUD] = this.props.createNotasDebCre

      numDocCRUD += 1

      movColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })

      this.updColecc(crudColecc, argsCrud, totDocCRUD)

      //Crear el registro en histclientes
      let creaHCMany = [], creaHCMany1 = []
      creaHC.forEach((elementoHC, ii) => {
        creaHCMany.push(elementoHC)
      })
      creaHCMany1.push({histcliente: creaHCMany})

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createHistClienteMany)
      }

      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createHistClienteMany

      // console.log(crudColecc)
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)

      //actualizar saldo cliente
      let actColecc = []
      creaColecc = []
      let argsUpd = {
        "tipoAct": "EditarCliOdeS",
        "_id": this.state.idLista._id,
        "estadoCliente": this.state.idLista.estadoCliente,
        "cargoMensual": this.state.idLista.cargoMensual,
        "saldoPendiente": saldoCl,
      }
      actColecc.push(argsUpd)

      //crear registro en movclientes
      if(this.state.permiteNDF){
        valorMC = totNota      
        valorAntesImptosMC = valorAntesImptos
        if(saldoCl<=0){
          valorPag = valorMC
        }
        if(saldoCl<totNota&&saldoCl>0){
          valorPag = parseInt(totNota, 10) - saldoCl
        }
      }else{
        valorMC = totNota * -1
        valorAntesImptosMC = valorAntesImptos * -1
        // if(saldoCl<0){
          valorPag = valorMC
        // }
      }

      //traer clase si todos los servicios de la tarifa son d la misma clase
      let claseServSig = "NoDefinida", claseServSig1 = ""
      if(this.state.idLista.tarifa.codigoTarifa){
        claseServSig1 = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        claseServSig = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        this.state.idLista.tarifa.servicios.forEach((elemento, _id) => {
          if(claseServSig1!==claseServSig){
            claseServSig = "NoDefinida"
          }
        })
      }
      // console.log(claseServSig)

      argsAdd = {
        "contrato": argsDocum.contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": tipoNota,
        "procesado": "S",
        "nombreResumido": origen,
        "descripcionServicio": stObservacNota,
        "descrClaseServ": claseServSig,
        "concepto": origen,
        "origen": origen,
        "saldoCliente": saldoCl,
        "valorTotal": valorMC,
        "valorAntesImptos": valorAntesImptosMC,
        "documento": numeroNota,
        "valorPagado": valorPag,
        "valorPendiente": valorMC - valorPag,
        "numeroOdeDX": 0,
        "fechaCreate": fechaHoraHoy,
      };
      creaColecc.push(argsAdd)
      // console.log(argsAdd)
      if(saldoCl<=0){
        lista4.forEach((elemento1, ii) => {
          argsUpd = {
            "contrato": argsDocum.contrato,
            "_id": elemento1._id,
            "procesado": elemento1.procesado,
            "concepto": elemento1.concepto,
            "numeroFra": elemento1.numeroFra,
            "numeroRC": elemento1.numeroRC,
            "numeroCE": elemento1.numeroCE,
            "numeroOdeDX": elemento1.numeroOdeDX,
            "fechaUltPago": elemento1.fechaUltPago,
            "valorUltPago": elemento1.valorUltPago,
            "documento": elemento1.documento,
            "valorPagado": elemento1.valorTotal,
            "valorPendiente": 0,
          }
          movColecc.push(argsUpd)
        })
      }

      numDocCRUD = 0
      totDocCRUD = movColecc.length + 2
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovClientes)
      }

      argsCrud[numDocCRUD] = creaColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createMovClientes

      numDocCRUD += 1

      movColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })

      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCliente

      // numDocCRUD += 1

      this.updColecc(crudColecc, argsCrud, totDocCRUD)
      // this.setState({notaProc: true})

      if(!this.state.permiteNDF){
        //SI ES NOTA CREDITO => AFECTA LOS MOVIMIENTOS DEL CLIENTE
        let totRecib = totNota
        let listColecc = lista4.map(recpago => ({...recpago}))
        listColecc = _.orderBy(listColecc, ['_id'], ['asc'])

        let estCl = this.state.idLista.estadoCliente
        let ultFRX = this.state.idLista.fecgaUltRX
          
        let numDX = this.state.idLista.numeroOdeDX
        let valorparaPermRX = this.props.getParametro.getParametro.valorparaPermRX
        let hacerRX = true
        if(numDX===0){
          hacerRX = false
        }
        if(saldoCl>0){
          listColecc.forEach((elemento, i) => {
            if(elemento.valorTotal<0){
              totRecib -= elemento.valorTotal
              listColecc[i].valorRecibido = elemento.valorTotal
            }
          })
          listColecc.forEach((elemento, i) => {
            if(elemento.valorTotal>0){
              if(totRecib > elemento.valorTotal - elemento.valorPagado){
                totRecib -= (elemento.valorTotal - elemento.valorPagado)
                listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
              }else{
                listColecc[i].valorRecibido = totRecib
                totRecib = 0
              }
            }
          })

          let movColecc = []
          listColecc.forEach((elemento1, ii) => {
            if(numDX>0&&elemento1.numeroOdeDX>0&&(!elemento1.valorRecibido||elemento1.valorRecibido===0)&&
                elemento1.valorTotal>0){
              hacerRX = false
            }
            if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
              let valPagado = 0
              if(elemento1.valorPagado){
                valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
              }else{
                valPagado = parseInt(elemento1.valorRecibido, 10)
              }
              let valParaHacerRX = parseInt(valPagado, 10) + parseInt(valorparaPermRX, 10)
              // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal)
              // if(numDX>0&&elemento1.numeroOdeDX>0&&valPagado<elemento1.valorTotal&&elemento1.valorTotal>0){
              if(numDX>0&&elemento1.numeroOdeDX>0&&valParaHacerRX<elemento1.valorTotal&&elemento1.valorTotal>0){
                // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal)
                hacerRX = false
              }

              argsUpd = {
                "contrato": this.state.idLista.contrato,
                "_id": elemento1._id,
                "procesado": elemento1.procesado,
                "concepto": elemento1.concepto,
                "numeroFra": elemento1.numeroFra,
                "numeroRC": elemento1.numeroRC,
                "numeroCE": elemento1.numeroCE,
                "numeroOdeDX": elemento1.numeroOdeDX,
                "documento": elemento1.documento,
                "fechaUltPago": elemento1.fechaUltPago,
                "valorUltPago": elemento1.valorUltPago,
                "valorPagado": valPagado,
                "valorPendiente": elemento1.valorTotal - valPagado,
              }
              movColecc.push(argsUpd)
            }
          })

          //Actualizar BD
          numDocCRUD = 0
          totDocCRUD = movColecc.length + 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editMovClientes)
          }

          movColecc.forEach((elemento1, ii) => {
            argsCrud[numDocCRUD] = elemento1
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

            numDocCRUD += 1
          })

          //Actualizar saldo despues de actualizar movim => para calcular diasMora
          argsCrud[numDocCRUD] = actColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editCliente

          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        let movCli = [], movCliRX = [], actServCli = []
    
        if(hacerRX){
          //PROCESO CREAR DOCUM DE CARGUE EN MOVIMCLIENTE POR DX
          // console.log(this.props.getParametro.getParametro.comoAsigCargosAlCliente)
          // console.log(saldoCl)
          let saldoClCC = saldoCl

          // let fechaHoy = new Date()
          // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          let fechaHoy = fechaHoraHoy.substr(0, 10)
    
          //traer el número de días del mes
          const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
          const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1
    
          let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
          let diaFra= parseInt(fechaHoy.substr(8, 2), 10)
          let periodoFrado = ""
          // let numServ=0
    
          let elemento3 = []
          let difSaldoNeg = 0, valorPagNeg = 0
          //verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
          //los cargos positivos
          if(this.state.idLista.tarifa.codigoTarifa){
            elemento3 = this.state.idLista.tarifa
            elemento3.servicios.forEach((elemento1, i) => {
              if(elemento1.estadoServicio==="D"){
                let numDNvo = numDM - ddI
                let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
                
                if(valorServ<0){
                  valorPagNeg += valorServ
                }
              }
            })
            if(saldoCl<(valorPagNeg * -1)){
              difSaldoNeg = (valorPagNeg * -1) - saldoCl
            }
          }
    
          // console.log("Hacer RX")
          let agnoFra = fechaHoy.substr(0, 4)
          let mesFra = fechaHoy.substr(5, 2)
    
          elemento3 = []
    
          // listColecc.forEach((elemento, ii) => {
          //   if(numDX>0&&elemento.numeroOdeDX>0){
          if(this.state.idLista.tarifa.codigoTarifa){
            elemento3 = this.state.idLista.tarifa
            // console.log(elemento3.servicios.length)
            elemento3.servicios.forEach((elemento1, i) => {
              // console.log(elemento1)
              // if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
              if(elemento1.estadoServicio==="D"){
                //Si esta DX => crear movcliente => siempre carga porque al dx se le descontó
                // let listServCargoFra = []
                let numDNvo = numDM - ddI
                let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
                let valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)
    
                let valorPag = 0
                if(difSaldoNeg>0&&valorServ>0){
                  if(difSaldoNeg-valorServ>=0){
                    valorPag = valorServ
                  }else{
                    valorPag = difSaldoNeg
                  }
                  difSaldoNeg -= valorPag
                }
    
                if(saldoCl<0&&valorServ>0){
                  if(saldoCl+valorServ>0){
                    valorPag = saldoCl * -1
                  }else{
                    valorPag = valorServ
                  }
                }
                if(valorServ<0){
                  valorPag = valorServ
                }                
    
                periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
                periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM
    
                let numServ = elemento1.numeroServicios
                if(numServ!==0){
                  let imptosServ = elemento1.imptos.map(impto => ({
                    ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
                  if(valorServ!==0){
                    // listServCargoFra.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
                    //   codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                    //   _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                    //   descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                    //   codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                    //   numeroServicios: numServ, valorServicios: valorServ, imptos: imptosServ,
                    //   agnoFra: agnoFra, mesFra: mesFra, fechaCargo: fechaHoy, periodoFrado: periodoFrado,
                    //   valorAntesImptos: valorAntesI,
                    //   _id: i
                    // });
    
                    //CREA REGISTRO EN movclientes
                    saldoCl += valorServ
                    argsUpd = {}
    
                    let movCliI = [], actCargoFra = []
                    argsUpd = {}
                    imptosServ.forEach((elementoI, ii) => {
                      if(elementoI.codigoImpto!==null){
                        argsUpd = {
                          "codigoImpto": elementoI.codigoImpto,
                          "descrImpto": elementoI.descrImpto,
                          "porcImpto": elementoI.porcImpto,
                          "valorImpto": elementoI.valorImpto,
                        }
                        movCliI.push(argsUpd)
                      }
                    })
    
                    //PARA CUANDO SE FACTURA UN MES ANTERIOR
                    let ultMF = ""
                    let tieneMCCMesAnt = true
                    let lista8CC = this.props.allMovClientesCC.allMovClientesCC
    
                    let agno = fechaHoy.substr(0, 4)
                    let mes = fechaHoy.substr(5, 2)
    
                    let ultPF = this.props.allProcFact1.allProcFact.filter(elemento => elemento.cicloFact===this.state.idLista.cicloFact)
                    if(ultPF.length>0){
                      ultMF = ultPF[ultPF.length-1].mes
                    }
                    let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
                    //Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
                    //en movcliccs
                    if(difmesesUMF>1){
                      let mesMA = parseInt(mes, 10)
                      let agnoMA = agno
                      if(mes==="01"){
                        agnoMA = (parseInt(agno, 10) - 1).toString()
                        mesMA = "12"
                      }else{
                        mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                      }
                      // console.log(agnoMA + "-" + mesMA)
                      let indexFrado = lista8CC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
                      if(indexFrado===-1){
                        //NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
                        //como NO FACTURAR
                        tieneMCCMesAnt = false
                      }  
                    }
    
                    //verificar si NO tiene mov en el mes ant
                    if(!tieneMCCMesAnt){
                      //verificar si esta des, sus o ret, la os lo va a pasar a act
                      if(this.state.idLista.estadoCliente==="DESCONECTADO"||this.state.idLista.estadoCliente==="SUSPENDIDO"||
                          this.state.idLista.estadoCliente==="RETIRADO"){
                        //crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
                        //esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
                        let fechaHoyMA = new Date()
                        let agnoMA = (fechaHoyMA.getFullYear()).toString()
                        let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
                        mesMA = parseInt(mesMA, 10)
                        if(mesMA==="01"){
                          agnoMA = (parseInt(agnoMA, 10) - 1).toString()
                          mesMA = "12"
                        }else{
                          mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                        }
                        // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
                        let periodoFradoMA = "NO FACTURAR"
                        // let pruebaFMA =[]
                        // pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
    
                        argsUpd = {}
                        argsUpd = {
                          "contrato": argsDocum.contrato,
                          "fechaMov": fechaHoy,
                          "tipo": "C",
                          "subTipo": "RX",
                          "procesado": "N",
                          "codigoServicio": elemento1.codigoServicio,
                          "nombreResumido": elemento1.nombreResumido,
                          "descripcionServicio": elemento1.descripcionServicio,
                          "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                          "periodo": periodoFradoMA,
                          "origen": "DX-" + this.state.idLista.numeroOdeDX,
                          "saldoCliente": saldoCl,
                          "valorTotal": 0,
                          "valorAntesImptos": 0,
                          "agno": agnoMA,
                          "mes": mesMA,
                          "valorPagado": 0,
                          // "valorPendiente": elemento1.valorTotal - valorPag,
                          "usuarioCreate": sessionStorage.getItem('userLogin'),
                          "imptos": []
                        };
                        actCargoFra.push(argsUpd)
    
                        // console.log(pruebaFMA)
                        // console.log(listServCargoFra)
                      }
                    }
                    //FIN PARA CUANDO SE FACTURA UN MES ANTERIOR
    
                    argsUpd = {}
                    argsUpd = {
                      "contrato": argsDocum.contrato,
                      "fechaMov": fechaHoy,
                      "tipo": "C",
                      "subTipo": "RX",
                      "procesado": "N",
                      "codigoServicio": elemento1.codigoServicio,
                      "nombreResumido": elemento1.nombreResumido,
                      "descripcionServicio": elemento1.descripcionServicio,
                      "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                      "periodo": periodoFrado,
                      "origen": "DX-" + this.state.idLista.numeroOdeDX,
                      "saldoCliente": saldoCl,
                      "valorTotal": valorServ,
                      "valorAntesImptos": valorAntesI,
                      "agno": agnoFra,
                      "mes": mesFra,
                      "valorPagado": valorPag,
                      // "valorPendiente": elemento1.valorTotal - valorPag,
                      "usuarioCreate": sessionStorage.getItem('userLogin'),
                      "imptos": movCliI
                    };
                    actCargoFra.push(argsUpd)
                    // console.log(actCargoFra)
                    // console.log("66")
    
                    actCargoFra.forEach((elementoDX, ii) => {
                      if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                        movCliRX.push(elementoDX)
                      }else{
                        movCli.push(elementoDX)
                      }
                      // console.log("77")
    
                      argsUpd = {}
                      argsUpd['tipoAct'] = "EditarServDX"
                      argsUpd['contrato'] = argsDocum.contrato
                      argsUpd['tarifa'] = { codigoTarifa: this.state.idLista.tarifa.codigoTarifa, servicios: 
                                        [{"codigoServicio": elementoDX.codigoServicio,
                                          "estadoServicio": "A"}]}
                      actServCli.push(argsUpd)
                      // console.log(movCli, movCliRX, actServCli)
                    })
                  }
                }
              }
            })
          }
          //   }
          // })
          // //FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
          // console.log(saldoCl, saldoClCC)
          if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
            saldoCl = saldoClCC
          }

          creaHC = []
          argsAddHC = {
            "fechaHistCliente": fechaHoy + ' ' + horaHoy,
            "contrato": argsDocum.contrato,
            "movimiento": "Nota",
            "descripcion": clase,
            "detalle": `Se hace RX por Nota`,
            "relacion": numeroNota,
            "valor": totNota,
            "usuarioCreate": sessionStorage.getItem('userLogin'),
          }
          creaHC.push(argsAddHC)
          //Crear el registro en histclientes
          let creaHCMany = [], creaHCMany1 = []
          creaHC.forEach((elementoHC, ii) => {
            creaHCMany.push(elementoHC)
          })
          creaHCMany1.push({histcliente: creaHCMany})
    
          numDocCRUD = 0
          totDocCRUD = 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.createHistClienteMany)
          }
    
          argsCrud[numDocCRUD] = creaHCMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.createHistClienteMany
    
          // console.log(crudColecc)
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
          // console.log(saldoCl)
        }

        // console.log(movCli)
        if(movCli.length>0||movCliRX.length>0){
          let actCli = [], actCliMany = [], movCliMany = [], movCliRXMany = [], actServCliMany = []

          let numOdeDX = 0
          if(!hacerRX&&this.state.idLista.numeroOdeDX>0){
            numOdeDX = this.state.idLista.numeroOdeDX
          }
          argsUpd = {}
          argsUpd = {
            "tipoAct": "EditarCliDX",
            "contrato": argsDocum.contrato,
            "numeroOdeDX": numOdeDX,
          }
          actCli.push(argsUpd)
          actCli.forEach((elementoDX, ii) => {
            actCliMany.push(elementoDX)
          })
          movCli.forEach((elementoDX, ii) => {
            movCliMany.push(elementoDX)
          })
          movCliRX.forEach((elementoDX, ii) => {
            movCliRXMany.push(elementoDX)
          })
          actServCli.forEach((elementoDX, ii) => {
            actServCliMany.push(elementoDX)
          })

          let actCliMany1 = []
          actCliMany1.push({cliente: actCliMany})
          let movCliMany1 = [], movCliRXMany1 = []
          movCliMany1.push({movcliente: movCliMany})
          if(movCliRX.length>0){
            movCliRXMany1.push({movcliente: movCliRXMany})
          }
          let actServCliMany1 = []
          actServCliMany1.push({cliente: actServCliMany})

          numDocCRUD = 0
          if(movCliRX.length>0){
            totDocCRUD = 4
          }else{
            totDocCRUD = 3
          }
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.createMovClientesMany)
          }

          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteMany

          numDocCRUD += 1

          argsCrud[numDocCRUD] = actServCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

          numDocCRUD += 1

          if(movCliRX.length>0){
            argsCrud[numDocCRUD] = movCliRXMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.createMovCliCCMany

            numDocCRUD += 1
          }
          if(movCli.length>0){
            argsCrud[numDocCRUD] = movCliMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.createMovClientesMany
          }

          // console.log(argsCrud)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)

          if(this.state.idLista.estadoCliente!=="ACTIVO"&&hacerRX){
            estCl = "ACTIVO"
            ultFRX = fechaHoy
          }
        }

        //ACTUALIZAR DIASMORA
        //para calcular diasmora =>
        //diasMora = movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0
        // let movimDX1 = await listColecc.map(movim => ({
        //   ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0}))
        let actCli = [], fechaPH = null
        if(saldoCl>0){
          let fechaMora = new Date()
          fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
          let movimDX1 = await listColecc.map(movim => ({
            ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
          let fechaHoy1 = new Date()
          let diasHoy = fechaHoy1.getUTCDate()
          let mesHoy = fechaHoy1.getMonth()+1

          let diasMora = 0, diasMoraMayor = 0
          await movimDX1.forEach((movim, ii) => {
            // console.log(movim)
            diasMora = 0
            if(movim.pagueHasta&&movim.valorTotal>(movim.valorPagado+movim.valorRecibido)&&movim.valorTotal>0){
              if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&this.state.idLista.cargoMensual>0){
                //Math.ceil redondea al entero por encima
                  let mesesM = Math.ceil((movim.valorTotal - (movim.valorPagado+movim.valorRecibido)) / this.state.idLista.cargoMensual)
                  if(movim.codigoServicio==="SISTV"){
                    diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
                  }else{
                    diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
                  }
                // console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
              }else{
                diasMora = movim.diasMora
              }
            }
            if(diasMora>diasMoraMayor||(diasMora<0&&diasMoraMayor===0)){
              diasMoraMayor = diasMora
            }
          })
          if(diasMoraMayor!==0){
            let fechaInicio = new Date(fechaMora).getTime();
            let fechaFin = new Date(fechaInicio-(diasMoraMayor*1000*60*60*24)+(1000*60*60*24));
            fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
          }else{
            fechaPH = null
          }
        }else{
          fechaPH = null
        }
        argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarCliPagueHasta",
          "contrato": this.state.idLista.contrato,
          "pagueHasta": fechaPH,
        }
        actCli.push(argsUpd)
        //FIN ACTUALIZAR DIASMORA

        actColecc = []
        argsUpd = {
          "tipoAct": "EditarCliOdeS",
          "_id": this.state.idLista._id,
          "estadoCliente": estCl,
          "cargoMensual": this.state.idLista.cargoMensual,
          "saldoPendiente": saldoCl,
        }
        actColecc.push(argsUpd)

        let actFechas = []
        argsUpd = {
          "tipoAct": "EditarFechCli",
          "_id": this.state.idLista._id,
          "fechaUltOSAb": this.state.idLista.fechaUltOSAb,
          "fechaPrimeraActivacion": this.state.idLista.fechaPrimeraActivacion,
          "fechaUltDX": this.state.idLista.fechaUltDX,
          "fecgaUltRX": ultFRX,
          "estadoAnterior": this.state.idLista.estadoAnterior,
          "fechaUltOSCe": this.state.idLista.fechaUltOSCe,
          "fechaUltPago": this.state.idLista.fechaUltPago,
          "valorUltPago": this.state.idLista.valorUltPago,
        }
        actFechas.push(argsUpd)

        //Actualizar BD
        numDocCRUD = 0
        // totDocCRUD = movColecc.length + 2
        totDocCRUD = movColecc.length + 3
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editMovClientes)
        }

        argsCrud[numDocCRUD] = actFechas[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        numDocCRUD += 1

        argsCrud[numDocCRUD] = actCli[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        numDocCRUD += 1

        // console.log(movColecc)
        movColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

          numDocCRUD += 1
        })

        argsCrud[numDocCRUD] = actColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        // numDocCRUD += 1

        // console.log(crudColecc)
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }

      setTimeout(async () => {
        this.props.allClientes.refetch()
      }, 1000)

      this.estadosFalse()
      this.setState({showClient: true})
    }
  }
}

handleSubmitNvoCargoPF = async (ev, stValor, argsDocum) => {
// console.log(stValor, argsDocum)
  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []
  let errors = []
  let saldoPendiente = -99999999
  if(this.props.allClientes.allClientes){
    let {data} = await this.props.allClientes.refetch({contrato: argsDocum.contrato})
    saldoPendiente = await data.allClientes[0].saldoPendiente
  }
  if(saldoPendiente === -99999999){
    errors.push({path: 'Cargo', message: `Cargando la información del cliente`});
  }

  if(argsDocum.descrOtrosPagCl==="Seleccionar..."){
    errors.push({path: 'Concepto', message: `Debe seleccionar el concepto`});
  }
  if(stValor<=0){
    errors.push({path: 'Valor', message: `El valor del ajuste ($${stValor}) no puede ser menor o igual a cero`});
  }

  if(errors.length>0){
    this.setState({errorAdd: errors})
  }else{
    //PARA CONTROLAR QUE NO SE ENTRE A RECIBIR PAGOS POR OPCIONES DIFERENTES A ENTRADA DEL USUARIO
    //ESTO PORQUE SE ESTAN CREANDO PAGOS DUPLICADOS
    let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
    let horaEntrada = new Date().getTime();
    let difHoraEntrada = 3000
    if(horaEntradaAnt){
      // console.log(horaEntradaAnt)
      difHoraEntrada = horaEntrada - horaEntradaAnt
    }else{
      difHoraEntrada = 8000
    }

    if(difHoraEntrada>7000){
      sessionStorage.setItem("horaEntrada", horaEntrada);
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)

      let valorAntesI = stValor
      let valorImpto = 0
      if(argsDocum.descrImpto){
        valorAntesI = (valorAntesI / ((100 + Math.round(argsDocum.porcImpto))/100))
        valorAntesI = Math.round(valorAntesI)
        valorImpto = stValor - valorAntesI
      }
  
      let movCliI = []
      let argsUpd = {}
      if(argsDocum.codigoImpto!==null){
        argsUpd = {
          "codigoImpto": argsDocum.codigoImpto,
          "descrImpto": argsDocum.descrImpto,
          "porcImpto": argsDocum.porcImpto,
          "valorImpto": valorImpto,
        }
        movCliI.push(argsUpd)
      }

      // let codigoServicio = "OTPACL"
      let codigoServicio = argsDocum.descrOtrosPagCl
      let movCli = []      
      argsUpd = {
        "contrato": argsDocum.contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": "NC",
        "procesado": stValor===0?"S":"N",
        "codigoServicio": codigoServicio,
        "nombreResumido": argsDocum.descrOtrosPagCl,
        "descripcionServicio": argsDocum.descrOtrosPagCl,
        "concepto": argsDocum.descrOtrosPagCl,
        "descrClaseServ": argsDocum.descrClaseServ,
        "periodo": fechaHoraHoy.substr(0, 7),
        "origen": "Nuevo cargo",
        "saldoCliente": saldoPendiente,
        "valorTotal": stValor,
        "valorAntesImptos": valorAntesI,
        "agno": fechaHoraHoy.substr(0, 4),
        "mes": fechaHoraHoy.substr(5, 2),
        "valorPagado": 0,
        "numeroOdeDX": 0,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
        "fechaCreate": fechaHoraHoy,
        "imptos": movCliI,
      };
      // console.log(argsUpd)
      movCli.push(argsUpd)

      let movCliMany = [], movCliMany1 = []
      movCli.forEach((elementoDX, ii) => {
        movCliMany.push(elementoDX)
      })
      movCliMany1.push({movcliente: movCliMany})
      
      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createMovCliCCMany)
      }

      argsCrud[numDocCRUD] = movCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createMovCliCCMany

      // console.log(crudColecc)
      // console.log(argsCrud)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)

      this.estadosFalse()
      this.setState({showClient: true})
    }
  }
}

handleSubmitProgServ = async (ev, argsDocum, accion) => {
  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []
  let creaHC = [], creaHCMany = [], creaHCMany1 = []

  let response = await this.props.fecha({
    variables: {}
  });
  const {fechaHoraHoy} = response.data.fecha
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)

  let errors = []

  if(accion==="Crear"){
    if(!argsDocum.descripcionServicio||argsDocum.descripcionServicio==="Seleccionar..."){
      errors.push({path: 'Servicio', message: `Debe seleccionar el servicio a programar`});
    }
    if(!argsDocum.fechaPS){
      errors.push({path: 'Fecha', message: `Debe seleccionar la fecha`});
    }

    if(errors.length>0){
      this.setState({errorAdd: errors})
    }else{
      //PARA CONTROLAR QUE NO SE ENTRE A RECIBIR PAGOS POR OPCIONES DIFERENTES A ENTRADA DEL USUARIO
      //ESTO PORQUE SE ESTAN CREANDO PAGOS DUPLICADOS
      let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
      let horaEntrada = new Date().getTime();
      let difHoraEntrada = 3000
      if(horaEntradaAnt){
        // console.log(horaEntradaAnt)
        difHoraEntrada = horaEntrada - horaEntradaAnt
      }else{
        difHoraEntrada = 8000
      }

      if(difHoraEntrada>7000){
        sessionStorage.setItem("horaEntrada", horaEntrada);

        let servProg = []
        let argsUpd = {}
        argsUpd = {
          "contrato": argsDocum.contrato,
          "fechaProg": argsDocum.fechaPS,
          "procesado": "N",
          "codigoTarifa": argsDocum.codigoTarifa,
          "descrTarifa": argsDocum.descrTarifa,
          "codigoServicio": argsDocum.codigoServicio,
          "nombreResumido": argsDocum.nombreResumido,
          "descripcionServicio": argsDocum.descripcionServicio,
          "valorTotal": argsDocum.valorServicios,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
          "fechaCreate": fechaHoraHoy,
        };
        // console.log(argsUpd)
        servProg.push(argsUpd)

        let argsAddHC = {
          "fechaHistCliente": fechaHoy + ' ' + horaHoy,
          "contrato": argsDocum.contrato,
          "movimiento": "Programar servicio",
          "descripcion": argsDocum.descripcionServicio,
          "detalle": argsDocum.fechaPS,
          "valor": argsDocum.valorServicios,
          "usuarioCreate": sessionStorage.getItem('userLogin'),
        }
        creaHC.push(argsAddHC)

        creaHC.forEach((elementoHC, ii) => {
          creaHCMany.push(elementoHC)
        })
        creaHCMany1.push({histcliente: creaHCMany})

        numDocCRUD = 0
        totDocCRUD = 2
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.createProgServ)
        }

        argsCrud[numDocCRUD] = servProg[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createProgServ

        numDocCRUD += 1

        argsCrud[numDocCRUD] = creaHCMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createHistClienteMany

        this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }
      this.estadosFalse()
      this.setState({showClient: true})
    }
  }
  if(accion==="Eliminar"){
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": argsDocum.contrato,
      "movimiento": "Eliminar Prog servicio",
      "descripcion": argsDocum.descripcionServicio,
      "detalle": this.props.allProgServ.allProgServ[0].fechaProg.substr(0, 10),
      "valor": this.props.allProgServ.allProgServ[0].valorTotal,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createHistClienteMany)
    }

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany
    
    await this.updColecc(crudColecc, argsCrud, totDocCRUD)

    const argsDel = {
      _id: argsDocum.id_ProgServ
    }
    await this.props.deleteProgServ({
      variables: argsDel
    });

    this.estadosFalse()
    this.setState({showClient: true})
  }
}

handleSubmitNotAut = async (ev, stConcepto, stValor, argsDocum, lista4) => {
  // console.log(stConcepto, stValor, argsDocum, lista4)
  let errors = []
  let saldoPendiente = -99999999
  let clienteSel = []
  if(this.props.allClientes.allClientes){
    let {data} = await this.props.allClientes.refetch({contrato: argsDocum.contrato})
    clienteSel = await data.allClientes[0]
    saldoPendiente = clienteSel.saldoPendiente
  }
  if(saldoPendiente === -99999999){
    errors.push({path: 'Nota Crédito', message: `Cargando la información del cliente`});
  }
  if(!stConcepto){
    errors.push({path: 'Concepto', message: `Por favor escriba el concepto`});
  }
  if(stValor<=0){
    errors.push({path: 'Valor', message: `El valor de la nota ($${stValor}) no puede ser menor o igual a cero`});
  }
  let lista4_1 = []
  // console.log(saldoPendiente, stValor, lista4)
  // if(saldoPendiente<stValor){
  //   //Cuando el valor de la nota es mayor que el saldo pendiente => tener en cuenta mov de facturas pagadas
    if(this.props.allMovClientes.allMovClientes){
      // lista4_1 = this.props.allMovClientes.allMovClientes.filter(elemento => elemento.tipo==="C" &&
      //   elemento.subTipo==="CF" && elemento.valorTotal===elemento.valorPagado)
      lista4_1 = this.props.allMovClientes.allMovClientes.filter(elemento => elemento.tipo==="C" &&
        elemento.subTipo==="CF")

      lista4_1 = lista4.concat(lista4_1);
    }
  // }else{
  //   lista4_1 = lista4
  // }
  // console.log(lista4_1)
  if(errors.length>0){
    this.setState({errorAdd: errors})
  }else{
    document.body.style.cursor = 'wait'

    // console.log(clienteSel)
    //PARA CONTROLAR QUE NO SE ENTRE A RECIBIR PAGOS POR OPCIONES DIFERENTES A ENTRADA DEL USUARIO
    //ESTO PORQUE SE ESTAN CREANDO PAGOS DUPLICADOS
    let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
    let horaEntrada = new Date().getTime();
    let difHoraEntrada = 3000
    if(horaEntradaAnt){
      // console.log(horaEntradaAnt)
      difHoraEntrada = horaEntrada - horaEntradaAnt
    }else{
      difHoraEntrada = 8000
    }

    if(difHoraEntrada>7000){
      sessionStorage.setItem("horaEntrada", horaEntrada);
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha

      let listFactDetN = []
      let listNC = []
      listNC.push({contrato: argsDocum.contrato, observacNota: stConcepto, valor: stValor})
      //debe tener saldo pendiente >= al valor de la nota
      // if(lista4_1.length>0 && saldoPendiente >= listNC[0].valor){
      if(lista4_1.length>0){
        let valorSaldoConFra = 0
        let lista4ConFra = []
        for(let i=0; i<lista4_1.length; i++){
          if(lista4_1[i].numeroFra){
            valorSaldoConFra += lista4_1[i].valorTotal
            lista4ConFra.push({numeroFra: lista4_1[i].numeroFra})
          }
        }
        lista4ConFra = _.uniqWith(lista4ConFra, _.isEqual);
        //El valor pendiente con saldo por factura (valorSaldoConFra) debe ser >= que el valor de la nota
        let valorNota = listNC[0].valor
        let listaFra = []
        if(lista4ConFra.length>0 && valorSaldoConFra >= valorNota){
          for(let i=0; i<lista4ConFra.length; i++){
            let argsBuscarFactUsu = {}
            argsBuscarFactUsu = {tipoqry: `[{$match: {'numeroFra': '${lista4ConFra[i].numeroFra}'}},
            {"$unwind": '$detalleFact'},
            {$project: {'numeroFra': 1, idRangoFact: 1, valorNC: 1,
                'descrClaseServ': '$detalleFact.descrClaseServ',
                'codigoServicio': '$detalleFact.codigoServicio',
                'descripcionServicio': '$detalleFact.descripcionServicio',
                'nombreResumido': '$detalleFact.nombreResumido',
                'periodo': '$detalleFact.periodo',
                'consecEnFra': '$detalleFact.consecEnFra',
                'valorSF': {
                    $let: {
                        vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                        in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                    }
                },
                'valorIF': {
                    $let: {
                        vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                        in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                    }
                }
              }
            },
            {$group: {_id: {numeroFra: '$numeroFra', idRangoFact: '$idRangoFact', valorNC: '$valorNC',
                descrClaseServ: '$descrClaseServ',
                'codigoServicio': '$codigoServicio', descripcionServicio: '$descripcionServicio',
                nombreResumido: '$nombreResumido', periodo: '$periodo', 'consecEnFra': '$consecEnFra'},
                valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
            {$unwind: "$_id"},
                {$project: {_id: 0, 'numeroFra': '$_id.numeroFra', 'concepto': '$_id.idRangoFact',
                'valorNC': '$_id.valorNC',
                'descrClaseServ': '$_id.descrClaseServ',
                'descripcionServicio': '$_id.descripcionServicio',
                'tipoGen': '$_id.codigoServicio',
                'codProcFact': '$_id.nombreResumido',
                'descrRecurso': '$_id.periodo',
                'totServ': '$_id.consecEnFra',                  
                'totFras': {
                    $let: {
                        vars: {valorSF: '$valorSF', valorIF: '$valorIF'},
                        in: { $cond: { if: { $gt: [ "$$valorIF", 0 ] },
                          then: {$divide: [ { $multiply: [ "$$valorIF", 100 ] }, "$$valorSF" ]},
                          else: 0 } }
                    }
                },
                valorSF: {$toInt: '$valorSF'}, valorIF: {$toInt: '$valorIF'}}}
              ]`
            }
            // console.time(1)
            let {data} = await this.props.allFactRtesGroup.refetch(argsBuscarFactUsu)
            let allFactRtesGroup = await data.allFactRtesGroup
            listaFra = listaFra.concat(allFactRtesGroup);
            // console.timeEnd(1)
          }
          // console.log(listaFra)
          //calcular el valor total de las fact al que se le puede hacer NC
          let valorSaldoNCFra = 0
          listaFra.forEach((elemento, i) => {
            valorSaldoNCFra += (elemento.valorSF + elemento.valorIF)
          })
          for(let i=0; i<lista4ConFra.length; i++){
            let indexFrado = listaFra.findIndex(elemento => elemento.numeroFra===lista4ConFra[i].numeroFra)
            if(indexFrado!==-1){
              valorSaldoNCFra -= listaFra[indexFrado].valorNC
            // }else{
            //   console.log(lista4ConFra[i].numeroFra)
            //   valorSaldoNCFra = 0
            }
          }
          if(lista4ConFra.length===0){
            console.log(lista4ConFra.length)
            valorSaldoNCFra = 0
          }
          //FIN calcular el valor total de las fact al que se le puede hacer NC
          // console.log(listNC[0].contrato, valorSaldoNCFra, valorNota)
          // console.log(listaFra.length, lista4ConFra.length, valorSaldoNCFra, valorNota)
          if(listaFra.length>0 && valorSaldoNCFra >= valorNota){
            // const elemento3 = listaFra
            listaFra.forEach((elemento, i) => {
              // console.log(elemento)
              listFactDetN.push({numeroFra: elemento.numeroFra, idRangoFact: elemento.concepto, valorNC: elemento.valorNC,
                codigoServicio: elemento.tipoGen,descrClaseServ: elemento.descrClaseServ,
                nombreResumido: elemento.codProcFact, descripcionServicio: elemento.descripcionServicio,
                periodo: elemento.descrRecurso, consecEnFra: elemento.totServ, porcImpto: Math.round(elemento.totFras),
                valorSF: elemento.valorSF, valorIF: elemento.valorIF, nuevoValor: elemento.valorSF + elemento.valorIF,
                _id: i, estadoSelecc: true
              });
            })
            // console.log(listFactDetN)
            // console.time(2)
            // console.log(lista4ConFra)
            await mainNC(listNC[0], clienteSel, lista4_1, lista4ConFra, listFactDetN,
              this.props.editSeqfindOneAndUpdate, this.props.createNotasDebCre,
              this.props.editNotasDebCreUpdDoc,
              this.props.createHistClienteMany, this.props.createMovClientes,
              this.props.editMovClientes, this.props.editCliente, fechaHoraHoy)
              // console.log(contratoFin)
            // console.timeEnd(2)
            
            setTimeout(async () => {
              this.props.allClientes.refetch()
              document.body.style.cursor = 'default'
            }, 1000)
            this.estadosFalse()
            this.setState({showClient: true})
          }else{
            if(listaFra.length>0 && valorSaldoNCFra >= valorNota){
              errors.push({path: "Contrato: " + listNC[0].contrato, message: "No hay facturas con saldo pendiente para hacerle Notas Crédito"});
            }else{
              errors.push({path: "Contrato: " + listNC[0].contrato, message: "El valor de la Nota Crédito es mayor al valor disponible en las facturas para hacer Notas Crédito O el valor de la nota es mayor al saldo del cliente"});
            }

            // console.log("NO NC => NO Existe Fra o Valor de NC pendiente con factura en fact es < al valor de la nota", listNC[0].contrato, clienteSel.saldoPendiente, listNC[0].valor)
          }
        }else{
          errors.push({path: "Contrato: " + listNC[0].contrato, message: "El valor de la Nota Crédito es mayor al valor de las facturas pendientes por pagar"});

          // console.log("NO NC => El valor pendiente con factura en movcli es < al valor de la nota", listNC[0].contrato, clienteSel.saldoPendiente, listNC[0].valor, valorSaldoConFra)
        }
      }else{
        errors.push({path: "Contrato: " + listNC[0].contrato, message: "El valor de la Nota Crédito es mayor al saldo pendiente"});

        // console.log("NO NC => Saldo < valor nota", listNC[0].contrato, clienteSel.saldoPendiente, listNC[0].valor)
      }
    }
    if(errors.length>0){
      this.setState({errorAdd: errors})
      document.body.style.cursor = 'default'
    }  
  }
}

handleSubmitAju = async (ev, stConcepto, stValor, argsDocum, lista4) => {
  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []

// console.log(data.allClientes[0].saldoPendiente)
// let allClientes = await data.allClientes
// clienteSel = allClientes[0]
  let errors = []
  let saldoPendiente = -99999999
  if(this.props.allClientes.allClientes){
    let {data} = await this.props.allClientes.refetch({contrato: argsDocum.contrato})
    saldoPendiente = await data.allClientes[0].saldoPendiente
  }
  if(saldoPendiente === -99999999){
    errors.push({path: 'Ajuste', message: `Cargando la información del cliente`});
  }

  if(!stConcepto){
    errors.push({path: 'Concepto', message: `Por favor escriba el concepto`});
  }
  if(stValor<=0){
    errors.push({path: 'Valor', message: `El valor del ajuste ($${stValor}) no puede ser menor o igual a cero`});
  }

  if(errors.length>0){
    this.setState({errorAdd: errors})
  }else{
    //PARA CONTROLAR QUE NO SE ENTRE A RECIBIR PAGOS POR OPCIONES DIFERENTES A ENTRADA DEL USUARIO
    //ESTO PORQUE SE ESTAN CREANDO PAGOS DUPLICADOS
    let horaEntradaAnt = sessionStorage.getItem('horaEntrada')
    let horaEntrada = new Date().getTime();
    let difHoraEntrada = 3000
    if(horaEntradaAnt){
      // console.log(horaEntradaAnt)
      difHoraEntrada = horaEntrada - horaEntradaAnt
    }else{
      difHoraEntrada = 8000
    }

    if(difHoraEntrada>7000){
      sessionStorage.setItem("horaEntrada", horaEntrada);

      // let fechaHoy = new Date()
      // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)
      let horaHoy = fechaHoraHoy.substr(11, 8)

      let origen = "", saldoCl = 0, valorMC = 0, valorPag = 0
      let argsAdd = {}
      let creaColecc = [], movColecc = []
      let numeroAjuste = await this.nextVal('aju')
      numeroAjuste = numeroAjuste.toString()
      let tipoAjuste = "", clase = ""
      if(this.state.permiteAjP){
        tipoAjuste = "AP"
        origen = `Ajuste positivo ${numeroAjuste}`
        clase = "Ajuste positivo"
        saldoCl = parseInt(saldoPendiente, 10) + parseInt(stValor, 10)
      }else{
        tipoAjuste = "AN"
        origen = `Ajuste negativo ${numeroAjuste}`
        clase = "Ajuste negativo"
        saldoCl = parseInt(saldoPendiente, 10) - parseInt(stValor, 10)
      }

      // let valor = 0
      // if(this.state.permiteAjP){
        let valor = stValor
      // }else{
      //   valor = 0 - stValor
      // }

      argsAdd['tipoAjuste'] = tipoAjuste
      argsAdd['numeroAjuste'] = numeroAjuste
      argsAdd['fechaAjuste'] = fechaHoy
      argsAdd['contrato'] = argsDocum.contrato
      argsAdd['concepto'] = stConcepto
      argsAdd['valorAjuste'] = valor
      creaColecc.push(argsAdd)

      //CREA REGISTRO EN HISTCLIENTES
      let creaHC = []
      let argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": argsDocum.contrato,
        "movimiento": "Ajuste",
        "descripcion": clase,
        "detalle": stConcepto,
        "relacion": numeroAjuste,
        "valor": valor,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      creaHC.push(argsAddHC)

      //Crear el ajuste
      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }

      argsCrud[numDocCRUD] = creaColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createAjuste

      await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      //Crear el registro en histclientes
      let creaHCMany = [], creaHCMany1 = []
      creaHC.forEach((elementoHC, ii) => {
        creaHCMany.push(elementoHC)
      })
      creaHCMany1.push({histcliente: creaHCMany})

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createHistClienteMany)
      }

      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createHistClienteMany

      // console.log(crudColecc)
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      //actualizar saldo cliente
      let actColecc = []
      creaColecc = []
      let argsUpd = {
        "tipoAct": "EditarCliOdeS",
        "_id": this.state.idLista._id,
        "estadoCliente": this.state.idLista.estadoCliente,
        "cargoMensual": this.state.idLista.cargoMensual,
        "saldoPendiente": saldoCl,
      }
      actColecc.push(argsUpd)

      //crear registro en movclientes
      if(this.state.permiteAjP){
        valorMC = stValor
        if(saldoCl<=0){
          valorPag = valorMC
        }
        if(saldoCl<stValor&&saldoCl>0){
          valorPag = parseInt(stValor, 10) - saldoCl
        }
      }else{
        valorMC = stValor * -1
        // if(saldoCl<=0){
          valorPag = valorMC
        // }
      }

      //traer clase si todos los servicios de la tarifa son de la misma clase
      let claseServSig = "NoDefinida", claseServSig1 = ""
      if(this.state.idLista.tarifa.codigoTarifa){
        claseServSig1 = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        claseServSig = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
        this.state.idLista.tarifa.servicios.forEach((elemento, _id) => {
          if(claseServSig1!==claseServSig){
            claseServSig = "NoDefinida"
          }
        })
      }
      // console.log(claseServSig)

      let argsAddAju = {
        "contrato": argsDocum.contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": tipoAjuste,
        "procesado": "S",
        "nombreResumido": stConcepto,
        "descripcionServicio": "Ajuste",
        "descrClaseServ": claseServSig,
        "concepto": "Ajuste",
        "origen": origen,
        "saldoCliente": saldoCl,
        "valorTotal": valorMC,
        "valorAntesImptos": valorMC,
        "documento": numeroAjuste,
        "valorPagado": valorPag,
        "valorPendiente": valorMC - valorPag,
        "numeroOdeDX": 0,
        "fechaCreate": fechaHoraHoy,
      };
      creaColecc.push(argsAddAju)
      // console.log(argsAddAju)
      // console.log(lista4)

      if(saldoCl<=0){
        lista4.forEach((elemento1, ii) => {
          argsUpd = {
            "contrato": argsDocum.contrato,
            "_id": elemento1._id,
            "procesado": elemento1.procesado,
            "concepto": elemento1.concepto,
            "numeroFra": elemento1.numeroFra,
            "numeroRC": elemento1.numeroRC,
            "numeroCE": elemento1.numeroCE,
            "numeroOdeDX": elemento1.numeroOdeDX,
            "fechaUltPago": elemento1.fechaUltPago,
            "valorUltPago": elemento1.valorUltPago,
            "documento": elemento1.documento,
            "valorPagado": elemento1.valorTotal,
            "valorPendiente": 0
          }
          movColecc.push(argsUpd)
        })
      }

      numDocCRUD = 0
      totDocCRUD = movColecc.length + 2
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovClientes)
      }

      argsCrud[numDocCRUD] = creaColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createMovClientes

      numDocCRUD += 1

      movColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })

      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCliente

      // numDocCRUD += 1
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      if(!this.state.permiteAjP){
        //SI ES AJUSTE NEGATIVO => AFECTA LOS MOVIMIENTOS DEL CLIENTE
        let totRecib = stValor
        let listColecc = lista4.map(recpago => ({...recpago}))
        listColecc = _.orderBy(listColecc, ['_id'], ['asc'])

        let estCl = this.state.idLista.estadoCliente
        let ultFRX = this.state.idLista.fecgaUltRX
        
        let numDX = this.state.idLista.numeroOdeDX
        let valorparaPermRX = this.props.getParametro.getParametro.valorparaPermRX
        let hacerRX = true
        if(numDX===0){
          hacerRX = false
        }
  
        if(saldoCl>0){
          listColecc.forEach((elemento, i) => {
            if(elemento.valorTotal<0){
              totRecib -= elemento.valorTotal
              listColecc[i].valorRecibido = elemento.valorTotal
            }
          })
          listColecc.forEach((elemento, i) => {
            if(elemento.valorTotal>0){
              if(totRecib > elemento.valorTotal - elemento.valorPagado){
                totRecib -= (elemento.valorTotal - elemento.valorPagado)
                listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
              }else{
                listColecc[i].valorRecibido = totRecib
                totRecib = 0
              }
            }
          })
          
          let movColecc = []
          // console.log(listColecc)
          listColecc.forEach((elemento1, ii) => {
            if(numDX>0&&elemento1.numeroOdeDX>0&&(!elemento1.valorRecibido||elemento1.valorRecibido===0)&&
                elemento1.valorTotal>0){
              hacerRX = false
            }
            if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
              let valPagado = 0
              if(elemento1.valorPagado){
                valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
              }else{
                valPagado = parseInt(elemento1.valorRecibido, 10)
              }
              let valParaHacerRX = parseInt(valPagado, 10) + parseInt(valorparaPermRX, 10)
              // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal)
              // if(numDX>0&&elemento1.numeroOdeDX>0&&valPagado<elemento1.valorTotal&&elemento1.valorTotal>0){
              if(numDX>0&&elemento1.numeroOdeDX>0&&valParaHacerRX<elemento1.valorTotal&&elemento1.valorTotal>0){
                // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal)
                hacerRX = false
              }

              argsUpd = {
                "contrato": this.state.idLista.contrato,
                "_id": elemento1._id,
                "procesado": elemento1.procesado,
                "concepto": elemento1.concepto,
                "numeroFra": elemento1.numeroFra,
                "numeroRC": elemento1.numeroRC,
                "numeroCE": elemento1.numeroCE,
                "numeroOdeDX": elemento1.numeroOdeDX,
                "documento": elemento1.documento,
                "fechaUltPago": elemento1.fechaUltPago,
                "valorUltPago": elemento1.valorUltPago,
                "valorPagado": valPagado,
                "valorPendiente": elemento1.valorTotal - valPagado
              }
              movColecc.push(argsUpd)
            }
          })

          //Actualizar BD
          numDocCRUD = 0
          totDocCRUD = movColecc.length + 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editMovClientes)
          }

          movColecc.forEach((elemento1, ii) => {
            argsCrud[numDocCRUD] = elemento1
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

            numDocCRUD += 1
          })

          //Actualizar saldo despues de actualizar movim => para calcular diasMora
          argsCrud[numDocCRUD] = actColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editCliente

          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        let movCli = [], movCliRX = [], actServCli = []
    
        if(hacerRX){
          //PROCESO CREAR DOCUM DE CARGUE EN MOVIMCLIENTE POR DX
          // console.log(this.props.getParametro.getParametro.comoAsigCargosAlCliente)
          let saldoClCC = saldoCl

          // let fechaHoy = new Date()
          // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          let fechaHoy = fechaHoraHoy.substr(0, 10)
    
          //traer el número de días del mes
          const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
          const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1
    
          let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
          let diaFra= parseInt(fechaHoy.substr(8, 2), 10)
          let periodoFrado = ""
          // let numServ=0
    
          let elemento3 = []
          let difSaldoNeg = 0, valorPagNeg = 0
          //verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
          //los cargos positivos
          if(this.state.idLista.tarifa.codigoTarifa){
            elemento3 = this.state.idLista.tarifa
            elemento3.servicios.forEach((elemento1, i) => {
              if(elemento1.estadoServicio==="D"){
                let numDNvo = numDM - ddI
                let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
                
                if(valorServ<0){
                  valorPagNeg += valorServ
                }
              }
            })
            if(saldoCl<(valorPagNeg * -1)){
              difSaldoNeg = (valorPagNeg * -1) - saldoCl
            }
          }
    
          // console.log("Hacer RX")
          let agnoFra = fechaHoy.substr(0, 4)
          let mesFra = fechaHoy.substr(5, 2)
    
          elemento3 = []
    
          // listColecc.forEach((elemento, ii) => {
          //   if(numDX>0&&elemento.numeroOdeDX>0){
          if(this.state.idLista.tarifa.codigoTarifa){
            elemento3 = this.state.idLista.tarifa
            // console.log(elemento3.servicios.length)
            elemento3.servicios.forEach((elemento1, i) => {
              // console.log(elemento1)
              // if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
              if(elemento1.estadoServicio==="D"){
                //Si esta DX => crear movcliente => siempre carga porque al dx se le descontó
                // let listServCargoFra = []
                let numDNvo = numDM - ddI
                let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
                let valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)
    
                let valorPag = 0
                if(difSaldoNeg>0&&valorServ>0){
                  if(difSaldoNeg-valorServ>=0){
                    valorPag = valorServ
                  }else{
                    valorPag = difSaldoNeg
                  }
                  difSaldoNeg -= valorPag
                }
    
                if(saldoCl<0&&valorServ>0){
                  if(saldoCl+valorServ>0){
                    valorPag = saldoCl * -1
                  }else{
                    valorPag = valorServ
                  }
                }
                if(valorServ<0){
                  valorPag = valorServ
                }                
    
                periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
                periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM
    
                let numServ = elemento1.numeroServicios
                if(numServ!==0){
                  let imptosServ = elemento1.imptos.map(impto => ({
                    ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
                  if(valorServ!==0){
                    // listServCargoFra.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
                    //   codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                    //   _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                    //   descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                    //   codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                    //   numeroServicios: numServ, valorServicios: valorServ, imptos: imptosServ,
                    //   agnoFra: agnoFra, mesFra: mesFra, fechaCargo: fechaHoy, periodoFrado: periodoFrado,
                    //   valorAntesImptos: valorAntesI,
                    //   _id: i
                    // });
    
                    //CREA REGISTRO EN movclientes
                    saldoCl += valorServ
                    argsUpd = {}
    
                    let movCliI = [], actCargoFra = []
                    argsUpd = {}
                    imptosServ.forEach((elementoI, ii) => {
                      if(elementoI.codigoImpto!==null){
                        argsUpd = {
                          "codigoImpto": elementoI.codigoImpto,
                          "descrImpto": elementoI.descrImpto,
                          "porcImpto": elementoI.porcImpto,
                          "valorImpto": elementoI.valorImpto,
                        }
                        movCliI.push(argsUpd)
                      }
                    })
    
                    //PARA CUANDO SE FACTURA UN MES ANTERIOR
                    let ultMF = ""
                    let tieneMCCMesAnt = true
                    let lista8CC = this.props.allMovClientesCC.allMovClientesCC
    
                    let agno = fechaHoy.substr(0, 4)
                    let mes = fechaHoy.substr(5, 2)
    
                    let ultPF = this.props.allProcFact1.allProcFact.filter(elemento => elemento.cicloFact===this.state.idLista.cicloFact)
                    if(ultPF.length>0){
                      ultMF = ultPF[ultPF.length-1].mes
                    }
                    let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
                    //Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
                    //en movcliccs
                    if(difmesesUMF>1){
                      let mesMA = parseInt(mes, 10)
                      let agnoMA = agno
                      if(mes==="01"){
                        agnoMA = (parseInt(agno, 10) - 1).toString()
                        mesMA = "12"
                      }else{
                        mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                      }
                      // console.log(agnoMA + "-" + mesMA)
                      let indexFrado = lista8CC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
                      if(indexFrado===-1){
                        //NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
                        //como NO FACTURAR
                        tieneMCCMesAnt = false
                      }  
                    }
    
                    //verificar si NO tiene mov en el mes ant
                    if(!tieneMCCMesAnt){
                      //verificar si esta des, sus o ret, la os lo va a pasar a act
                      if(this.state.idLista.estadoCliente==="DESCONECTADO"||this.state.idLista.estadoCliente==="SUSPENDIDO"||
                          this.state.idLista.estadoCliente==="RETIRADO"){
                        //crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
                        //esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
                        let fechaHoyMA = new Date()
                        let agnoMA = (fechaHoyMA.getFullYear()).toString()
                        let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
                        mesMA = parseInt(mesMA, 10)
                        if(mesMA==="01"){
                          agnoMA = (parseInt(agnoMA, 10) - 1).toString()
                          mesMA = "12"
                        }else{
                          mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                        }
                        // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
                        let periodoFradoMA = "NO FACTURAR"
                        // let pruebaFMA =[]
                        // pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
    
                        argsUpd = {}
                        argsUpd = {
                          "contrato": argsDocum.contrato,
                          "fechaMov": fechaHoy,
                          "tipo": "C",
                          "subTipo": "RX",
                          "procesado": "N",
                          "codigoServicio": elemento1.codigoServicio,
                          "nombreResumido": elemento1.nombreResumido,
                          "descripcionServicio": elemento1.descripcionServicio,
                          "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                          "periodo": periodoFradoMA,
                          "origen": "DX-" + this.state.idLista.numeroOdeDX,
                          "saldoCliente": saldoCl,
                          "valorTotal": 0,
                          "valorAntesImptos": 0,
                          "agno": agnoMA,
                          "mes": mesMA,
                          "valorPagado": 0,
                          // "valorPendiente": elemento1.valorTotal - valorPag,
                          "usuarioCreate": sessionStorage.getItem('userLogin'),
                          "imptos": []
                        };
                        actCargoFra.push(argsUpd)
    
                        // console.log(pruebaFMA)
                        // console.log(listServCargoFra)
                      }
                    }
                    //FIN PARA CUANDO SE FACTURA UN MES ANTERIOR
    
                    argsUpd = {}
                    argsUpd = {
                      "contrato": argsDocum.contrato,
                      "fechaMov": fechaHoy,
                      "tipo": "C",
                      "subTipo": "RX",
                      "procesado": "N",
                      "codigoServicio": elemento1.codigoServicio,
                      "nombreResumido": elemento1.nombreResumido,
                      "descripcionServicio": elemento1.descripcionServicio,
                      "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                      "periodo": periodoFrado,
                      "origen": "DX-" + this.state.idLista.numeroOdeDX,
                      "saldoCliente": saldoCl,
                      "valorTotal": valorServ,
                      "valorAntesImptos": valorAntesI,
                      "agno": agnoFra,
                      "mes": mesFra,
                      "valorPagado": valorPag,
                      // "valorPendiente": elemento1.valorTotal - valorPag,
                      "usuarioCreate": sessionStorage.getItem('userLogin'),
                      "imptos": movCliI
                    };
                    actCargoFra.push(argsUpd)
    
                    actCargoFra.forEach((elementoDX, ii) => {
                      if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                        movCliRX.push(elementoDX)
                      }else{
                        movCli.push(elementoDX)
                      }
    
                      argsUpd = {}
                      argsUpd['tipoAct'] = "EditarServDX"
                      argsUpd['contrato'] = argsDocum.contrato
                      argsUpd['tarifa'] = { codigoTarifa: this.state.idLista.tarifa.codigoTarifa, servicios: 
                                        [{"codigoServicio": elementoDX.codigoServicio,
                                          "estadoServicio": "A"}]}
                      actServCli.push(argsUpd)
                    })
                  }
                }
              }
            })
          }
          //   }
          // })
          // //FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
          // console.log(saldoCl, saldoClCC)
          if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
            saldoCl = saldoClCC
          }

          creaHC = []
          argsAddHC = {
            "fechaHistCliente": fechaHoy + ' ' + horaHoy,
            "contrato": argsDocum.contrato,
            "movimiento": "Ajuste",
            "descripcion": clase,
            "detalle": "Se hace RX por Ajuste",
            "relacion": numeroAjuste,
            "valor": valor,
            "usuarioCreate": sessionStorage.getItem('userLogin'),
          }
          creaHC.push(argsAddHC)
          //Crear el registro en histclientes
          let creaHCMany = [], creaHCMany1 = []
          creaHC.forEach((elementoHC, ii) => {
            creaHCMany.push(elementoHC)
          })
          creaHCMany1.push({histcliente: creaHCMany})
    
          numDocCRUD = 0
          totDocCRUD = 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.createHistClienteMany)
          }

          argsCrud[numDocCRUD] = creaHCMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.createHistClienteMany
    
          // console.log(crudColecc)
          // console.log(argsCrud)
          // console.log(totDocCRUD)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        if(movCli.length>0||movCliRX.length>0){
          let actCli = [], actCliMany = [], movCliMany = [], movCliRXMany = [], actServCliMany = []

          let numOdeDX = 0
          if(!hacerRX&&this.state.idLista.numeroOdeDX>0){
            numOdeDX = this.state.idLista.numeroOdeDX
          }
          argsUpd = {}
          argsUpd = {
            "tipoAct": "EditarCliDX",
            "contrato": argsDocum.contrato,
            "numeroOdeDX": numOdeDX,
          }
          actCli.push(argsUpd)
          actCli.forEach((elementoDX, ii) => {
            actCliMany.push(elementoDX)
          })
          movCli.forEach((elementoDX, ii) => {
            movCliMany.push(elementoDX)
          })
          movCliRX.forEach((elementoDX, ii) => {
            movCliRXMany.push(elementoDX)
          })
          actServCli.forEach((elementoDX, ii) => {
            actServCliMany.push(elementoDX)
          })

          let actCliMany1 = []
          actCliMany1.push({cliente: actCliMany})
          let movCliMany1 = [], movCliRXMany1 = []
          movCliMany1.push({movcliente: movCliMany})
          if(movCliRX.length>0){
            movCliRXMany1.push({movcliente: movCliRXMany})
          }
          let actServCliMany1 = []
          actServCliMany1.push({cliente: actServCliMany})

          numDocCRUD = 0
          if(movCliRX.length>0){
            totDocCRUD = 4
          }else{
            totDocCRUD = 3
          }
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.createMovClientesMany)
          }

          argsCrud[numDocCRUD] = actCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteMany

          numDocCRUD += 1

          argsCrud[numDocCRUD] = actServCliMany1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

          numDocCRUD += 1

          if(movCliRX.length>0){
            argsCrud[numDocCRUD] = movCliRXMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.createMovCliCCMany

            numDocCRUD += 1
          }
          
          if(movCli.length>0){
            argsCrud[numDocCRUD] = movCliMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.createMovClientesMany
          }

          // console.log(argsCrud)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)

          if(this.state.idLista.estadoCliente!=="ACTIVO"&&hacerRX){
            estCl = "ACTIVO"
            ultFRX = fechaHoy
          }
        }

        //ACTUALIZAR DIASMORA
        //para calcular diasmora =>
        //diasMora = movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0
        // let movimDX1 = await listColecc.map(movim => ({
        //   ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0}))
        let actCli = [], fechaPH = null
        if(saldoCl>0){
          let fechaMora = new Date()
          fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
          let movimDX1 = await listColecc.map(movim => ({
            ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
          let fechaHoy1 = new Date()
          let diasHoy = fechaHoy1.getUTCDate()
          let mesHoy = fechaHoy1.getMonth()+1

          let diasMora = 0, diasMoraMayor = 0
          await movimDX1.forEach((movim, ii) => {
            // console.log(movim)
            diasMora = 0
            if(movim.pagueHasta&&movim.valorTotal>(movim.valorPagado+movim.valorRecibido)&&movim.valorTotal>0){
              if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&this.state.idLista.cargoMensual>0){
                //Math.ceil redondea al entero por encima
                  let mesesM = Math.ceil((movim.valorTotal - (movim.valorPagado+movim.valorRecibido)) / this.state.idLista.cargoMensual)
                  if(movim.codigoServicio==="SISTV"){
                    diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
                  }else{
                    diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
                  }
                // console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
              }else{
                diasMora = movim.diasMora
              }
            }
            if(diasMora>diasMoraMayor||(diasMora<0&&diasMoraMayor===0)){
              diasMoraMayor = diasMora
            }
          })
          if(diasMoraMayor!==0){
            let fechaInicio = new Date(fechaMora).getTime();
            let fechaFin = new Date(fechaInicio-(diasMoraMayor*1000*60*60*24)+(1000*60*60*24));
            fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
          }else{
            fechaPH = null
          }
        }else{
          fechaPH = null
        }
        argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarCliPagueHasta",
          "contrato": this.state.idLista.contrato,
          "pagueHasta": fechaPH,
        }
        actCli.push(argsUpd)
        //FIN ACTUALIZAR DIASMORA

        actColecc = []
        argsUpd = {
          "tipoAct": "EditarCliOdeS",
          "_id": this.state.idLista._id,
          "estadoCliente": estCl,
          "cargoMensual": this.state.idLista.cargoMensual,
          "saldoPendiente": saldoCl,
        }
        actColecc.push(argsUpd)

        let actFechas = []
        argsUpd = {
          "tipoAct": "EditarFechCli",
          "_id": this.state.idLista._id,
          "fechaUltOSAb": this.state.idLista.fechaUltOSAb,
          "fechaPrimeraActivacion": this.state.idLista.fechaPrimeraActivacion,
          "fechaUltDX": this.state.idLista.fechaUltDX,
          "fecgaUltRX": ultFRX,
          "estadoAnterior": this.state.idLista.estadoAnterior,
          "fechaUltOSCe": this.state.idLista.fechaUltOSCe,
          "fechaUltPago": this.state.idLista.fechaUltPago,
          "valorUltPago": this.state.idLista.valorUltPago,
        }
        actFechas.push(argsUpd)

        //Actualizar BD
        numDocCRUD = 0
        // totDocCRUD = movColecc.length + 2
        totDocCRUD = movColecc.length + 3
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editMovClientes)
        }

        argsCrud[numDocCRUD] = actFechas[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        numDocCRUD += 1

        argsCrud[numDocCRUD] = actCli[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        numDocCRUD += 1

        // console.log(movColecc)
        movColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

          numDocCRUD += 1
        })

        argsCrud[numDocCRUD] = actColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        // numDocCRUD += 1

        // console.log(crudColecc)
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }

      setTimeout(async () => {
        this.props.allClientes.refetch()
      }, 1000)

      this.estadosFalse()
      this.setState({showClient: true})
    }
  }
}

handleEnvCorreo = async (ev, idListaF, empresa, allRangoFact) => {
  // console.log(idListaF, this.state.idLista, empresa)

  let stImprFact = true
  let listFactCl_T = []

  let clientesFraDoc = this.state.idLista
  clientesFraDoc['factMod'] = "Modelo 2"  // aplica para   conectic, supercable, supercablebq

  let fraCliente = idListaF
  fraCliente['apellidoCliente'] = "Enviar por correo"

  listFactCl_T.push({listFact: fraCliente, clientesFra: clientesFraDoc})

  let list = allRangoFact
  let list2 = this.props.allProcFact1.allProcFact

  let listFactCl = []
  listFactCl.push(listFactCl_T[0])
  // console.log(listFactCl, listFactCl_T[iii])

  // Enviar pdf de la factura al servidor
  imprFactEC(listFactCl, list2, list, empresa, stImprFact)

  setTimeout(async () => {
    this.props.allClientes.refetch()
  }, 1000)

  let creaFraMany_T = []
  let argsUpd = {
    "numeroFra": fraCliente.numeroFra,
    "eMail": clientesFraDoc.eMail,
    "contrato": fraCliente.contrato,
    "nombreCliente": clientesFraDoc.nombreCliente,
    "apellidoCliente": clientesFraDoc.apellidoCliente
  };
  creaFraMany_T.push(argsUpd)

  let iii = 0
  const startTime = async (creaFraMany_T) => {
    setTimeout(async ()=>{
      // console.log(iii, creaFraMany_T.length)
      if(iii<creaFraMany_T.length){
        let creaFraMany = []
        creaFraMany.push(creaFraMany_T[iii])

        let creaFraMany1 = []
        creaFraMany1.push({facturacion: creaFraMany})
      
        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.enviarCorreoFact)
        }
      
        argsCrud[numDocCRUD] = creaFraMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.enviarCorreoFact

        // Enviar correo con factura
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)

        await startTime(creaFraMany_T)

        iii += 1
      }else{
        // alert(`Proceso ENVIAR CORREO finalizado`)
      }
    }, 200);
  }
  await startTime(creaFraMany_T)

  setTimeout(async () => {
    this.props.allClientes.refetch()
  }, 1000)

  this.estadosFalse()
  this.setState({showClient: true})
}

handleConfDatos = async (ev, confDatos_EnvCorreo) => {
  // Actualiza datosConfirmados / envFraCorreo
  let editDatosBas = []
  let argsUpd = {}
  if(confDatos_EnvCorreo==="confDatos"||confDatos_EnvCorreo==="habCambDatos"){
    argsUpd = {
      "accionBD": this.props.editCliente,
      "tipoAct": "ConfHabDatosBas",
      "contrato": this.state.idLista.contrato,
      "datosConfirmados": confDatos_EnvCorreo==="confDatos"?"SI":"NO",
    }
  }else{
    argsUpd = {
      "accionBD": this.props.editCliente,
      "tipoAct": "EditarCliEnvFraCorreo",
      "contrato": this.state.idLista.contrato,
      "envFraCorreo": confDatos_EnvCorreo==="enviar"?"S":"N",
    }
  }
  editDatosBas.push(argsUpd)
  await this.props.editCliente({
    variables: editDatosBas[0]
  });
  // console.log(argsUpd)
  setTimeout(async () => {
    this.props.allClientes.refetch()
  }, 1000)

  this.estadosFalse()
  this.setState({showClient: true})
}

handleAnularPago = async (ev, idListaP, razonap, updFechaPago, anular_updfechapago) => {
  // console.log(idListaP)
//   console.log(ev.target.name)
//   let datoUpd1 = document.getElementById("btnRazonap");
//   let datoUpd2 = document.getElementById("btnFechaPago");
// console.log(anular_updfechapago)
// console.log(datoUpd1, datoUpd2)

  let response = await this.props.fecha({
    variables: {}
  });
  const {fechaHoraHoy} = response.data.fecha
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)

  let numDocCRUD = 0, totDocCRUD = 0, argsCrud = [], crudColecc = []

  if(anular_updfechapago==="btnfechaPago"){
    let horaHoy = idListaP.fechaCreate.substr(11, 8)
    let movColecc = [], creaHC = []
    let argsUpd = {
      "_id": idListaP._id,
      "tipoAct": "EditFechaPago",
      "fechaPago": updFechaPago,
      "fechaCreate": updFechaPago + " " + horaHoy
    }
    movColecc.push(argsUpd)

    //CREA REGISTRO EN HISTCLIENTES
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": this.state.idLista.contrato,
      "movimiento": "Pago",
      "descripcion": "CAMBIO FECHA DE PAGO",
      "detalle": idListaP.fechaPago + " => " + updFechaPago,
      "relacion": idListaP.numeroRC,
      "valor": idListaP.valorTotal,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

    //Crear el registro en histclientes
    let creaHCMany = [], creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    //Actualizar BD
    totDocCRUD = 2
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editPagoClientes)
    }

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany

    numDocCRUD += 1

    argsCrud[numDocCRUD] = movColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editPagoClientes

    // console.log(crudColecc)
    // console.log(argsCrud)
    // console.log(totDocCRUD)
    this.updColecc(crudColecc, argsCrud, totDocCRUD)
  }
  if(anular_updfechapago==="btnrazonap"){
    let saldoCl = -99999999
    if(this.props.allClientes.allClientes){
      let {data} = await this.props.allClientes.refetch({contrato: this.state.idLista.contrato})
      saldoCl = await data.allClientes[0].saldoPendiente + idListaP.valorTotal
    }
    if(saldoCl === -99999999){
      saldoCl = this.state.idLista.saldoPendiente + idListaP.valorTotal
    }
    // let saldoCl = this.state.idLista.saldoPendiente + idListaP.valorTotal
    // console.log(this.state.idLista.saldoPendiente)
    // console.log(this.state.idLista)
    // console.log(idListaP.valorTotal)
    // console.log(saldoCl)
    let movColecc = [], movCli = [], actColecc = []
    // console.log(document.getElementById("razonap"))
    let argsUpd = {
      "_id": idListaP._id,
      "tipoAct": "EditAnular",
      "documento": "ANULADO",
      "razonap": razonap
    }
    movColecc.push(argsUpd)
    // console.log(argsUpd)

    let documPago = "FRA " + idListaP.numeroFra
    let relacion = idListaP.numeroFra

    if(idListaP.tipo!=="OP"){
      documPago = "RC " + idListaP.numeroRC
      relacion = idListaP.numeroRC
      let periodo = documPago
      // let procesado = "S"

      // let valorPagado = 0
    
      if(idListaP.tipo==="PA"){
        documPago = "FRA " + idListaP.numeroFra
        relacion = idListaP.numeroFra
        // procesado = "S"
        periodo = idListaP.descripcionPago
        // valorPagado = idListaP.valorTotal
      }else{
        // if(this.state.idLista.saldoPendiente+valorPagado<0){
        //   if(this.state.idLista.saldoPendiente+idListaP.valorTotal>0){
        //     valorPagado = (this.state.idLista.saldoPendiente)*-1
        //   }else{
        //     valorPagado = (idListaP.valorTotal)
        //   }
        // }
      }
      let codigoServicio = "PAGOANUL"
      let nombreResumido = "Pago ANULADO - " + documPago
      let descripcionServicio = "Pago ANULADO - " + documPago
      let descrClaseServ = "Pago ANULADO"
      let concepto = "Pago ANULADO - " + documPago
      // console.log(idListaP.detalle)
      if(idListaP.detalle.length>0){
        codigoServicio = idListaP.detalle[0].codigoServicio
        nombreResumido = idListaP.detalle[0].nombreResumido
        descripcionServicio = idListaP.detalle[0].descripcionServicio
        descrClaseServ = idListaP.detalle[0].descrClaseServ
      }else{
        console.log("Se encuentra inconsistencia en la transacción, por favor informar al administrador del sistema")
        // alert("Se encuentra inconsistencia en la transacción, por favor informar al administrador del sistema")
      }
      let argsAdd = {
        "contrato": this.state.idLista.contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": "CE",
        "procesado": "S",

        "codigoServicio": codigoServicio,
        "nombreResumido": nombreResumido,
        "descripcionServicio": descripcionServicio,
        "descrClaseServ": descrClaseServ,
        "concepto": concepto,

        "periodo": periodo,
        "origen": "Pago ANULADO",
        "saldoCliente": saldoCl,
        "valorTotal": idListaP.valorTotal,
        "valorAntesImptos": idListaP.valorTotal,
        "numeroRC": idListaP.numeroRC,
        "numeroFra": idListaP.numeroFra,
        "documento": "ANULADO",
        "valorPagado": idListaP.valorTotal,
        "valorPendiente": 0,
        "numeroOdeDX": 0,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
        "fechaCreate": fechaHoraHoy,
      };
      movCli.push(argsAdd)
      // console.log(argsAdd)
      argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarCliOdeS",
        "_id": this.state.idLista._id,
        "estadoCliente": this.state.idLista.estadoCliente,
        "cargoMensual": this.state.idLista.cargoMensual,
        "saldoPendiente": saldoCl,
      }
      actColecc.push(argsUpd)
    }

//CREA REGISTRO EN HISTCLIENTES
    let creaHC = []
    let argsAddHC = {
      "fechaHistCliente": fechaHoy + ' ' + horaHoy,
      "contrato": this.state.idLista.contrato,
      "movimiento": "Pago",
      "descripcion": "ANULADO",
      "detalle": documPago,
      "relacion": relacion,
      "valor": idListaP.valorTotal,
      "usuarioCreate": sessionStorage.getItem('userLogin'),
    }
    creaHC.push(argsAddHC)

//Actualizar BD
    numDocCRUD = 0
    totDocCRUD = 3
    if(idListaP.tipo==="OP"){
      totDocCRUD = 1
    }
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editPagoClientes)
    }

    if(idListaP.tipo!=="OP"){
      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editCliente

      numDocCRUD += 1

      argsCrud[numDocCRUD] = movCli[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createMovClientes

      numDocCRUD += 1
    }

    argsCrud[numDocCRUD] = movColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editPagoClientes

  // console.log(crudColecc)
  // console.log(argsCrud)
  // console.log(totDocCRUD)
    this.updColecc(crudColecc, argsCrud, totDocCRUD)

//Crear el registro en histclientes
    let creaHCMany = [], creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})

    numDocCRUD = 0
    totDocCRUD = 1
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createHistClienteMany)
    }

    argsCrud[numDocCRUD] = creaHCMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createHistClienteMany

// console.log(crudColecc)
// console.log(argsCrud)
// console.log(totDocCRUD)
    this.updColecc(crudColecc, argsCrud, totDocCRUD)

    // Actualizar fechaUltPago
    let argsBuscarMC={}
    argsBuscarMC.orden='-_id'
    argsBuscarMC.contrato=this.state.idLista.contrato
    let pagosCli = []
    if(this.props.getPagoCliente.getPagoCliente){
       if(this.props.getPagoCliente.getPagoCliente.length>0){
        pagosCli = this.props.getPagoCliente.getPagoCliente
       }
    }
    if(pagosCli.length>0){
      let fechaUltPago = null
      let valorUltPago = 0
      for(let ii=0; ii<pagosCli.length; ii++){
        if(pagosCli[ii].documento!=="ANULADO"&&pagosCli[ii].tipo==="PO"&&idListaP.documento!==pagosCli[ii].documento){
          fechaUltPago = pagosCli[ii].fechaPago
          valorUltPago = pagosCli[ii].valorTotal
          ii = pagosCli.length
        }
      }
      if(valorUltPago>0){
        let actFechas = []
        argsUpd = {
          "tipoAct": "EditarFechCli",
          "_id": this.state.idLista._id,
          "fechaUltOSAb": this.state.idLista.fechaUltOSAb,
          "fechaPrimeraActivacion": this.state.idLista.fechaPrimeraActivacion,
          "fechaUltDX": this.state.idLista.fechaUltDX,
          "fecgaUltRX": this.state.idLista.fecgaUltRX,
          "estadoAnterior": this.state.idLista.estadoAnterior,
          "fechaUltOSCe": this.state.idLista.fechaUltOSCe,
          "fechaUltPago": fechaUltPago,
          "valorUltPago": valorUltPago,
        }
        actFechas.push(argsUpd)

        //Actualizar BD
        numDocCRUD = 0
        totDocCRUD = 1
        argsCrud = []
        crudColecc = []

        argsCrud[numDocCRUD] = actFechas[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        // console.log(crudColecc)
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }
    }
    // FIN Actualizar fechaUltPago

    let totAnul = 0
//si es otro pago del cliente o  pago adelantado => se anula la factura
    if(idListaP.tipo==="OP"||idListaP.tipo==="PA"){
      movColecc = []
      argsUpd = {}
      argsUpd = {
        "numeroFra": idListaP.numeroFra,
        "tipoAct": "EditAnular",
        "codProcFact": "ANULADA",
      }
      movColecc.push(argsUpd)

      numDocCRUD = 0
      totDocCRUD = 1
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editFacturacion)
      }

      argsCrud[numDocCRUD] = movColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editFacturacion

  // console.log(argsCrud)
      this.updColecc(crudColecc, argsCrud, totDocCRUD)

      if(idListaP.tipo==="PA"){
//Es pago adelantado => actualiza totPagoAdelSinFrar en clientes
        let totPagoAdelSinFrar = parseInt(this.state.idLista.totPagoAdelSinFrar, 10) - parseInt(idListaP.valorTotal, 10)

        let actPASFCli = []
        let argsUpd1 = {}
        argsUpd1 = {
          "tipoAct": "EditarCliPagoAdelSF",
          "contrato": this.state.idLista.contrato,
          "totPagoAdelSinFrar": totPagoAdelSinFrar,
        }
        actPASFCli.push(argsUpd1)
// console.log(argsUpd1)
        numDocCRUD = 0
        totDocCRUD = 1
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editCliente)
        }

        argsCrud[numDocCRUD] = actPASFCli[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editCliente

        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }
    }else{
//Actualizar valorPagado en los movcliente anulados
// console.log(this.props.allMovClientes.allMovClientes)
      let movCliVP = []
      let listaMov = await this.props.allMovClientes.allMovClientes
      let detalleP = idListaP.detalle
      // detalleP.forEach((elemento, i) => {
      for(let iiii=detalleP.length-1; iiii>=0; iiii--){
        let elemento = detalleP[iiii]
        // console.log(iiii, elemento)
        if(elemento.idMovClientes){
          const indexLis = listaMov.findIndex( movim => movim._id===elemento.idMovClientes );
          // console.log(indexLis, elemento.idMovClientes)
          // console.log(listaMov[indexLis].valorTotal, listaMov[indexLis].valorPagado, elemento.valorDetalle)
          if(indexLis!==-1){
            totAnul += listaMov[indexLis].valorTotal - (listaMov[indexLis].valorPagado - elemento.valorDetalle)
            let valorPagado = listaMov[indexLis].valorPagado - elemento.valorDetalle
            let valorPendiente = listaMov[indexLis].valorTotal - (listaMov[indexLis].valorPagado - elemento.valorDetalle)
            // console.log(totAnul, saldoCl)
            if(totAnul>saldoCl){
              if(valorPendiente - (totAnul - saldoCl)>=0){
                valorPendiente = valorPendiente - (totAnul - saldoCl)
                valorPagado = valorPagado + (totAnul - saldoCl)
                totAnul = saldoCl
                // console.log(valorPendiente, valorPagado, totAnul, saldoCl)
              }
            }
            
            argsUpd = {
              "contrato": listaMov[indexLis].contrato,
              "_id": listaMov[indexLis]._id,
              "procesado": listaMov[indexLis].procesado,
              "concepto": listaMov[indexLis].concepto,
              "numeroFra": listaMov[indexLis].numeroFra,
              "numeroRC": listaMov[indexLis].numeroRC,
              "numeroCE": listaMov[indexLis].numeroCE,
              "numeroOdeDX": listaMov[indexLis].numeroOdeDX,
              "documento": listaMov[indexLis].documento,
              "fechaUltPago": listaMov[indexLis].fechaUltPago,
              "valorUltPago": listaMov[indexLis].valorUltPago,
              "valorPagado": valorPagado,
              "valorPendiente": valorPendiente,
              // "valorPagado": listaMov[indexLis].valorPagado - elemento.valorDetalle,
              // "valorPendiente": listaMov[indexLis].valorTotal - (listaMov[indexLis].valorPagado - elemento.valorDetalle),
            }
            movCliVP.push(argsUpd)
            // console.log(argsUpd)
          }
        }
      }
      // })

// console.log(movCliVP)
      if(movCliVP.length>0){
        //Actualizar BD
        numDocCRUD = 0
        // console.log(totAnul)
        if(totAnul>0){
          totDocCRUD = movCliVP.length
        }
        totDocCRUD = movCliVP.length + 1
        argsCrud = []
        crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editMovClientes)
        }

        movCliVP.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

          numDocCRUD += 1
        })

        if(totAnul===0){
          //Actualizar saldo despues de actualizar movim => para calcular diasMora
          argsCrud[numDocCRUD] = actColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editCliente
        }

        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }
      // console.log(totAnul)
      // console.log(idListaP.valorTotal)
      if(totAnul<idListaP.valorTotal){
        // console.log("pendiente por anular: ", idListaP.valorTotal - totAnul)
        await this.props.allMovClientes.refetch()
        let listaMov = await this.props.allMovClientes.allMovClientes

        let totAnular = idListaP.valorTotal - totAnul
        let saldoCl = this.state.idLista.saldoPendiente + idListaP.valorTotal
        if(saldoCl<idListaP.valorTotal){
          totAnular = saldoCl - totAnul
        }

        let movCliVP = []
        // console.log(listaMov)
        // console.log(totAnular, saldoCl)
        listaMov.forEach((elemento, i) => {
          if(elemento.tipo==="C"&&elemento.documento!=="ANULADO"&&elemento.subTipo==="CF"&&
              elemento.valorPagado>0&&totAnular>0){
            // console.log(elemento)
            let valorAnul = 0
            if(elemento.valorPagado>=totAnular){
              valorAnul = totAnular
              totAnular = 0
            }else{
              valorAnul = elemento.valorPagado
              totAnular -= elemento.valorPagado
            }
            argsUpd = {}
            argsUpd = {
              "contrato": elemento.contrato,
              "_id": elemento._id,
              "procesado": elemento.procesado,
              "concepto": elemento.concepto,
              "numeroFra": elemento.numeroFra,
              "numeroRC": elemento.numeroRC,
              "numeroCE": elemento.numeroCE,
              "numeroOdeDX": elemento.numeroOdeDX,
              "documento": elemento.documento,
              "fechaUltPago": elemento.fechaUltPago,
              "valorUltPago": elemento.valorUltPago,
              "valorPagado": elemento.valorPagado - valorAnul,
              "valorPendiente": elemento.valorTotal + valorAnul,
            }
            movCliVP.push(argsUpd)
          }
        })
        // console.log(movCliVP)
        if(movCliVP.length>0){
          //Actualizar BD
          numDocCRUD = 0
          totDocCRUD = movCliVP.length + 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editMovClientes)
          }
  
          movCliVP.forEach((elemento1, ii) => {
            argsCrud[numDocCRUD] = elemento1
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    
            numDocCRUD += 1
          })

          //Actualizar saldo despues de actualizar movim => para calcular diasMora
          argsCrud[numDocCRUD] = actColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editCliente

          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }        
      }
    }
  }

  setTimeout(async () => {
    this.props.allClientes.refetch()
    console.log("setTimeout")
  }, 1000)

  this.estadosFalse()
  this.setState({showClient: true})
  this.setState({anuloPago: true})
}

  componentDidUpdate(prevProps, prevState){
    if(!this.state.argsBuscCliente.descrDpto){
      let descrDptoUA = sessionStorage.getItem('Dpto')
      if(descrDptoUA){
        if(descrDptoUA!=="Todos..."){
          let argsBuscCliente = this.state.argsBuscCliente
          argsBuscCliente.descrDpto = descrDptoUA
          // console.log(argsBuscCliente)
          this.setState({argsBuscCliente})
          this.props.allClientes.refetch(argsBuscCliente)
        }
      }
    }
    if(!this.state.argsBuscCliente.nombreCiudad){
      let nombreCiudadUA = sessionStorage.getItem('Ciudad')
      if(nombreCiudadUA){
        if(nombreCiudadUA!=="Todas..."){
          let argsBuscCliente = this.state.argsBuscCliente
          argsBuscCliente.nombreCiudad = nombreCiudadUA
          // console.log(argsBuscCliente)
          this.setState({argsBuscCliente})
          this.props.allClientes.refetch(argsBuscCliente)
        }
      }
    }
    if(this.state.argsBuscCliOS.contrato){
      let argsBuscarMC = this.state.argsBuscCliOS
      // console.log(argsBuscarMC)
      this.props.allMovClientes.refetch(argsBuscarMC)
      this.props.allMovClientesCC.refetch(argsBuscarMC)
      this.props.getPagoCliente.refetch(argsBuscarMC)
      this.props.allFacturacion1.refetch(argsBuscarMC)
      this.props.allCargoEsp1.refetch(argsBuscarMC)
      this.props.allNotasDebCre.refetch(argsBuscarMC)
      this.props.allAjuste.refetch(argsBuscarMC)
      this.props.allProgServ.refetch(argsBuscarMC)

      //PARA VER LOS CRITERIOS DADOS EN BUSCAR
      // console.log(this.state.argsBuscCliente)
      if(this.state.argsBuscCliente.numDocum){
        var numDocum = document.getElementById("numDocum");
        if(numDocum){numDocum.value = this.state.argsBuscCliente.numDocum}
      }
      // if(this.state.argsBuscCliente.contrato){
      //   var contrato = document.getElementById("contrato");
      //   if(contrato){contrato.value = this.state.argsBuscCliente.contrato}
      // }
      if(this.state.argsBuscCliente.nombreCliente){
        var nombreCliente = document.getElementById("bnombreCliente");
        if(nombreCliente){nombreCliente.value = this.state.argsBuscCliente.nombreCliente}
      }
      if(this.state.argsBuscCliente.apellidoCliente){
        var apellidoCliente = document.getElementById("bapellidoCliente");
        if(apellidoCliente){apellidoCliente.value = this.state.argsBuscCliente.apellidoCliente}
      }
      if(this.state.argsBuscCliente.descrClaseServ){
        var descrClaseServ = document.getElementById("bdescrClaseServ");
        if(descrClaseServ){descrClaseServ.value = this.state.argsBuscCliente.descrClaseServ}
      }
      if(this.state.argsBuscCliente.descrSubclaseServ){
        var descrSubclaseServ = document.getElementById("bdescrSubclaseServ");
        if(descrSubclaseServ){descrSubclaseServ.value = this.state.argsBuscCliente.descrSubclaseServ}
      }
    
      // if(this.state.argsBuscCliente.descrDpto){
      //   var descrDpto = document.getElementById("bdescrDpto");
      //   if(descrDpto){descrDpto.value = this.state.argsBuscCliente.descrDpto}
      // }
      let descrDptoUA = sessionStorage.getItem('Dpto')
      if(descrDptoUA){
        if(descrDptoUA==="Todos..."){
          if(this.state.argsBuscCliente.descrDpto){
            let descrDpto = document.getElementById("bdescrDpto");
            if(descrDpto){descrDpto.value = this.state.argsBuscCliente.descrDpto}
          }
        }else{
          let descrDpto = document.getElementById("bdescrDpto");
          if(descrDpto){
            descrDpto.value = descrDptoUA
          }
        }
      }

      let nombreCiudadUA = sessionStorage.getItem('Ciudad')
      if(nombreCiudadUA){
        if(nombreCiudadUA==="Todas..."){
          if(this.state.argsBuscCliente.nombreCiudad){
            let nombreCiudad = document.getElementById("bnombreCiudad");
            if(nombreCiudad){nombreCiudad.value = this.state.argsBuscCliente.nombreCiudad}
          }
        }else{
          let nombreCiudad = document.getElementById("bnombreCiudad");
          if(nombreCiudad){
            nombreCiudad.value = nombreCiudadUA
          }
        }
      }
      if(this.state.argsBuscCliente.nombreZona){
        let nombreZona = document.getElementById("bnombreZona");
        if(nombreZona){nombreZona.value = this.state.argsBuscCliente.nombreZona}
      }
      if(this.state.argsBuscCliente.nombreBarrio){
        let nombreBarrio = document.getElementById("bnombreBarrio");
        if(nombreBarrio){nombreBarrio.value = this.state.argsBuscCliente.nombreBarrio}
      }
    
      if(this.state.argsBuscCliente.descrTipoVia1){
        let descrTipoVia1 = document.getElementById("bdescrTipoVia1");
        if(descrTipoVia1){descrTipoVia1.value = this.state.argsBuscCliente.descrTipoVia1}
      }
      if(this.state.argsBuscCliente.numeroTipoVia1){
        let numeroTipoVia1 = document.getElementById("bnumeroTipoVia1");
        if(numeroTipoVia1){numeroTipoVia1.value = this.state.argsBuscCliente.numeroTipoVia1}
      }
      if(this.state.argsBuscCliente.descrTipoVia2){
        let descrTipoVia2 = document.getElementById("bdescrTipoVia2");
        if(descrTipoVia2){descrTipoVia2.value = this.state.argsBuscCliente.descrTipoVia2}
      }
      if(this.state.argsBuscCliente.numeroTipoVia2){
        let numeroTipoVia2 = document.getElementById("bnumeroTipoVia2");
        if(numeroTipoVia2){numeroTipoVia2.value = this.state.argsBuscCliente.numeroTipoVia2}
      }
      if(this.state.argsBuscCliente.numeroTipoVia2F){
        let numeroTipoVia2F = document.getElementById("bnumeroTipoVia2F");
        if(numeroTipoVia2F){numeroTipoVia2F.value = this.state.argsBuscCliente.numeroTipoVia2F}
      }
    
      if(this.state.argsBuscCliente.mac){
        let mac = document.getElementById("bmac");
        if(mac){mac.value = this.state.argsBuscCliente.mac}
      }
    
      if(this.state.argsBuscCliente.estadoCliente){
        let estadoCliente = document.getElementById("bestadoCliente");
        if(estadoCliente){estadoCliente.value = this.state.argsBuscCliente.estadoCliente}
      }
      if(this.state.argsBuscCliente.descrEstrato){
        let descrEstrato = document.getElementById("bdescrEstrato");
        if(descrEstrato){descrEstrato.value = this.state.argsBuscCliente.descrEstrato}
      }
      if(this.state.argsBuscCliente.telefono){
        let telefono = document.getElementById("btelefono");
        if(telefono){telefono.value = this.state.argsBuscCliente.telefono}
      }
      if(this.state.argsBuscCliente.numeroDoc){
        let numeroDoc = document.getElementById("bnumeroDoc");
        if(numeroDoc){numeroDoc.value = this.state.argsBuscCliente.numeroDoc}
      }
      if(this.state.argsBuscCliente.descrTipoCliente){
        let descrTipoCliente = document.getElementById("bdescrTipoCliente");
        if(descrTipoCliente){descrTipoCliente.value = this.state.argsBuscCliente.descrTipoCliente}
      }
      if(this.state.argsBuscCliente.descrGrupoAfin){
        let descrGrupoAfin = document.getElementById("bdescrGrupoAfin");
        if(descrGrupoAfin){descrGrupoAfin.value = this.state.argsBuscCliente.descrGrupoAfin}
      }
      //FIN PARA VER LOS CRITERIOS DADOS EN BUSCAR
    }
    if(this.props.allClientes.allClientes&&prevProps.allClientes.allClientes){
      if(this.props.allClientes.allClientes!==prevProps.allClientes.allClientes){
        this.props.allClientes.refetch()
      }
    }
    if(this.state.numeroRC!==prevState.numeroRC&this.state.stImprRC){
      this.props.allClientes.refetch()
      // console.log("33", this.state.stImprRC)
      this.setState({stImprRC: false})
    }
    if(this.state.numeroFra!==prevState.numeroFra&this.state.stImprFact){
      this.setState({stImprFact: false})
    }
  }

  render(){
    const {showClient, showTipocli, addTipocli, verTipocli, showGrupoaf, addGrupoaf, verGrupoaf,
          showTipodoc, addTipodoc, verTipodoc, showCicloFact, addCicloFact, verCicloFact,
          showOtrosPagCl, addOtrosPagCl, verOtrosPagCl, showOficina, addOficina, verOficina,
          showSegmento, addSegmento, verSegmento, showPaquete, addPaquete, verPaquete,
          showTipoAju, addTipoAju, verTipoAju,
          showUser, showDirecc, showConfig, showMigrar, showOdeS, opcionOdeS, showRecPago, stImprRC, stImprFact,
          numeroRC, listaR, listFact, listServTar, nombreUA, showRecPagoOtr, showRecPagoAdel,
          saldoCl, totRecibido, showFact, showProc, showRtes, addCliente, verCliente,
          permiteHistFinanc, permiteHistPago, permiteProgNvoServ, permiteHistFact, permiteHistCE, permiteHistNot,
          permiteHistAj, permiteNCPF, permiteNDF, permiteNCF, permiteNCA, permiteAjP, permiteAjN,
          permiteMNF,
          permiteUpdate, permiteUpdateDir, permiteDelete, argsAdd, errorAdd, argsBuscCliente,
          idLista} = this.state;

// console.log(sessionStorage.getItem('userLogin'))
// console.log(sessionStorage.getItem('token'))
// console.log(sessionStorage.getItem('Ciudad'))
// console.log(this.props.allProgServ.allProgServ)
// console.log(this.state.stImprRC)
    let autorizacUA = [], codigoCiudadUA="", nombreCiudadUA=sessionStorage.getItem('Ciudad'), numeroDocumUA=""
    let codigoDptoUA="", descrDptoUA=sessionStorage.getItem('Dpto')
    let descrOficina="Todas..."
    let descrTipoRec = "Todos..."
    if(sessionStorage.getItem('userLogin')==="foroptic@foroptic.com"){
      codigoCiudadUA = "Todas..."
      codigoDptoUA="Todos..."
      numeroDocumUA = "Todos..."
      if(this.props.allAutorizac.allAutorizac){
        // this.props.allAutorizac.allAutorizac.map
        autorizacUA = this.props.allAutorizac.allAutorizac.map(autorizac => autorizac.codigoAutorizac)
      }
      if(this.props.allUsuarios.allUsuarios){
        if(this.props.allPerfiles.allPerfiles){
          const usuActivo = this.props.allUsuarios.allUsuarios.filter(usuario => usuario.email===sessionStorage.getItem('userLogin'))
          if(usuActivo[0]){
            descrOficina = usuActivo[0].descrOficina
          }
        }
      }
    }else{
      if(this.props.allUsuarios.allUsuarios){
        if(this.props.allPerfiles.allPerfiles){
          const usuActivo = this.props.allUsuarios.allUsuarios.filter(usuario => usuario.email===sessionStorage.getItem('userLogin'))
          if(usuActivo[0]){
            codigoCiudadUA = usuActivo[0].codigoCiudad
            codigoDptoUA = usuActivo[0].codigoDpto
            numeroDocumUA = usuActivo[0].numeroDocum
            const perfilUA = this.props.allPerfiles.allPerfiles.filter(perfil => perfil._id===usuActivo[0].perfil._id)
            autorizacUA = perfilUA[0].autorizac.map((elemento, _id) => elemento.codigoAutorizac)
            descrOficina = usuActivo[0].descrOficina
            descrTipoRec = usuActivo[0].descrTipoRec
          }
        }
      }
    }
// console.log(codigoCiudadUA, nombreCiudadUA, codigoDptoUA, descrDptoUA, numeroDocumUA, sessionStorage.getItem('Dpto'))
    const a05 = autorizacUA.findIndex( autorizac => autorizac === "05" );
    const a10 = autorizacUA.findIndex( autorizac => autorizac === "10" );
    const a15 = autorizacUA.findIndex( autorizac => autorizac === "15" );
    const a20 = autorizacUA.findIndex( autorizac => autorizac === "20" );
    const a25 = autorizacUA.findIndex( autorizac => autorizac === "25" );
    const a01010105 = autorizacUA.findIndex( autorizac => autorizac === "01010105" );
    const a01015001 = autorizacUA.findIndex( autorizac => autorizac === "01015001" );
// console.log(a01015001)
    // console.log(this.props.getPagoCliente.getPagoCliente)
    // console.log(this.props.allMovClientes.allMovClientes)
    // console.log(this.state.argsBuscCliOS)
    // console.log(Object.values(this.state))
    // this.props.allClientes.variables = argsBuscCliente
    // const lista = this.props.allClientes.allClientes
    // console.log(this.props.allClientes.allClientes)
    let lista = []
    let lista1 = []
    let lista2 = []
    let lista3 = []
    let lista4 = []
    let lista4CC = []
    let lista5 = []
    let lista6 = []
    let lista7 = []
    let lista8 = []
    let lista8N = []
    let lista9 = []
    let lista12 = []
    let listaSeg = []
    let listaPaq = []
    let listaOPC = []
    let listaCF = []
    let listaPS = []

    let contrato = ""
    // let argsBuscarOS = {}
    let argsBuscMovCliente = {contrato: idLista.contrato}
    // console.log("1")
    if (this.state.showClient) {
      if(this.props.allClientes.allClientes){lista = this.props.allClientes.allClientes}
    }
    if (this.state.showTipocli) {
      if(this.props.allTiposCliente.allTiposCliente){lista = this.props.allTiposCliente.allTiposCliente}
    }
    if (this.state.showGrupoaf) {
      if(this.props.allGruposAfin.allGruposAfin){lista = this.props.allGruposAfin.allGruposAfin}
    }
    if (this.state.showTipodoc) {
      if(this.props.allTiposDoc.allTiposDoc){lista = this.props.allTiposDoc.allTiposDoc}
    }
    if (this.state.showCicloFact||this.state.showFact||this.state.showRtes||this.state.showProc) {
      if(this.props.allCicloFact.allCicloFact){listaCF = this.props.allCicloFact.allCicloFact}
    }

    if (this.state.showFact) {
      if(this.props.allRecurso.allRecurso){lista1 = this.props.allRecurso.allRecurso}
    }

    if (this.state.showOtrosPagCl) {
      if(this.props.allOtrosPagCl.allOtrosPagCl){lista = this.props.allOtrosPagCl.allOtrosPagCl}
    }
    if (this.state.addOtrosPagCl||this.state.verOtrosPagCl) {
      if(this.props.allImpto.allImpto){lista = this.props.allImpto.allImpto}
    }
    if (this.state.showOficina) {
      if(this.props.allOficina.allOficina){lista = this.props.allOficina.allOficina}
    }
    if (this.state.showSegmento) {
      if(this.props.allSegmento.allSegmento){lista = this.props.allSegmento.allSegmento}
    }
    if (this.state.showPaquete) {
      if(this.props.allPaquete.allPaquete){lista = this.props.allPaquete.allPaquete}
    }
    if (this.state.showTipoAju) {
      if(this.props.allTipoAju.allTipoAju){lista = this.props.allTipoAju.allTipoAju}
    }

    // if (this.state.showUser) {
    //   if(this.props.allUsuarios.allUsuarios){lista = this.props.allUsuarios.allUsuarios}
    // }
    if (this.state.addCliente || this.state.verCliente) {
      if(this.props.allTiposDoc.allTiposDoc){lista = this.props.allTiposDoc.allTiposDoc}
      if(this.props.allTiposCliente.allTiposCliente){lista1 = this.props.allTiposCliente.allTiposCliente}
      if(this.props.allGruposAfin.allGruposAfin){lista2 = this.props.allGruposAfin.allGruposAfin}
      if(this.props.allEstrato.allEstrato){lista3 = this.props.allEstrato.allEstrato}
      if(this.props.allSegmento.allSegmento){listaSeg = this.props.allSegmento.allSegmento}
      if(this.props.allPaquete.allPaquete){listaPaq = this.props.allPaquete.allPaquete}
      if(this.props.allCicloFact.allCicloFact){lista8 = this.props.allCicloFact.allCicloFact}
      if(this.props.allRecurso.allRecurso){
        lista12 = this.props.allRecurso.allRecurso
        lista12 = lista12.filter(elemento => elemento.tiporec.areaAprovech==='VENTAS')
      }
    }
    if (this.state.verCliente) {
      if (this.state.permiteNCPF){
        if(this.props.allOtrosPagCl.allOtrosPagCl){
          let claseServSig = "NoDefinida", claseServSig1 = ""
          if(this.state.idLista.tarifa.codigoTarifa){
            claseServSig = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
            this.state.idLista.tarifa.servicios.forEach((elemento, _id) => {
              claseServSig1 = elemento.subclaseserv.claseserv.descrClaseServ
              if(claseServSig1!==claseServSig){
                claseServSig = "NoDefinida"
              }
            })
          }
          if(this.props.allOtrosPagCl.allOtrosPagCl){
            if(claseServSig!=="NoDefinida"){
              lista4 = this.props.allOtrosPagCl.allOtrosPagCl.filter(elemento => elemento.descrClaseServ===claseServSig)
            }else{
              lista4 = this.props.allOtrosPagCl.allOtrosPagCl
            }
            // console.log(lista4)
          }
        }
      }else{
        // if (this.state.permiteMNF){
        //   if(this.props.allMesNoFra.allEliminarMesNoFra){
        //     lista4 = this.props.allMesNoFra.allMesNoFra.filter(elemento => elemento.procesado==="N")
        //   }
        // }else{
          if(this.props.allMovClientes.allMovClientes){lista4 = this.props.allMovClientes.allMovClientes}
          if(this.props.allProgServ.allProgServ){listaPS = this.props.allProgServ.allProgServ}
          // }
      }
      if(this.props.getPagoCliente.getPagoCliente){
        lista5 = this.props.getPagoCliente.getPagoCliente
      }
      if(this.props.allFacturacion1.allFacturacion){
        lista6 = this.props.allFacturacion1.allFacturacion
      }
      if(this.props.allCargoEsp1.allCargoEsp){
        lista7 = this.props.allCargoEsp1.allCargoEsp
      }
      if(this.props.allNotasDebCre.allNotasDebCre){
        lista8N = this.props.allNotasDebCre.allNotasDebCre
      }
      if(this.props.allAjuste.allAjuste){
        lista9 = this.props.allAjuste.allAjuste
      }
    }
    // console.log(lista4)

    if (this.state.showOdeS) {
      contrato = idLista.contrato
      if(this.props.allEstrato.allEstrato){
        lista3 = this.props.allEstrato.allEstrato
      }
      if(this.props.allMovClientes.allMovClientes){
        lista4 = this.props.allMovClientes.allMovClientes
      }
      if(this.props.allMovClientesCC.allMovClientesCC){
        lista4CC = this.props.allMovClientesCC.allMovClientesCC
      }
      if(this.props.allOtrosPagCl.allOtrosPagCl){
        listaOPC = this.props.allOtrosPagCl.allOtrosPagCl
      }
    }
     if (this.state.showRecPago) {
      if(this.props.allMovClientes.allMovClientes){
        lista4 = this.props.allMovClientes.allMovClientes
        lista4 = lista4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
      }
      if(this.props.allOficina.allOficina){
        lista = this.props.allOficina.allOficina
      }
     }
     if (this.state.showRecPagoOtr){
      if(this.props.allOtrosPagCl.allOtrosPagCl){
        let claseServSig = "NoDefinida", claseServSig1 = ""
        if(this.state.idLista.tarifa.codigoTarifa){
          claseServSig = this.state.idLista.tarifa.servicios[0].subclaseserv.claseserv.descrClaseServ
          this.state.idLista.tarifa.servicios.forEach((elemento, _id) => {
            claseServSig1 = elemento.subclaseserv.claseserv.descrClaseServ
            if(claseServSig1!==claseServSig){
              claseServSig = "NoDefinida"
            }
          })
        }
        if(this.props.allOtrosPagCl.allOtrosPagCl){
          if(claseServSig!=="NoDefinida"){
            lista4 = this.props.allOtrosPagCl.allOtrosPagCl.filter(elemento => elemento.descrClaseServ===claseServSig)
          }else{
            lista4 = this.props.allOtrosPagCl.allOtrosPagCl
          }
        }
      }
      if(this.props.allOficina.allOficina){
        lista = this.props.allOficina.allOficina
      }
    }
    if (this.state.showRecPagoAdel){
      if(this.props.allOficina.allOficina){
        lista = this.props.allOficina.allOficina
      }
    }
    if (this.state.showConfig){
      if(this.props.allCicloFact.allCicloFact){lista8 = this.props.allCicloFact.allCicloFact}
    }
    if (this.state.showProc){
      if(this.props.allEstrato.allEstrato){lista3 = this.props.allEstrato.allEstrato}
      if(this.props.allMovClientesCC.allMovClientesCC){
        lista4CC = this.props.allMovClientesCC.allMovClientesCC
      }
      if(this.props.allProcFact1.allProcFact){lista5 = this.props.allProcFact1.allProcFact}
      if(this.props.allOficina.allOficina){
        lista = this.props.allOficina.allOficina
      }
      if(this.props.allTiposCliente.allTiposCliente){lista4 = this.props.allTiposCliente.allTiposCliente}
    }
    if (this.state.showRtes){
      if(this.props.allOficina.allOficina){
        lista1 = this.props.allOficina.allOficina
      }
    }
    //  if (this.state.showRecPagoTer) {
    //   if(this.props.allRecurso.allRecurso){
    //     lista7 = this.props.allRecurso.allRecurso
    //     lista7 = lista7.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
    //   }
    // }

    //  let clienteSel = []
    //  if (this.state.showRecPagoTer) {
    //   lista4 = this.props.allMovClientes.allMovClientes
    //   lista4 = lista4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado&&
    //                           elemento.contrato==="1030")
    // console.log(clienteSel)
    // console.log(listaCF)
    //  }

    let contratoSequence = "NO"
    let mensaje = ""
    let ajCero = 0
    let prefijoFact = ""
    let comoAsigCicloFact = "Asignarlo al crear o modificar clientes"
    let comoAsigCargosAlCliente = "Hacer los cargos al cliente en el proceso de facturación"
    let empresa = {empresaRazonSocial: "", empresaNit: "", empresaDir: "", empresaTel: "",
                  pagueHastaSegunSaldo: false, numMesesParaPH: 3, impRboCaja: "Tamaño carta",
                  modeloFactura: "1", modeloFacturaPF: "1", modeloCodBarras: "2", prefijoServ: "",
                  numDiasAP: 30, valorparaPermRX: 0, IdentificadorOperador_CUN: "", mesesUltDXImpDC: 0},
                  codBarrasRdo = ""
    if(this.props.getParametro.getParametro){
    contratoSequence = this.props.getParametro.getParametro.contratoSequence
    mensaje = this.props.getParametro.getParametro.mensaje
    ajCero = this.props.getParametro.getParametro.ajCero
    prefijoFact = this.props.getParametro.getParametro.prefijoFact
    comoAsigCicloFact = this.props.getParametro.getParametro.comoAsigCicloFact
    comoAsigCargosAlCliente = this.props.getParametro.getParametro.comoAsigCargosAlCliente
    empresa.empresaRazonSocial = this.props.getParametro.getParametro.empresaRazonSocial
    empresa.empresaNit = this.props.getParametro.getParametro.empresaNit
    empresa.empresaDir = this.props.getParametro.getParametro.empresaDir
    empresa.empresaTel = this.props.getParametro.getParametro.empresaTel
    empresa.pagueHastaSegunSaldo = this.props.getParametro.getParametro.pagueHastaSegunSaldo
    empresa.numMesesParaPH = this.props.getParametro.getParametro.numMesesParaPH
    empresa.impRboCaja = this.props.getParametro.getParametro.impRboCaja
    empresa.modeloFactura = this.props.getParametro.getParametro.modeloFactura
    empresa.modeloFacturaPF = this.props.getParametro.getParametro.modeloFacturaPF
    empresa.modeloCodBarras = this.props.getParametro.getParametro.modeloCodBarras
    empresa.prefijoServ = this.props.getParametro.getParametro.prefijoServ
    empresa.empresaArchFE = this.props.getParametro.getParametro.empresaArchFE
    if(this.props.getParametro.getParametro.numDiasAP){
      empresa.numDiasAP = this.props.getParametro.getParametro.numDiasAP
    }
    if(this.props.getParametro.getParametro.valorparaPermRX){
      empresa.valorparaPermRX = this.props.getParametro.getParametro.valorparaPermRX
    }
    if(this.props.getParametro.getParametro.IdentificadorOperador_CUN){
      empresa.IdentificadorOperador_CUN = this.props.getParametro.getParametro.IdentificadorOperador_CUN
    }
    if(this.props.getParametro.getParametro.mesesUltDXImpDC){
      empresa.mesesUltDXImpDC = this.props.getParametro.getParametro.mesesUltDXImpDC
    }
    codBarrasRdo = this.props.getParametro.getParametro.codBarrasRdo
    }
    //  console.log(empresa)
// console.log(mensaje)
     //  console.log(this.props.allMovClientes.allMovClientes)
    //  console.log(this.props)
    // const {variables} = this.props.allClientes
    // console.log(variables)
    // console.log(argsBuscCliente)
    // console.log(lista)
    // if(lista){console.log(lista.length)};
    // console.log(this.props.allClientes)
    // console.log(this.props)
// console.log(this.props.allClientes)
// delete this.props.allClientes.variables.contrato
    // console.log(this.props)
    // console.log(idLista)

//     console.log(sessionStorage.getItem('userLogin'))
// console.log(sessionStorage.getItem('token'))
// console.log(errorAdd)
// console.log(argsAdd)
    let fechaPago = new Date()
    fechaPago = (fechaPago.getFullYear()) + '-' + ((fechaPago.getMonth()+1)<10?'0'+(fechaPago.getMonth()+1):(fechaPago.getMonth()+1)) + '-' + (fechaPago.getUTCDate()<10?'0'+fechaPago.getUTCDate():fechaPago.getUTCDate())

    let listRCCl = []
    // let imprRCCl = true
    listRCCl.push({listServTar, cliente: idLista, numeroRC, nombreUA, saldoCl, totRecibido, fechaPago: fechaPago})

    let procFact = []
    let listFactCl = []
    let imprFactCl = true
    listFactCl.push({listFact, clientesFra: idLista})
    // console.log(listFact)
    // console.log(stImprFact)
//   })
// }
// console.log(listRCCl)
// console.log(stImprRC, imprRCCl, a01015001)
// OJOOOO Error => Uncaught TypeError: Cannot read property 'nodeName' of null
// No sale si al hacer el pago en el
// this.setState({stImprRC: true, numeroRC, listServTar: listColecc, nombreUA, saldoCl: saldoClRC, totRecibido})
// se quita el estado stImprRC: true
// No sale error => this.setState({numeroRC, listServTar: listColecc, nombreUA, saldoCl: saldoClRC, totRecibido})
// tambien se corrige si se pone comentario a las siguientes lineas
// {(stImprRC&&imprRCCl&&a01015001!==-1) &&
//   <ImprRC listRCCl={listRCCl} empresa={empresa}/>
// }
// => ????????????????
return (
      <div>
        <div className="ui two column stackable grid">
          <div className="row rowBotones container" style={styles.bordes}>
            <div className="column" style={styles.menuPpal}>
              {/* <img src="images/foroptic.png" alt="Logo"/> */}
              {/* <svg width="50" height="50">
                <circle cx="25" cy="25" r="20" stroke="green" strokeWidth="4" fill="yellow" />
              </svg> */}
              <svg height="55" width="250">
                <text x="70" y="42" fill="#c1b82f"  style={{font: '50px Calibri', fontWeight: 'Bold', fontStyle: 'Italic'}}>foroptic</text>
              </svg>


{/* <img src="images/foroptic.png" className="ui image" alt="imagen"/> */}
              {/* <img className="ui small image" src="images/logocliente.png" alt="foto"/> */}


              {/* <span>foroptic</span> */}
            </div>
            
            <div className="column" style={styles.boxDer}>
              <div className="ui labeled inverted icon menu" style={styles.menu}>
                <a href="#top" onClick={this.showClient} className="item selected">
                  <i className="id card yellow icon"></i>
                  Clientes
                </a>
                {a05!==-1 &&
                <a href="#top" onClick={this.showFact} className="item">
                  <i className="edit yellow icon"></i>
                  Facturación
                </a>
                }
                {a10!==-1 &&
                <a href="#top" onClick={this.showProc} className="item">
                  <i className="id tasks yellow icon"></i>
                  Procesos
                </a>
                }
                {a15!==-1 &&
                <a href="#top" onClick={this.showRtes} className="item">
                  <i className="id clipboard outline yellow icon"></i>
                  Reportes
                </a>
                }
                {a20!==-1 &&
                <a href="#top" onClick={this.showUser} className="item">
                  <i className="users yellow icon"></i>
                  Usuarios
                </a>
                }
                {a25!==-1 &&
                <a href="#top" onClick={this.showConfig} className="item">
                  <i className="settings yellow icon"></i>
                  Configurar
                </a>
                }
                {/* <a href="http://159.65.45.92:3001" className="item"> */}
                {/* <a href="#top" onClick={this.showMigrar} className="item">
                  <i className="recycle yellow icon"></i>
                  Migración
                </a> */}

{/* <Button className="item" onClick={this.showConfig}>
<i className="settings yellow icon"></i>
Configurar
                      </Button> */}

                <a href="#top" onClick={this.logout} className="right item">
                  <i className="close yellow icon"></i>
                  Salir
                </a>
              </div>
            </div>
          </div>
          
          <div className="row" style={styles.rowMarquee}>
            {/* <marquee behavior="alternate" scrollamount="7" color="red">!! Mensaje !!</marquee> */}
            <div className="marquee">
              <div>
                {/* <span>!! El sacrificio de hoy es el éxito de mañana !!</span>
                <span>!! El sacrificio de hoy es el éxito de mañana !!</span> */}
                <span>{mensaje}</span>
                <span>{mensaje}</span>                
              </div>
            </div>
          </div>
          
          {(!showFact && !showProc && !showRtes && !showConfig && !showDirecc && !showOdeS && !showMigrar &&
            !showUser) &&
            <div className="column" style={styles.boxIzq}>
              {showClient && <HomeCli1 autorizacUA={autorizacUA} styles={styles}
                    handleChange={this.handleChangeBuscClient} handleSubmit={this.handleBuscCliente}
                    args={argsBuscCliente} nombreCiudadUA={nombreCiudadUA} descrDptoUA={descrDptoUA}
                    handleClickDir={this.showDirecc} handleClickTC={this.showTipocli}
                    handleClickGA={this.showGrupoaf} handleClickTD={this.showTipodoc}
                    handleClickCF={this.showCicloFact} handleClickOP={this.showOtrosPagCl}
                    handleClickOf={this.showOficina} handleClickSeg={this.showSegmento}
                    handleClickPaq={this.showPaquete}/>}
              {addCliente && <AddCli1 styles={styles} handleClickRegr={this.showClient}/>}
              {verCliente && <VerCli1 autorizacUA={autorizacUA} styles={styles} args={argsBuscMovCliente}
                    idLista={idLista} empresa={empresa}
                    handleClickRegr={this.showClient} handleClickView={this.handleClickView}
                    handleClickHistFinanc={this.handleClickHistFinanc}
                    handleClickHistPago={this.handleClickHistPago}
                    handleClickHistFact={this.handleClickHistFact}
                    handleClickHistCE={this.handleClickHistCE}
                    handleClickHistNot={this.handleClickHistNot}
                    handleClickHistAj={this.handleClickHistAj}
                    handlePyS={this.handlePyS}
                    handleImpContr={(ev)=>this.showOdeS(ev, "ImprContr")}
                    handleClickNCPF={this.handleClickNCPF}
                    handleClickProgNvoServ={this.handleClickProgNvoServ}
                    handleClickNDF={this.handleClickNDF} handleClickNCF={this.handleClickNCF}
                    handleClickNCA={this.handleClickNCA}
                    handleClickAjP={this.handleClickAjP} handleClickAjN={this.handleClickAjN}
                    handleClickMNF={this.handleClickMNF}
                    handleClickUpd={this.handleClickUpd} handleClickUpdDir={this.handleClickUpdDir}
                    handleClickDel={this.handleClickDel}
                    handleClickSel2={(ev)=>this.showOdeS(ev, "ModOdeS")}
                    handleClickRecPago={this.showRecPago}
                    handleClickRecPagoOtr={this.showRecPagoOtr}
                    handleClickRecPagoAdel={this.showRecPagoAdel}/>}

              {showTipocli && <HomeTicl1 styles={styles} handleClickRegr={this.showClient}/>}
              {addTipocli && <AddTicl1 styles={styles} handleClickRegr={this.showTipocli}/>}
              {verTipocli && <VerTicl1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showTipocli} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showGrupoaf && <HomeGraf1 styles={styles} handleClickRegr={this.showClient}/>}
              {addGrupoaf && <AddGraf1 styles={styles} handleClickRegr={this.showGrupoaf}/>}
              {verGrupoaf && <VerGraf1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showGrupoaf} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showTipodoc && <HomeTido1 styles={styles} handleClickRegr={this.showClient}/>}
              {addTipodoc && <AddTido1 styles={styles} handleClickRegr={this.showTipodoc}/>}
              {verTipodoc && <VerTido1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showTipodoc} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showCicloFact && <HomeCifa1 styles={styles} handleClickRegr={this.showClient}/>}
              {addCicloFact && <AddCifa1 styles={styles} handleClickRegr={this.showCicloFact}/>}
              {verCicloFact && <VerCifa1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showCicloFact} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showOtrosPagCl && <HomeOtpa1 styles={styles} handleClickRegr={this.showClient}/>}
              {addOtrosPagCl && <AddOtpa1 styles={styles} handleClickRegr={this.showOtrosPagCl}/>}
              {verOtrosPagCl && <VerOtpa1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showOtrosPagCl} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showOficina && <HomeOfic1 styles={styles} handleClickRegr={this.showClient}/>}
              {addOficina && <AddOfic1 styles={styles} handleClickRegr={this.showOficina}/>}
              {verOficina && <VerOfic1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showOficina} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showSegmento && <HomeSeg1 styles={styles} handleClickRegr={this.showClient}/>}
              {addSegmento && <AddSeg1 styles={styles} handleClickRegr={this.showSegmento}/>}
              {verSegmento && <VerSeg1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showSegmento} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showPaquete && <HomePaq1 styles={styles} handleClickRegr={this.showClient}/>}
              {addPaquete && <AddPaq1 styles={styles} handleClickRegr={this.showPaquete}/>}
              {verPaquete && <VerPaq1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showPaquete} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showTipoAju && <HomeTiaj1 styles={styles} handleClickRegr={this.showClient}/>}
              {addTipoAju && <AddTiaj1 styles={styles} handleClickRegr={this.showTipoAju}/>}
              {verTipoAju && <VerTiaj1 autorizacUA={autorizacUA} styles={styles} handleClickRegr={this.showTipoAju} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

              {showRecPago && <RecPago1 styles={styles} handleClickRegrRecPago={this.showClient}/>}
              {showRecPagoOtr && <RecPagoOtr1 styles={styles} handleClickRegrRecPago={this.showClient}/>}
              {showRecPagoAdel && <RecPagoAdel1 styles={styles} handleClickRegrRecPago={this.showClient}/>}
            </div>
          }
          {(!showFact && !showProc && !showRtes && !showConfig && !showDirecc && !showOdeS && !showMigrar &&
            !showUser) &&
            <div className="column" style={styles.boxDer}>
              {showClient && <HomeCli2 autorizacUA={autorizacUA} styles={styles} empresaArchFE={empresa.empresaArchFE}
                    handleClick={this.addCliente} list={lista} handleClickidLista={this.idLista}/>}
              {addCliente && <AddCli2 a01010105={a01010105} styles={styles} list={lista} list1={lista1} list2={lista2}
                    list3={lista3} listSeg={listaSeg} listPaq={listaPaq} list8={lista8} list12={lista12}
                    codigoCiudadUA={codigoCiudadUA}
                    codigoDptoUA={codigoDptoUA} modeloFactura={empresa.modeloFactura}
                    empresaArchFE={empresa.empresaArchFE}
                    handleSubmit={this.handleCliente} handleChange={this.handleChange}
                    args={argsAdd} errors={errorAdd}  handleListaTD={this.handleTipoDocCl}
                    handleListaTC={this.handleTipoClCl} handleListaGA={this.handleGrAfCl}
                    handleListaEstr={this.handleEstrCl} handleListaSeg={this.handleSeg}
                    handleListaCF={this.handleCicloFactCl}
                    handlelista5={this.handleTipoOSOS} handleLista1={this.handleTipoOSCateg}
                    handleLista4={this.handleListaGral}
                    handleListaInfAdic={this.handleListaInfAdic}
                    comoAsigCicloFact={comoAsigCicloFact} contratoSequence={contratoSequence}/>}
              {verCliente && <VerCli2 autorizacUA={autorizacUA} styles={styles} list={lista}
                    listaTC1={lista1} list2={lista2} list3={lista3} listSeg={listaSeg} listPaq={listaPaq}
                    list8={lista8} list4={lista4} list5={lista5} list6={lista6} list7={lista7}
                    list8N={lista8N} list9={lista9} listPS={listaPS} errors={errorAdd}
                    codigoDptoUA={codigoDptoUA} codigoCiudadUA={codigoCiudadUA}
                    modeloFactura={empresa.modeloFactura} empresaArchFE={empresa.empresaArchFE}
                    handleLista4={this.handleListaGral}
                    handleSubmitNot={this.handleSubmitNot} handleSubmitAju={this.handleSubmitAju}
                    handleSubmitNotAut={this.handleSubmitNotAut}
                    handleSubmitNvoCargoPF={this.handleSubmitNvoCargoPF}
                    handleSubmitProgServ={this.handleSubmitProgServ}
                    handleAnularPago={this.handleAnularPago}
                    handleConfDatos={this.handleConfDatos}
                    handleEnvCorreo={this.handleEnvCorreo}
                    handleSubmit={this.handleCliente} handleChange={this.handleChange}
                    args={argsAdd} idLista={idLista}
                    permiteHistFinanc={permiteHistFinanc} permiteHistPago={permiteHistPago}
                    permiteProgNvoServ={permiteProgNvoServ}
                    permiteHistFact={permiteHistFact} permiteHistCE={permiteHistCE}
                    permiteHistNot={permiteHistNot} permiteHistAj={permiteHistAj}
                    permiteNCPF={permiteNCPF}
                    permiteNDF={permiteNDF} permiteNCF={permiteNCF} permiteNCA={permiteNCA}
                    permiteAjP={permiteAjP} permiteAjN={permiteAjN} permiteMNF={permiteMNF}
                    permiteUpdate={permiteUpdate} permiteUpdateDir={permiteUpdateDir}
                    permiteDelete={permiteDelete}
                    handleClickAddServ={this.handleClickAddServ} comoAsigCicloFact={comoAsigCicloFact}
                    empresa={empresa} codBarrasRdo={codBarrasRdo}/>}

              {showTipocli && <HomeTicl2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addTipocli} list={lista} handleClickidLista={this.idLista}/>}
              {addTipocli && <AddTicl2 styles={styles} handleSubmit={this.handleTipocli} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verTipocli && <VerTicl2 styles={styles} handleSubmit={this.handleTipocli} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showGrupoaf && <HomeGraf2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addGrupoaf} list={lista} handleClickidLista={this.idLista}/>}
              {addGrupoaf && <AddGraf2 styles={styles} handleSubmit={this.handleGrupoaf} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verGrupoaf && <VerGraf2 styles={styles} handleSubmit={this.handleGrupoaf} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showTipodoc && <HomeTido2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addTipodoc} list={lista} handleClickidLista={this.idLista}/>}
              {addTipodoc && <AddTido2 styles={styles} handleSubmit={this.handleTipodoc} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verTipodoc && <VerTido2 styles={styles} handleSubmit={this.handleTipodoc} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showCicloFact && <HomeCifa2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addCicloFact} list={listaCF} handleClickidLista={this.idLista}/>}
              {addCicloFact && <AddCifa2 styles={styles} handleSubmit={this.handleCicloFact}
                  handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verCicloFact && <VerCifa2 styles={styles} handleSubmit={this.handleCicloFact}
                  args={argsAdd} errors={errorAdd} idLista={idLista}
                  permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showOtrosPagCl && <HomeOtpa2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addOtrosPagCl} list={lista} handleClickidLista={this.idLista}/>}
              {addOtrosPagCl && <AddOtpa2 styles={styles} handleSubmit={this.handleOtrosPagCl}
                  list={lista} handleLista={this.handleImptoOP} handleLista1={this.handleClaseOP}
                  handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verOtrosPagCl && <VerOtpa2 styles={styles} handleSubmit={this.handleOtrosPagCl}
                  list={lista}  args={argsAdd} errors={errorAdd} idLista={idLista}
                  permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showOficina && <HomeOfic2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addOficina} list={lista} handleClickidLista={this.idLista}/>}
              {addOficina && <AddOfic2 styles={styles} handleSubmit={this.handleOficina}
                  list={lista} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verOficina && <VerOfic2 styles={styles} handleSubmit={this.handleOficina}
                  list={lista}  args={argsAdd} errors={errorAdd} idLista={idLista}
                  permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showSegmento && <HomeSeg2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addSegmento} list={lista} handleClickidLista={this.idLista}/>}
              {addSegmento && <AddSeg2 styles={styles} handleSubmit={this.handleSegmento} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verSegmento && <VerSeg2 styles={styles} handleSubmit={this.handleSegmento} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showPaquete && <HomePaq2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addPaquete} list={lista} handleClickidLista={this.idLista}/>}
              {addPaquete && <AddPaq2 styles={styles} handleSubmit={this.handlePaquete} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verPaquete && <VerPaq2 styles={styles} handleSubmit={this.handlePaquete} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showTipoAju && <HomeTiaj2 autorizacUA={autorizacUA} styles={styles} handleClick={this.addTipoAju} list={lista} handleClickidLista={this.idLista}/>}
              {addTipoAju && <AddTiaj2 styles={styles} handleSubmit={this.handleTipoAju}
                  handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
              {verTipoAju && <VerTiaj2 styles={styles} handleSubmit={this.handleTipoAju}
                  args={argsAdd} errors={errorAdd} idLista={idLista}
                  permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

              {showRecPago && <RecPago2 autorizacUA={autorizacUA} styles={styles} handleSubmit={this.handleRecPago}
                  args={argsAdd} errors={errorAdd} list4={lista4} idLista={idLista}
                  prefijoFact={prefijoFact} descrOficina={descrOficina}
                  ajCero={ajCero} modeloFactura={empresa.modeloFactura} listaOf={lista}
                  empresaArchFE={empresa.empresaArchFE}/>}
              {/* {(stImprRC&&imprRCCl&&a01015001!==-1) && */}
              {(a01015001!==-1) &&
                <ImprRC listRCCl={listRCCl} empresa={empresa} stImprRC={stImprRC}/>
              }
              {showRecPagoOtr && <RecPagoOtr2 styles={styles} handleSubmit={this.handleRecPagoOtr} args={argsAdd}
                  errors={errorAdd} list4={lista4} idLista={idLista} listaOf={lista}
                  prefijoFact={prefijoFact} descrOficina={descrOficina} empresa={empresa}/>}
              {/* {(stImprFact&&imprFactCl&&showRecPagoOtr) && */}
              {(imprFactCl&&showRecPagoOtr) &&
                <ImprFact listFactCl={listFactCl} list2={procFact} list={listaR} empresa={empresa} stImprFact={stImprFact}/>
              }
              {showRecPagoAdel && <RecPagoAdel2 styles={styles} handleSubmit={this.handleRecPagoAd} args={argsAdd}
                  errors={errorAdd} idLista={idLista} listaOf={lista} prefijoFact={prefijoFact}
                  descrOficina={descrOficina} empresa={empresa}/>}
              {/* {(stImprFact&&imprFactCl&&showRecPagoAdel) && */}
              {(imprFactCl&&showRecPagoAdel) &&
                <ImprFact listFactCl={listFactCl} list2={procFact} list={listaR} empresa={empresa} stImprFact={stImprFact}/>
              }

            </div>
          }
          {showFact &&
            <div className="column" style={styles.boxUnaCol}>
              {showFact && <HomeFact autorizacUA={autorizacUA} styles={styles} prefijoFact={prefijoFact}
                            codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}
                            listaCF={listaCF} listaRec={lista1} empresa={empresa} codBarrasRdo={codBarrasRdo}/>}
            </div>
          }
          {showProc &&
            <div className="column" style={styles.boxUnaCol}>
              {showProc && <HomeProc autorizacUA={autorizacUA} codigoCiudadUA={codigoCiudadUA}
                            nombreCiudadUA={nombreCiudadUA} codigoDptoUA={codigoDptoUA} descrDptoUA={descrDptoUA}
                            numeroDocumUA={numeroDocumUA} styles={styles}
                            comoAsigCargosAlCliente={comoAsigCargosAlCliente} list3={lista3}
                            empresa={empresa} ajCero={ajCero} list4CC={lista4CC} list5={lista5}
                            descrOficina={descrOficina} descrTipoRec={descrTipoRec}
                            listaCF={listaCF} listaOf={lista} lista4={lista4}/>}
            </div>
          }
          {showRtes &&
            <div className="column" style={styles.boxUnaCol}>
              {showRtes && <HomeRtes autorizacUA={autorizacUA} codigoCiudadUA={codigoCiudadUA}
                            nombreCiudadUA={nombreCiudadUA} codigoDptoUA={codigoDptoUA} descrDptoUA={descrDptoUA}
                            numeroDocumUA={numeroDocumUA} styles={styles}
                            listaCF={listaCF} listaOf={lista1} empresa={empresa}/>}
            </div>
          }
          {showUser &&
            <div className="column" style={styles.boxUnaCol}>
              {showUser && <HomeUser autorizacUA={autorizacUA} styles={styles} empresa={empresa} mensaje={mensaje}
                codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>}
            </div>
          }
          {showConfig &&
            <div className="column" style={styles.boxUnaCol}>
              {showConfig && <HomeConf autorizacUA={autorizacUA} styles={styles} list8={lista8}
                            comoAsigCicloFact={comoAsigCicloFact}
                            codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>}
            </div>
          }
          {showMigrar &&
            <div className="column" style={styles.boxUnaCol}>
              {showMigrar && <HomeMigrar styles={styles}/>}
            </div>
          }
          {showDirecc &&
            <div className="column" style={styles.boxUnaCol}>
              {showDirecc && <HomeDir autorizacUA={autorizacUA} styles={styles}
                            codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>}
            </div>
          }
          {showOdeS &&
            <div className="column" style={styles.boxUnaCol}>
              {showOdeS && <HomeOdeS autorizacUA={autorizacUA} styles={styles} opcionOdeS={opcionOdeS}
                          list3={lista3} list4={lista4} list4CC={lista4CC} listOPC={listaOPC}
                          idLista={idLista} contrato={contrato} handleClickRegrOS={this.showClient}
                          comoAsigCicloFact={comoAsigCicloFact} comoAsigCargosAlCliente={comoAsigCargosAlCliente}
                          empresa={empresa} codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>}
            </div>
          }
          {/* {showRecPagoTer &&
            <div className="column" style={styles.boxUnaCol}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="column" style={styles.boxIzq}>
                  <RecPagoTer1 styles={styles} handleClickRegrRecPago={this.showClient}/>
                  </div>
                  <div className="column" style={styles.boxDer}>
                  <RecPagoTer2 styles={styles} list7={lista7} handleSubmit={this.handleRecPagoTer} handleChange={this.handleChange} args={argsAdd} errors={errorAdd}/>
                  </div>
                </div>
              </div>
            </div>
          } */}
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarClient}}}),
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 50}}}}),
  // Ej con props graphql(queries.query.allDetalleDX, {name:'allDetalleDX', options: (props) => {return {variables: {numeroOdeDX: props.idLista.numeroOdeDX, ...props.argsBuscar}}}}),

  graphql(queries.query.allClientes, {name:'allClientes1', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),

  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.query.allProcFact, {name:'allProcFact1', options: (props) => {return {variables: {}}}}),

  // graphql(queries.query.allCliTodos, {name:'allCliTodos'}),
  graphql(queries.mutation.createCliente, {name:'createCliente'}),

  // graphql(queries.query.allOdeS, {name:'allOdeS', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.editClienteUpdDoc, {name:'editClienteUpdDoc'}),
  graphql(queries.mutation.deleteClienteUpdDoc, {name:'deleteClienteUpdDoc'}),
  graphql(queries.mutation.deleteCliente, {name:'deleteCliente'}),

  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {orden: '-_id'}}}}),
  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),

  graphql(queries.query.allMovClientesCC, {name:'allMovClientesCC', options: (props) => {return {variables: {orden: '-_id'}}}}),
  graphql(queries.query.allProgServ, {name:'allProgServ', options: (props) => {return {variables: {contrato: "XYZ321", procesado: "N"}}}}),
  graphql(queries.mutation.createProgServ, {name:'createProgServ'}),
  graphql(queries.mutation.deleteProgServ, {name:'deleteProgServ'}),

  graphql(queries.query.getPagoCliente, {name:'getPagoCliente', options: (props) => {return {variables: {orden: '_id'}}}}),
  graphql(queries.mutation.createPagoClientes, {name:'createPagoClientes'}),
  graphql(queries.mutation.editPagoClientesUpdDoc, {name:'editPagoClientesUpdDoc'}),
  graphql(queries.mutation.editPagoClientes, {name:'editPagoClientes'}),
  graphql(queries.mutation.editFacturacion, {name:'editFacturacion'}),

  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.editMovClientesMany, {name:'editMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),

  graphql(queries.query.allFacturacion, {name:'allFacturacion1', options: (props) => {return {variables: {orden: 'numeroFra'}}}}),
  graphql(queries.query.allCargoEsp, {name:'allCargoEsp1', options: (props) => {return {variables: {orden: 'numeroCE'}}}}),
  graphql(queries.query.allNotasDebCre, {name:'allNotasDebCre', options: (props) => {return {variables: {orden: 'numeroNota'}}}}),
  graphql(queries.query.allAjuste, {name:'allAjuste', options: (props) => {return {variables: {orden: '-_id'}}}}),

  graphql(queries.query.allEstrato, {name:'allEstrato'}),

  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  // graphql(queries.mutation.createUsuario, {name:'createUsuario'}),
  // graphql(queries.mutation.deleteUsuario, {name:'deleteUsuario'}),

  graphql(queries.query.allPerfiles, {name:'allPerfiles', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createPerfil, {name:'createPerfil'}),
  graphql(queries.query.allAutorizac, {name:'allAutorizac', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allTiposCliente, {name:'allTiposCliente'}),
  graphql(queries.mutation.createTipoCliente, {name:'createTipoCliente'}),
  graphql(queries.mutation.editTipoCliente, {name:'editTipoCliente'}),
  graphql(queries.mutation.deleteTipoCliente, {name:'deleteTipoCliente'}),

  graphql(queries.query.allGruposAfin, {name:'allGruposAfin'}),
  graphql(queries.mutation.createGrupoAfin, {name:'createGrupoAfin'}),
  graphql(queries.mutation.editGrupoAfin, {name:'editGrupoAfin'}),
  graphql(queries.mutation.deleteGrupoAfin, {name:'deleteGrupoAfin'}),

  graphql(queries.query.allTiposDoc, {name:'allTiposDoc'}),
  graphql(queries.mutation.createTipoDoc, {name:'createTipoDoc'}),
  graphql(queries.mutation.editTipoDoc, {name:'editTipoDoc'}),
  graphql(queries.mutation.deleteTipoDoc, {name:'deleteTipoDoc'}),

  graphql(queries.query.allCicloFact, {name:'allCicloFact'}),
  graphql(queries.mutation.createCicloFact, {name:'createCicloFact'}),
  graphql(queries.mutation.editCicloFact, {name:'editCicloFact'}),
  graphql(queries.mutation.deleteCicloFact, {name:'deleteCicloFact'}),

  graphql(queries.mutation.updDocumMany, {name:'updDocumMany'}),

  graphql(queries.query.allOtrosPagCl, {name:'allOtrosPagCl'}),
  graphql(queries.mutation.createOtrosPagCl, {name:'createOtrosPagCl'}),
  graphql(queries.mutation.editOtrosPagCl, {name:'editOtrosPagCl'}),
  graphql(queries.mutation.deleteOtrosPagCl, {name:'deleteOtrosPagCl'}),

  graphql(queries.query.allOficina, {name:'allOficina'}),
  graphql(queries.mutation.createOficina, {name:'createOficina'}),
  graphql(queries.mutation.editOficina, {name:'editOficina'}),
  graphql(queries.mutation.deleteOficina, {name:'deleteOficina'}),

  graphql(queries.query.allSegmento, {name:'allSegmento'}),
  graphql(queries.mutation.createSegmento, {name:'createSegmento'}),
  graphql(queries.mutation.editSegmento, {name:'editSegmento'}),
  graphql(queries.mutation.deleteSegmento, {name:'deleteSegmento'}),

  graphql(queries.query.allPaquete, {name:'allPaquete'}),
  graphql(queries.mutation.createPaquete, {name:'createPaquete'}),
  graphql(queries.mutation.editPaquete, {name:'editPaquete'}),
  graphql(queries.mutation.deletePaquete, {name:'deletePaquete'}),

  graphql(queries.query.allTipoAju, {name:'allTipoAju'}),
  graphql(queries.mutation.createTipoAju, {name:'createTipoAju'}),
  graphql(queries.mutation.editTipoAju, {name:'editTipoAju'}),
  graphql(queries.mutation.deleteTipoAju, {name:'deleteTipoAju'}),

  graphql(queries.query.allImpto, {name:'allImpto'}),

  graphql(queries.mutation.createAjuste, {name:'createAjuste'}),
  graphql(queries.mutation.createNotasDebCre, {name:'createNotasDebCre'}),
  graphql(queries.mutation.editNotasDebCreUpdDoc, {name:'editNotasDebCreUpdDoc'}),

  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.editSeqFrafindOneAndUpdate, {name:'editSeqFrafindOneAndUpdate'}),

  graphql(queries.mutation.createFacturacionMany, {name:'createFacturacionMany'}),

  graphql(queries.mutation.createOdeS, {name:'createOdeS'}),
  graphql(queries.mutation.editOdeSUpdDoc, {name:'editOdeSUpdDoc'}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allFactRtesGroup, {name:'allFactRtesGroup', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: '123XYZ'}}]`}}}}),

  // graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allMigrarBarrio, {name:'allMigrarBarrio'}),
  // graphql(queries.mutation.editDptoUpdCiu, {name:'editDptoUpdCiu'}),
  // graphql(queries.query.allMigrarServicio, {name:'allMigrarServicio'}),
  // graphql(queries.query.allSubclasesServ, {name:'allSubclasesServ', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allMigrarTarifa, {name:'allMigrarTarifa'}),
  // graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  // graphql(queries.mutation.editTarifaUpdServ, {name:'editTarifaUpdServ'}),
  // graphql(queries.query.allMigrarCliente, {name:'allMigrarCliente'}),
  // graphql(queries.query.allMigrarDireccion, {name:'allMigrarDireccion'}),
  // graphql(queries.query.allMigrarDirmayor, {name:'allMigrarDirmayor'}),
  // graphql(queries.query.allMigrarTarifaCli, {name:'allMigrarTarifaCli'}),
  // graphql(queries.query.allClientes, {name:'allClientes1', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.enviarCorreoFact, {name:'enviarCorreoFact'}),

  graphql(queries.mutation.encriptar, {name:'encriptar'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(Home)

// export default graphql(queries.mutation.createUsuario)(Home)
